'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ==============================
//  THEME SCRIPTS
//  Main file for javascript consolidation. Do not write any javascript in this
//  file! Only include other modules as required.
//  Author: Diff - Foxpod
//  Please review practices documentation before contributing.
// ==============================

// ------------------------------
// MODULES
// ------------------------------
// Polyfills will add in functionality for browsers that do not
// support newer features


// IE11 Array.includes polyfill

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
		value: function value(searchElement, fromIndex) {
			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			// 1. Let O be ? ToObject(this value).
			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If len is 0, return false.
			if (len === 0) {
				return false;
			}

			// 4. Let n be ? ToInteger(fromIndex).
			//    (If fromIndex is undefined, this step produces the value 0.)
			var n = fromIndex | 0;

			// 5. If n ≥ 0, then
			//  a. Let k be n.
			// 6. Else n < 0,
			//  a. Let k be len + n.
			//  b. If k < 0, let k be 0.
			var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

			function sameValueZero(x, y) {
				return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
			}

			// 7. Repeat, while k < len
			while (k < len) {
				// a. Let elementK be the result of ? Get(O, ! ToString(k)).
				// b. If SameValueZero(searchElement, elementK) is true, return true.
				if (sameValueZero(o[k], searchElement)) {
					return true;
				}
				// c. Increase k by 1.
				k++;
			}

			// 8. Return false
			return false;
		}
	});
}

// Object.values IE11 polyfill
Object.values = Object.values || function (x) {
	return Object.keys(x).map(function (k) {
		return x[k];
	});
};
/**
 * UTILITIES LIBRARY
 *
 * @description General global JavaScript utility functions.
 * @namespace utils
 */

(function (theme) {

	/**
  * Class of general JavaScript utilities.
  */
	var Utilities = function () {
		function Utilities() {
			_classCallCheck(this, Utilities);

			// Initialize functions extending objects
			this._handleize();

			// Keep track of all unique numbers generated
			this._rendered_numbers = [];
		}

		/**
   * Initializes the handleize function on the String object.
   * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
   *
   * @private
   * @memberof Utilities
   */


		_createClass(Utilities, [{
			key: '_handleize',
			value: function _handleize() {
				// UTF to ASCII map. Removes accents.
				var defaultDiacriticsRemovalap = [{ 'base': 'A', 'letters': 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' }, { 'base': 'AA', 'letters': '\uA732' }, { 'base': 'AE', 'letters': '\xC6\u01FC\u01E2' }, { 'base': 'AO', 'letters': '\uA734' }, { 'base': 'AU', 'letters': '\uA736' }, { 'base': 'AV', 'letters': '\uA738\uA73A' }, { 'base': 'AY', 'letters': '\uA73C' }, { 'base': 'B', 'letters': 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' }, { 'base': 'C', 'letters': 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E' }, { 'base': 'D', 'letters': 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779' }, { 'base': 'DZ', 'letters': '\u01F1\u01C4' }, { 'base': 'Dz', 'letters': '\u01F2\u01C5' }, { 'base': 'E', 'letters': 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' }, { 'base': 'F', 'letters': 'F\u24BB\uFF26\u1E1E\u0191\uA77B' }, { 'base': 'G', 'letters': 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' }, { 'base': 'H', 'letters': 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' }, { 'base': 'I', 'letters': 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' }, { 'base': 'J', 'letters': 'J\u24BF\uFF2A\u0134\u0248' }, { 'base': 'K', 'letters': 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' }, { 'base': 'L', 'letters': 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' }, { 'base': 'LJ', 'letters': '\u01C7' }, { 'base': 'Lj', 'letters': '\u01C8' }, { 'base': 'M', 'letters': 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' }, { 'base': 'N', 'letters': 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' }, { 'base': 'NJ', 'letters': '\u01CA' }, { 'base': 'Nj', 'letters': '\u01CB' }, { 'base': 'O', 'letters': 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C' }, { 'base': 'OI', 'letters': '\u01A2' }, { 'base': 'OO', 'letters': '\uA74E' }, { 'base': 'OU', 'letters': '\u0222' }, { 'base': 'OE', 'letters': '\x8C\u0152' }, { 'base': 'oe', 'letters': '\x9C\u0153' }, { 'base': 'P', 'letters': 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' }, { 'base': 'Q', 'letters': 'Q\u24C6\uFF31\uA756\uA758\u024A' }, { 'base': 'R', 'letters': 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' }, { 'base': 'S', 'letters': 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' }, { 'base': 'T', 'letters': 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' }, { 'base': 'TZ', 'letters': '\uA728' }, { 'base': 'U', 'letters': 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' }, { 'base': 'V', 'letters': 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' }, { 'base': 'VY', 'letters': '\uA760' }, { 'base': 'W', 'letters': 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' }, { 'base': 'X', 'letters': 'X\u24CD\uFF38\u1E8A\u1E8C' }, { 'base': 'Y', 'letters': 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' }, { 'base': 'Z', 'letters': 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' }, { 'base': 'a', 'letters': 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' }, { 'base': 'aa', 'letters': '\uA733' }, { 'base': 'ae', 'letters': '\xE6\u01FD\u01E3' }, { 'base': 'ao', 'letters': '\uA735' }, { 'base': 'au', 'letters': '\uA737' }, { 'base': 'av', 'letters': '\uA739\uA73B' }, { 'base': 'ay', 'letters': '\uA73D' }, { 'base': 'b', 'letters': 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' }, { 'base': 'c', 'letters': 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184' }, { 'base': 'd', 'letters': 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' }, { 'base': 'dz', 'letters': '\u01F3\u01C6' }, { 'base': 'e', 'letters': 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' }, { 'base': 'f', 'letters': 'f\u24D5\uFF46\u1E1F\u0192\uA77C' }, { 'base': 'g', 'letters': 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' }, { 'base': 'h', 'letters': 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' }, { 'base': 'hv', 'letters': '\u0195' }, { 'base': 'i', 'letters': 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' }, { 'base': 'j', 'letters': 'j\u24D9\uFF4A\u0135\u01F0\u0249' }, { 'base': 'k', 'letters': 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' }, { 'base': 'l', 'letters': 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' }, { 'base': 'lj', 'letters': '\u01C9' }, { 'base': 'm', 'letters': 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' }, { 'base': 'n', 'letters': 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' }, { 'base': 'nj', 'letters': '\u01CC' }, { 'base': 'o', 'letters': 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275' }, { 'base': 'oi', 'letters': '\u01A3' }, { 'base': 'ou', 'letters': '\u0223' }, { 'base': 'oo', 'letters': '\uA74F' }, { 'base': 'p', 'letters': 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' }, { 'base': 'q', 'letters': 'q\u24E0\uFF51\u024B\uA757\uA759' }, { 'base': 'r', 'letters': 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' }, { 'base': 's', 'letters': 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' }, { 'base': 't', 'letters': 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' }, { 'base': 'tz', 'letters': '\uA729' }, { 'base': 'u', 'letters': 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' }, { 'base': 'v', 'letters': 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' }, { 'base': 'vy', 'letters': '\uA761' }, { 'base': 'w', 'letters': 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' }, { 'base': 'x', 'letters': 'x\u24E7\uFF58\u1E8B\u1E8D' }, { 'base': 'y', 'letters': 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' }, { 'base': 'z', 'letters': 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }];

				// Generate the diacritics map to replace accented characters.
				var diacriticsMap = {};
				for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
					var letters = defaultDiacriticsRemovalap[i].letters.split("");

					for (var j = 0; j < letters.length; j++) {
						diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
					}
				}

				/**
     * Replaces accented characters with their non-accented counterparts.<br>
     * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
     *
     * @param {boolean} [remove=false] - Whether to remove unicode characters that are not mapped to a non-accented characters.
     * 	This includes all non-ascii characters.
     * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
     * @returns {string} String without accents.
     * @memberof Utilities
     * @example
     * // returns 'My accented string$.'
     * 'My áccentéd string$.'.noAccents();
     */
				String.prototype.noAccents = function (remove, replacement) {
					// x00-x7E is the ASCII character range
					var withoutAccents = this.replace(/[^\u0000-\u007E]/g, function (ch) {
						return diacriticsMap[ch] || ch;
					});

					replacement = replacement || '';

					if (remove) {
						withoutAccents = withoutAccents.replace(/[^\u0000-\u007E]/g, replacement);
					}

					return withoutAccents;
				};

				/**
     * Returns a "handleized" version of a string suitable for URLs and file names.<br>
     * Based on {@link https://github.com/nicbou/stringops stringops} by Nicolas Bouliane.
     *
     * @param {string} [seperator=-] - The character to use as a separator.
     * @param {string} [replacement=Empty string] - The replacement character(s) to use for invalid characters.
     * @returns {string} The handleized string.
     * @memberof Utilities
     * @example
     * var myString = 'My áccentéd string$.';
     *
     * // returns 'my-accented-string'
     * myString.handleize();
     *
     * // returns 'my_accented_string##'
     * myString.handleize('_', '#');
     */
				String.prototype.handleize = function (separator, replacement) {
					var slug;
					separator = separator || '-';
					replacement = replacement || '';
					slug = this.noAccents(true, replacement).trim().replace(/[^a-z0-9\s-]/ig, replacement).replace(/\s/ig, separator);

					return slug.toLowerCase();
				};
			}

			/**
    * Curency formating function.
    *
    * @param {(number|string)} price - The price to format.
    * @param {object} options - The options for the currency formatter.
    * @param {boolean} [options.cents=false] - Wether or not the price is currently in cents.
    * @param {string} [options.locale=Shop locale or 'en-CA'] - Override the locale to format to.
    * @param {string} [options.currency=Shop currency or 'CAD'] - Override the currency to output.
    * @param {boolean} [options.no_zeros=false] - To output the price without decimal zeros.
    * @returns {(string|null)} The price formatted based on the locale and currency.
    * @memberof Utilities
    * @example
    * // Returns '$12.56'
    * theme.utils.toMoney(12.56)
    *
    * // Returns '12,56 $'
    * theme.utils.toMoney('12.56', { locale: 'fr-CA', currency: 'CAD' })
    *
    * // Returns '$12.56'
    * theme.utils.toMoney('1256', { cents: true })
    */

		}, {
			key: 'toMoney',
			value: function toMoney(price) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

				if (!price && price !== 0) {
					console.error('Utilities.toMoney: Invalid price passed.', price);
					return null;
				}

				var price = new Number(price);
				var currency_options = {
					style: 'currency'

					// Assign defaults if no options are passed.
				};options.cents = options.cents || false;
				options.locale = options.locale || (theme.shop ? theme.shop.locale : null) || 'en-CA';
				currency_options.currency = options.currency || (theme.shop ? theme.shop.currency : null) || 'CAD';

				// Convert to dollars if the amount passed is in cents
				if (options.cents) {
					price = price / 100;
				}
				// Check if the number wants to remove its decimals
				if (options.no_decimals) {
					currency_options.minimumFractionDigits = 0;
					currency_options.maximumFractionDigits = 0;
				}

				return price.toLocaleString(options.locale, currency_options);
			}
		}, {
			key: 'removeProtocol',


			/**
    * Removes the URL protocol.
    *
    * @param {string} path - The URL to strip out the protocol from.
    * @returns {(string|null)} The URL without protocol.
    * @memberof Utilities
    */
			value: function removeProtocol(path) {
				if (!path) {
					console.error('Utilities.removeProtocol: Invalid path passed.', path);
					return null;
				}

				return path.replace(/http(s)?:/, '');
			}

			/**
    * Adds a Shopify size attribute to an image URL.
    *
    * @param {string} src - The image source URL.
    * @param {string} size - The size parameters to fetch, following Shopify's img_url guidelines.
    * @returns {(string|null)} The updated URL.
    * @memberof Utilities
    * @example
    * theme.utils.getSizedImageUrl('cdn.shopify.com/some-image.jpg', '500x300_crop_center');
    */

		}, {
			key: 'getSizedImageUrl',
			value: function getSizedImageUrl(src, size) {
				if (!size) {
					console.error('Utilities.getSizedImageUrl: Invalid size passed.', size);
					return src;
				}

				if (size === 'master') {
					return this.removeProtocol(src);
				}

				var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

				if (match) {
					var prefix = src.split(match[0]);
					var suffix = match[0];

					return this.removeProtocol(prefix[0] + '_' + size + suffix);
				} else {
					console.error('Utilities.getSizedImageUrl: Invalid image URL passed.', src);
					return null;
				}
			}

			/**
    * Created an object from a parameter string.
    *
    * @param {string} object_string - The string to parse to an object.
    * @returns {object} The object created from the string.
    * @memberof Utilities
    * @example
    * // If called on a form that takes a name and email, could return { name: "Joe", email: "joe@diffagency.com" }
    * theme.utils.toObject($form.serialize());
    */

		}, {
			key: 'toObject',
			value: function toObject(object_string) {
				var parameters = {};
				var elements;

				if (!object_string) {
					return {};
				}

				// Decode the query string to get original characters
				object_string = decodeURIComponent(object_string);

				// Split into each element
				elements = object_string.split('&');

				elements.forEach(function (element) {
					var element = element.split('=');
					parameters[element[0]] = element[1] || null;
				});

				return parameters;
			}

			/**
    * Extracts the URL parameters into an object.
    *
    * @param {string} [url=window.location.href] - The URL to parse.
    * @returns {object} The query parameters object.
    * @memberof Utilities
    * @example
    * // Returns { name: "Joe", email: "joe@diffagency.com" }
    * theme.utils.getURLParams('https://example.com/?name%3DJoe%26email%3Djoe%40diffagency.com');
    */

		}, {
			key: 'getURLParams',
			value: function getURLParams(url) {
				var url = url || window.location.href;
				// Get the string after the '?' from the URL
				var query_string = url.split(/\?([^\#]+)/)[1];

				if (!query_string) {
					return {};
				}

				return this.toObject(query_string);
			}

			/**
    * Sets URL parameters.
    *
    * @param {object} [params] - The parameters to add to the URL.
    * @param {object} [options] - Method options.
    * @param {boolean} [options.clear=false] - Clear previous parameters.
    * @param {boolean} [options.no_overwrite=false] - Don't overwrite parameters with same key.
    * @param {boolean} [options.push_state=false] - Push a window history state. Defaults to replace state.
    * @memberof Utilities
    * @example
    * // Examples with a current URL of 'example.com/?page=2'
    *
    * // Will set url to 'example.com/?page=3&view=grid'
    * theme.utils.setURLParams({ page: 3, view: 'grid' });
    *
    * // Will set url to 'example.com/?page=2'
    * theme.utils.setURLParams({ page: 3 }, { no_overwrite: true });
    *
    * // Will clear parameters: 'example.com/'
    * theme.utils.setURLParams({}, { clear: true });
    *
    * // Will replace parameters: 'example.com/?view=grid'
    * theme.utils.setURLParams({ view: 'grid' }, { clear: true });
    */

		}, {
			key: 'setURLParams',
			value: function setURLParams(params) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

				var current_params = this.getURLParams();
				var new_params = options.clear ? {} : current_params;
				var query_array = [];
				var query_string = '';

				// Add new parameters
				Object.keys(params).forEach(function (key) {
					var param_value = params[key];
					new_params[key] = options.no_overwrite ? new_params[key] || param_value : param_value;
				});

				// Convert object to URL string
				Object.keys(new_params).forEach(function (key) {
					query_array.push(encodeURIComponent(key) + '=' + encodeURIComponent(new_params[key]));
				});

				if (query_array.length) {
					query_string = '?' + query_array.join('&');
				}

				if (options.push_state) {
					window.history.pushState({}, null, query_string);
				} else {
					window.history.replaceState({}, null, query_string);
				}
			}

			/**
    * Returns a modified version of the passed object based on the passed parameters.
    *
    * @param {object} object - The object to modify.
    * @param {object} parameters - The parameters to update.
    * @param {object} [options] - Function options.
    * @param {boolean} [options.no_overwrite=false] - Option to not overwrite existing parameters
    * @param {boolean} [options.clear=false] - To empty the object before updating it.
    * @memberof Utilities
    * @example
    * // Returns { name: 'Joe', age: 18, height: 2 }
    * theme.utils.modifyObject(
    * 	{ name: 'Joe', age: 17 },
    * 	{ age: 18, height: 2 }
    * );
    *
    * // Returns { name: 'Joe', age: 17, height: 2 }
    * theme.utils.modifyObject(
    * 	{ name: 'Joe', age: 17 },
    * 	{ age: 18, height: 2 },
    * 	{ no_overwrite: true }
    * );
    *
    * // Returns { age: 18, height: 2 }
    * theme.utils.modifyObject(
    * 	{ name: 'Joe', age: 17 },
    * 	{ age: 18, height: 2 },
    * 	{ clear: true }
    * );
    */

		}, {
			key: 'modifyObject',
			value: function modifyObject(object, parameters, options) {
				options = options || {};
				var new_object = options.clear ? {} : object || {};

				if (!object || !parameters || (typeof parameters === 'undefined' ? 'undefined' : _typeof(parameters)) !== 'object') {
					return new_object || {};
				}

				Object.keys(parameters).forEach(function (key) {
					new_object[key] = options.no_overwrite ? new_object[key] || parameters[key] : parameters[key];
				});

				return new_object;
			}

			/**
    * Generates a unique number.
    *
    * @param {number} [length=6] - The length of the unique number
    * @returns Unique number.
    * @memberof Utilities
    * @example
    *
    * // Could generate 66145
    * theme.utils.uniqueNumber(5);
    */

		}, {
			key: 'uniqueNumber',
			value: function uniqueNumber(length) {
				var length = length || 6;
				var id = Math.floor(Math.random() * Math.pow(10, length));

				while (this._rendered_numbers.indexOf(id) !== -1) {
					id = Math.floor(Math.random() * Math.pow(10, length));
				}

				// Keep track of the generated number so that it is never generated again.
				this._rendered_numbers.push(id);

				return id;
			}

			// Check if element exists

		}, {
			key: 'exists',
			value: function exists(element) {
				if (!element) {
					return false;
				} else if ((typeof element === 'undefined' ? 'undefined' : _typeof(element)) == 'object') {
					return element.length != 0;
				} else if (typeof element == 'string') {
					return $(element).length != 0;
				}
			}

			/**
    * Returns an array with the duplicated values removed.
    *
    * @param {array} array - Array to process
    * @returns {array} The array with unique entries
    * @memberof Utilities
    * @example
    * let myArray = [1, 'a', 'B', 'B', 'c', 'C', '1'];
    *
    * // returns [1, 'a', 'B', 'c', 'C', '1']
    * myArray = theme.utils.toUnique(myArray);
    */

		}, {
			key: 'toUnique',
			value: function toUnique(array) {
				return [].concat(_toConsumableArray(new Set(array)));
			}

			// Expand or collapse content, if expanded return true and if collapsed return false

		}, {
			key: 'toggleContent',
			value: function toggleContent(content) {
				if (!content) {
					return;
				}
				var $content = $(content);
				if ($content.is(':visible')) {
					$content.removeClass('expanded');
					$content.slideUp(function () {
						$content.addClass('collapsed');
					});
					return false;
				} else {
					$content.addClass('expanded');
					$content.slideDown(function () {
						$content.removeClass('collapsed');
					});
					return true;
				}
			}
		}]);

		return Utilities;
	}();

	// Global export


	theme.utils = new Utilities();
})(window.theme = window.theme || {});
/**
 * CART LIBRARY
 *
 * @description Handles the Shopify cart interactions.
 * @namespace cart
 */

(function (theme, $) {

	/**
  * Class representing the cart.
  */
	var Cart = function () {

		/**
   * Creates an instance of Cart.
   *
   * @param {object} [cart] - A cart object to use. Passing this argument will avoid an AJAX call to the Shopify API.
   * @constructs Cart
   * @memberof Cart
   */
		function Cart(cart) {
			_classCallCheck(this, Cart);

			this.content = cart || {};
			this._queue = $.when();

			// If no cart is passed, fetch it.
			if (!cart) {
				this.fetch();
			}
		}

		// ------------------------------
		//  Getters and Setters
		// ------------------------------

		/**
   * The cart object.<br><br>
   * @example
   * // Get the cart object
   * theme.cart.content
   *
   * @type {object}
   * @fires cart_set
   * @memberof Cart
   */


		_createClass(Cart, [{
			key: 'fetch',


			// ------------------------------
			//  Methods
			// ------------------------------

			/**
    * Queries the Shopify API to refresh the cart.<br>
    * Calling this function will update the cart object.
    *
    * @param {object} [options] - Properties to change the behaviour of fetch()
    * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
    * @fires cart_fetch
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * theme.cart.fetch();
    */
			value: function fetch() {
				var _this2 = this;

				var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref$silent = _ref.silent,
				    silent = _ref$silent === undefined ? false : _ref$silent;

				this._queue = this._queue.then(function () {
					return $.ajax({
						url: '/cart.js',
						type: 'GET',
						dataType: 'json'
					}).done(function (cart) {
						_this2.content = cart;

						if (!silent) {
							/**
        * The cart has been fetched.
        * The event is attached to the document element.<br><br>
        *
        * @event cart_fetch
        * @property {object} cart - The cart object.
        * @memberof Cart
        * @example
        * $(document).on('cart_fetch', function(event, cart) {});
        */
							$(document).trigger('cart_fetch', _this2.content);
						}
					}).fail(function (resp) {
						_this2._queue = $.when();
						console.error('Cart.fetch: Failed getting the cart.', resp);
					});
				});

				return this._queue;
			}

			/**
    * Adds an item to cart.
    *
    * @param {(object|number)} item - The item id or item object to add.
    * @param {number} item.id - The id of the variant to add.
    * @param {number} [item.quantity=1] - Quantity to add, defaults to 1.
    * @param {object} [options] - Properties to augment the behaviour of add()
    * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
    * @fires cart_add
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Adds 1 of item 1234567 to the cart.
    * theme.cart.add(1234567);
    */

		}, {
			key: 'add',
			value: function add(item) {
				var _this3 = this;

				var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
				    _ref2$silent = _ref2.silent,
				    silent = _ref2$silent === undefined ? false : _ref2$silent;

				if (!item) {
					console.warn('Cart.add: No item was passed.');
					return $.when();
				}

				// Set up the object if only an id is passed.
				if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) != 'object') {
					item = {
						id: item
					};
				}

				// Default the quantity to 1 if none is passed.
				item.quantity = item.quantity || 1;

				this._queue = this._queue.then(function () {
					return $.ajax({
						url: '/cart/add.js',
						data: item,
						type: 'POST',
						dataType: 'json'
					}).done(function (item) {
						if (!silent) {
							/**
        * An item has been added to cart.
        * The event is attached to the document element.<br><br>
        *
        * @event cart_add
        * @property {object} item - The item added to cart.
        * @memberof Cart
        * @example
        * $(document).on('cart_add', function(event, item) {});
        */
							$(document).trigger('cart_add', item);
						}
					}).fail(function (resp) {
						_this3._queue = $.when();
						console.error('Cart.add: Failed adding to the cart.', resp);
					});
				});

				// Queue a fetch to refresh the cart
				this.fetch({ silent: silent });

				return this._queue;
			}

			/**
    * Updates an item in the cart.
    *
    * @param {(object|object[]|number|number[])} items - The item id, id array, item object or object array to update.
    * @param {number} items.id - The id of the variant to update.
    * @param {number} [items.quantity=1] - Quantity to add, defaults to 1.
    * @param {object} [options] - Properties to augment the behaviour of update()
    * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
    * @fires cart_update
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Updated item 1234567's quantity to 5
    * theme.cart.update({ id: 1234567, quantity: 5 });
    *
    * // Updated item 1234567's quantity to 5 and item 7654321's quantity to 1
    * theme.cart.update([{ id: 1234567, quantity: 5 }, 7654321]);
    */

		}, {
			key: 'update',
			value: function update(items) {
				var _this4 = this;

				var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
				    _ref3$silent = _ref3.silent,
				    silent = _ref3$silent === undefined ? false : _ref3$silent;

				if (!items) {
					console.warn('Cart.update: No item was passed.');
					return $.when();
				}

				var data = {};

				/**
     * Internal function to convert items to the proper format for Shopify's update API call.
     *
     * @param {object} data - The data object to add the key/value pair to.
     * @param {(object|number)} item - The item id or item object to format.
     * @private
     */
				var _addUpdateItem = function _addUpdateItem(item) {
					// Set up the object if only an id is passed.
					if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
						if (!item.id) {
							console.warn('Cart.update: No id was passed with the product object.');
							return $.when();
						}
						data[item.id] = item.quantity || item.quantity === 0 ? item.quantity : 1;
					} else {
						data[item] = 1;
					}
				};

				if (Array.isArray(items)) {
					items.forEach(function (item) {
						_addUpdateItem(item);
					});
				} else {
					_addUpdateItem(items);
				}

				// If data is empty, return empty promise
				if (!Object.keys(data).length) {
					return $.when();
				}

				this._queue = this._queue.then(function () {
					return $.ajax({
						url: '/cart/update.js',
						data: { updates: data },
						type: 'POST',
						dataType: 'json'
					}).then(function (cart) {
						_this4.content = cart;
					}).done(function (cart) {
						// Refresh the cart

						if (!silent) {
							/**
        * An item in the cart has been updated.
        * The event is attached to the document element.<br><br>
        *
        * @event cart_update
        * @property {object} cart - The cart object.
        * @property {object} item - The item changed.
        * @memberof Cart
        * @example
        * $(document).on('cart_update', function(event, cart, item) {});
        */
							$(document).trigger('cart_update', [_this4.content, items]);
						}
					}).fail(function (resp) {
						_this4._queue = $.when();
						console.error('Cart.update: Failed updating a cart item.', resp);
					});
				});

				return this._queue;
			}

			/**
    * Change an item in the cart.
    *
    * @param {(object|number)} item - The item id or item object to update.
    * @param {number} item.id - The id of the variant to update.
    * @param {number} [item.quantity=1] - Quantity to add, defaults to 1.
    * @param {object} [options] - Properties to augment the behaviour of change()
    * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
    * @fires cart_change
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Changes item 1234567's quantity to 2
    * theme.cart.change({ id: 1234567, quantity: 2 });
    */

		}, {
			key: 'change',
			value: function change(item) {
				var _this5 = this;

				var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
				    _ref4$silent = _ref4.silent,
				    silent = _ref4$silent === undefined ? false : _ref4$silent;

				if (!item) {
					console.warn('Cart.change: No item was passed.');
					return $.when();
				}

				// Set up the object if only an id is passed.
				if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) != 'object') {
					item = {
						id: item,
						quantity: 1
					};
				}

				this._queue = this._queue.then(function () {
					return $.ajax({
						url: '/cart/change.js',
						data: item,
						type: 'POST',
						dataType: 'json'
					}).done(function (cart) {
						// Refresh the cart
						_this5.content = cart;

						if (!silent) {
							/**
        * An item in the cart's quantity has been changed.
        * The event is attached to the document element.<br><br>
        *
        * @event cart_change
        * @property {object} cart - The cart object.
        * @property {object} item - The item changed.
        * @memberof Cart
        * @example
        * $(document).on('cart_change', function(event, cart, item) {});
        */
							$(document).trigger('cart_change', [cart, item]);
						}
					}).fail(function (resp) {
						_this5._queue = $.when();
						console.error('Cart.change: Failed changing a cart quantity.', resp);
					});
				});
				return this._queue;
			}

			/**
    * Updates an item in the cart.
    *
    * @param {(object|object[]|number|number[])} item - The item id, id array, item object or object array to remove.
    * @param {object} [options] - Properties to augment the behaviour of remove()
    * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Removes item 1234567 from the cart
    * theme.cart.remove(1234567);
    */

		}, {
			key: 'remove',
			value: function remove(items) {
				var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
				    _ref5$silent = _ref5.silent,
				    silent = _ref5$silent === undefined ? false : _ref5$silent;

				if (!items) {
					console.warn('Cart.remove: No item was passed.');
					return $.when();
				}

				// Create an array of items with quantity 0 and feed to the update function.
				var remove_items = [];

				if (Array.isArray(items)) {
					items.forEach(function (item) {
						remove_items.push({ id: (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' ? item.id : item, quantity: 0 });
					});
				} else {
					remove_items.push({ id: (typeof items === 'undefined' ? 'undefined' : _typeof(items)) === 'object' ? items.id : items, quantity: 0 });
				}

				return this.update(remove_items, { silent: silent });
			}

			/**
    * Empty the cart.
    *
    * @param {object} [options] - Properties to augment the behaviour of clear()
    * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
    * @fires cart_clear
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * theme.cart.clear();
    */

		}, {
			key: 'clear',
			value: function clear() {
				var _this6 = this;

				var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
				    _ref6$silent = _ref6.silent,
				    silent = _ref6$silent === undefined ? false : _ref6$silent;

				this._queue = this._queue.then(function () {
					return $.ajax({
						url: '/cart/clear.js',
						type: 'POST',
						dataType: 'json'
					}).done(function (cart) {
						// Refresh the cart
						_this6.content = cart;

						if (!silent) {
							/**
        * The cart has been cleared.
        * The event is attached to the document element.<br><br>
        *
        * @event cart_clear
        * @property {object} cart - The cart object.
        * @memberof Cart
        * @example
        * $(document).on('cart_clear', function(event, cart) {});
        */
							$(document).trigger('cart_clear', cart);
						}
					}).fail(function (resp) {
						_this6._queue = $.when();
						console.error('Cart.clear: Failed clearing the cart.', resp);
					});
				});

				return this._queue;
			}

			/**
    * Updates an attribute in the cart.
    *
    * @param {object} attributes - The attribute(s) to update.
    * @param {object} [options] - The options to pass
    * @param {boolean} [options.no_overwrite=false] - Option to skip setting attributes if they are already set.
    * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
    * @fires cart_attributeUpdate
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Update the language attribute to 'fr' and currency to CAD
    * theme.cart.updateAttributes({ langauge: 'fr', currency: 'CAD' });
    *
    * // Update the language attribute to 'fr' but don't overwrite if already set
    * theme.cart.updateAttributes({ langauge: 'fr' }, { no_overwrite: true });
    */

		}, {
			key: 'updateAttributes',
			value: function updateAttributes(attributes) {
				var _this7 = this;

				var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
				    _ref7$no_overwrite = _ref7.no_overwrite,
				    no_overwrite = _ref7$no_overwrite === undefined ? false : _ref7$no_overwrite,
				    _ref7$silent = _ref7.silent,
				    silent = _ref7$silent === undefined ? false : _ref7$silent;

				if (!attributes) {
					console.warn('Cart.updateAttribute: No attributes were passed.');
					return $.when();
				}

				var data = {};

				// If we don't overwrite, only add attributes that are not set in cart
				if (no_overwrite) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = Object.keys(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var key = _step.value;

							if (!this.content.attributes[key]) {
								data[key] = attributes[key];
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				} else {
					data = attributes;
				}

				// If data is empty, return empty promise
				if (!Object.keys(data).length) {
					return $.when();
				}

				this._queue = this._queue.then(function () {
					return $.ajax({
						url: '/cart/update.js',
						data: { attributes: data },
						type: 'POST',
						dataType: 'json'
					}).done(function (cart) {
						// Refresh the cart
						_this7.content = cart;

						if (!silent) {
							/**
        * An item in the cart has been updated.
        * The event is attached to the document element.<br><br>
        *
        * @event cart_attributeUpdate
        * @property {object} cart - The cart object.
        * @property {object} attributes - The attributes changed.
        * @memberof Cart
        * @example
        * $(document).on('cart_attributeUpdate', function(event, cart, attributes) {});
        */
							$(document).trigger('cart_update', [cart, data]);
						}
					}).fail(function (resp) {
						_this7._queue = $.when();
						console.error('Cart.attributeUpdate: Failed updating a cart attribute.', resp);
					});
				});

				return this._queue;
			}

			/**
    * Clears all or specific attributes in the cart.
    *
    * @param {(string|string[])} [attributes] - The attribute(s) to clear. If none are passed, all will be cleared.
    * @param {object} [options] - Properties to augment the behaviour of clearAttributes()
    * @param {Boolean} [options.silent=false] - With silent enabled events will not be triggered
    * @returns {Promise} The AJAX call to Shopify's cart API.
    * @memberof Cart
    * @example
    * // Clears all cart attributes
    * theme.cart.clearAttributes();
    *
    * // Only clears the language attribute
    * theme.cart.clearAttributes('language');
    *
    * // Clears the language and currency attributes
    * theme.cart.clearAttributes(['language', 'currency']);
    */

		}, {
			key: 'clearAttributes',
			value: function clearAttributes(attributes) {
				var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
				    _ref8$silent = _ref8.silent,
				    silent = _ref8$silent === undefined ? false : _ref8$silent;

				var cleared_attributes = {};

				// If no attributes are passed, use all cart attributes to clear
				var attribute_keys = attributes !== undefined ? [].concat(attributes || []) : Object.keys(theme.cart.content.attributes);

				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = attribute_keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var key = _step2.value;

						cleared_attributes[key] = '';
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				return this.updateAttributes(cleared_attributes, { silent: silent });
			}
		}, {
			key: 'content',
			get: function get() {
				return this._object;
			},
			set: function set(cart) {
				// The Cart class uses a private variable to keep track of the cart content.
				this._object = cart || this._object;

				/**
     * The cart has been updated.
     * The event is attached to the document element.<br><br>
     *
     * @event cart_set
     * @property {object} cart - The cart object.
     * @memberof Cart
     * @example
     * $(document).on('cart_set', function(event, cart) {});
     */
				$(document).trigger('cart_set', this.content);
			}
		}]);

		return Cart;
	}();

	// Global export
	// Uses the cart information stored by the global object if available


	theme.cart = new Cart(theme.cart || null);
})(window.theme = window.theme || {}, jQuery);

(function (theme, $) {
	var algolia_params = {
		appId: theme.algolia_keys.appId,
		apiKey: theme.algolia_keys.apiKey,
		indexName: theme.algolia_keys.prefix + 'products',
		routing: true,
		searchParameters: {
			hitsPerPage: 200,
			filters: 'tags:b2c'
		}
	};

	theme.ALGOLIA = algolia_params;
})(window.theme = window.theme || {}, jQuery);
// Shipping Price Calculation
(function (theme, $) {
	var ShippingCalculator = function () {
		function ShippingCalculator() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			_classCallCheck(this, ShippingCalculator);

			this.directory = theme.lookup.shipping;
		}

		_createClass(ShippingCalculator, [{
			key: '_lookupFee',
			value: function _lookupFee(shipper_handle) {
				// Default: If there's no shipping information found for a particular shipper, the shipping fee will default to 0.
				return (this.directory[shipper_handle] ? parseInt(this.directory[shipper_handle].fee) : undefined) || 0;
			}
		}, {
			key: 'calculate',
			value: function calculate() {
				var _this8 = this;

				var shippers = theme.utils.toUnique(theme.cart.content.items.map(function (item) {
					return item.vendor;
				}));

				var shipping_cost = shippers.reduce(function (acc, shipper) {
					return acc + _this8._lookupFee(shipper.handleize());
				}, 0);

				return shipping_cost;
			}
		}, {
			key: 'populate',
			value: function populate(selector) {
				var shipping_total = this.calculate();
				$(selector).text(theme.utils.toMoney(shipping_total, { cents: true }));
			}
		}, {
			key: 'cart_flyout_product_shipping_fee',
			value: function cart_flyout_product_shipping_fee(html_data) {
				var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
				var no_decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

				var $this = $(html_data);
				var shipper_handle = $this.data('shipper').handleize();
				var money_options = {
					cents: cents,
					no_decimals: no_decimals
					// shipping fee for the product
				};return theme.utils.toMoney(this._lookupFee(shipper_handle), money_options);
			}
		}, {
			key: 'cart_flyout_set_short_title',
			value: function cart_flyout_set_short_title($element) {
				var shipper_handle = $element.data('shipper').handleize();
				if (this.directory[shipper_handle]) {
					$element.html(this.directory[shipper_handle].short_title);
				}
			}
		}, {
			key: 'cart_flyout_set_shipping_delay',
			value: function cart_flyout_set_shipping_delay($element) {
				var shipper_handle = $element.data('shipper').handleize();
				if (this.directory[shipper_handle]) {
					$element.html(this.directory[shipper_handle].shipping_delay);
				}
			}
		}]);

		return ShippingCalculator;
	}();

	// ------------------------------
	//  Initialization
	// ------------------------------

	theme.shippingCalculator = new ShippingCalculator();

	/* To test:
  * let sc = new theme.ShippingCalculator(theme.cart.content);
  * sc.calculate();
  * // returns 1000 [in cents]
  */
})(window.theme = window.theme || {}, jQuery || Checkout.jQuery);
/**
 * CART FLYOUT LIBRARY
 *
 * @description Handles the Shopify cart flyout interactions.
 * @namespace cartflyout
 */

(function (theme, $) {

	/**
  * Class representing a Cart Item in the cart flyout.
  *
  * @classdesc Creates a Cart Item objects from <code>.js-cart-flyout</code> children elements with the class <code>js-cart-item</code> and the <code>data-key</code> attribute containing the line item's key.
  * <br><br>
  *
  * A cart item requires an <code><input type="number"/></code> quantity field with the class <code>js-cart-qty</code>, an element with the class <code>js-cart-remove</code> for removing the item from the cart and an element with the class <code>js-cart-save</code> for saving to Wishlist.
  *
  * @example
  * <li class="js-cart-item" data-key="{{ item.key }}">
  * 	<input type="number" class="js-cart-qty"/>
  * 	<div class="js-cart-remove"></div>
  * 	<div class="js-cart-save"></div>
  * </li>
  *
  * @property {object} item - Cart line item
  * @property {object} elements - Contains the cart item element and its triggers
  * @property {string} key - Cart line item key
  */
	var CartItem = function () {

		/**
   * Creates an instance of CartItem.
   *
   * @param {HTMLElement} $element - The line item element
   * @constructs CartItem
   * @memberof CartItem
   */
		function CartItem($element) {
			var _this9 = this;

			_classCallCheck(this, CartItem);

			if (!$element) {
				console.error('CartItem.constructor: No element was passed.');
				return false;
			}

			this.elements = {
				item: $element,
				qty: $element.find('.js-cart-qty'),
				remove: $element.find('.js-cart-remove'),
				tooltip: $element.find('.js-inventory-tooltip')
			};

			this.key = this.elements.item.data('key');

			// if item is a subprod, to stay in sync with parent modifications.
			if (this.elements.item.data('is-sub')) {
				var sum = 0;
				var variantId = this.elements.item.data('id');

				$('.js-cart-qty[data-subprod=' + variantId + ']').each(function () {
					sum += Number($(this).val());
				});

				// update the qty to match the total qty of parent items in the cart.
				if (sum !== Number(this.elements.qty.val())) {
					theme.cart.update({
						id: this.key,
						quantity: sum
					});
				}
			}

			if (theme.cart.content.items) {
				this.item = theme.cart.content.items.filter(function (item) {
					return item.key == _this9.key;
				})[0];
			}

			try {
				this.thc = parseFloat(this.item.properties._thc);
			} catch (err) {
				console.error(err);
				// if thc isn't set, it's bc the cart in the theme object hasn't been updated to the actual cart yet,
				// so for now just set the thc to the total available thc (preventative),
				// and update the icon in the header with the cart count
				this.thc = theme.THCRegulator.getAvailable();
			}

			this._bindTriggers();
		}

		// ------------------------------
		//  Methods
		// ------------------------------

		/**
   * Internal method that binds cart item triggers and adds them to <code>elements.qty</code>,  <code>elements.remove</code>, and <code>elements.save</code>
   * Handles change and click events.
   *
   * @private
   * @memberof CartItem
   */


		_createClass(CartItem, [{
			key: '_bindTriggers',
			value: function _bindTriggers() {
				var _this10 = this;

				this.elements.qty.off('change.CartFlyout').on('change.CartFlyout', function () {
					var current_qty = _this10.item.quantity;
					var available_thc = theme.THCRegulator.getAvailable();

					var qty = parseInt(_this10.elements.qty.val());

					if (qty === NaN) {
						return;
					}

					// If the new quantity would be over the limit of a non b2b account
					// Cap the quantity to the max that would be possible without going over the limit
					if ((qty - current_qty) * _this10.thc > available_thc) {
						qty = current_qty + Math.floor(available_thc / _this10.thc);
					}

					if (qty > 0) {
						theme.cart.update({
							id: _this10.key,
							quantity: qty
						}).then(function () {
							$(document).trigger('CartItem_update');
						});
					} else {
						_this10.elements.remove.trigger('click.CartFlyout');
					}
				});

				this.elements.remove.off('click.CartFlyout').on('click.CartFlyout', function () {
					theme.cart.remove(_this10.key).then(function () {
						$(document).trigger('CartItem_remove');
					});
				});

				this.elements.tooltip.off('click.CartFlyout').on('click.CartFlyout', function () {
					_this10.elements.tooltip.toggleClass('tooltip-active');
				});
			}
		}]);

		return CartItem;
	}();

	/**
  * Class representing the cart flyout element.
  *
  * @classdesc Creates Cart Flyout object from the first (and only) element with the class <code>js-cart-flyout</code>.
  *
  * @example
  * <div class='js-cart-flyout'></div>
  *
  *
  * @property {object} elements - Contains the cart flyout, its triggers, and the items in the cart
  * @property {boolean} refresh - Flag to prevent the flyout from refreshing its layout too quickly while the user is still interacting with it
  */


	var CartFlyout = function () {

		/**
   * Creates an instance of CartFlyout.
   *
   * @param {HTMLElement} $cart_flyout - The cart flyout element
   * @constructs CartItem
   * @memberof CartItem
   */
		function CartFlyout($cart_flyout) {
			var _this11 = this;

			_classCallCheck(this, CartFlyout);

			if (!$cart_flyout) {
				console.error('CartFlyout.constructor: No element was passed.');
				return false;
			}

			this.elements = {
				cart_flyout: $cart_flyout,
				wrapper: $cart_flyout.parent(),
				cart_items: []
			};

			this._validation_pass = false;
			this._validation_steps = [];

			this._bindItems();

			$(document).on('cart_set', function () {
				_this11._refresh();
			});

			this.updateShipping();

			this._flyout_id = this.elements.wrapper.data('flyout-id');

			this._refresh();
		}

		// ------------------------------
		//  Methods
		// ------------------------------

		/**
   * Internal method instantiates cart items adds them to <code>cartflyout.elements.cart_items</code>.
   *
   * @private
   * @memberof CartFlyout
   */


		_createClass(CartFlyout, [{
			key: '_bindItems',
			value: function _bindItems() {
				var _this12 = this;

				this.elements.cart_flyout.find('.js-cart-item').each(function (index, element) {
					_this12.elements.cart_items.push(new CartItem($(element)));
				});

				this.elements.checkout_button = $('.js-flyout-checkout-button', this.elements.cart_flyout);
				this.elements.checkout_button.toggleClass('bag_gated', !this._validation_pass);
				this.elements.validation = $('.js-cart-flyout-validation', this.elements.cart_flyout);

				// Recheck any elements after a refresh
				Object.keys(this._validation_steps).forEach(function (step) {
					_this12.elements.validation.filter('[name="' + step + '"]').prop('checked', !!_this12._validation_steps[step]);
				});

				this.elements.validation.on('change', function (event) {
					_this12._validation_pass = !_this12.elements.validation.not(':checked').length;
					_this12._validation_steps[event.target.name] = event.target.checked;

					_this12.elements.checkout_button.toggleClass('bag_gated', !_this12._validation_pass);
				});
			}

			/**
    * Internal method that updates the contents of the Cart Flyout.
    *
    * @private
    * @memberof CartFlyout
    */

		}, {
			key: '_refresh',
			value: function _refresh() {
				var _this13 = this;

				if (!this.refresh || true) {
					this.refresh = true;
					$.get('/cart?view=flyout', function (cart_flyout) {
						var $cart_flyout = $(cart_flyout);
						_this13.elements.cart_flyout = $cart_flyout;
						_this13.elements.wrapper.html($cart_flyout);

						theme.Flyouts[_this13._flyout_id]._refresh();

						_this13._bindItems();
						_this13.elements.cart_flyout.trigger('CartFlyout_update');
						_this13.updateShipping();
					}).done(function () {

						_this13.refresh = false;
					});
				}
			}
		}, {
			key: 'updateShipping',
			value: function updateShipping() {
				if (theme.cart.content.items.length > 0) {
					$('.js-shipping-price').html(theme.utils.toMoney(theme.shippingCalculator.calculate(), {
						cents: true
					}));
				}
			}
		}]);

		return CartFlyout;
	}();

	// ------------------------------
	//  Initiallization
	// ------------------------------


	if (!theme.cart_flyout) {
		theme.cart_flyout = {};
	}

	theme.cart_flyout.cart = new CartFlyout($('.js-cart-flyout').first());
})(window.theme = window.theme || {}, jQuery);
// Filters, sort, and local navigation
(function (theme, $) {
	if (theme.template.name == 'collection') {

		var LOCAL_NAVIGATION_DEFAULTS = {
			selectors: {
				container: '.js-local-nav',
				toggle: '.js-toggle-local-nav',
				close: '.js-close-local-nav',
				list: '.js-local-nav-list'
			},
			status: {
				open: 'local-nav-open'
			}
		};

		var LocalNavigation = function () {
			function LocalNavigation($container) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

				_classCallCheck(this, LocalNavigation);

				this.$container = $container;
				this.options = $.extend(options, LOCAL_NAVIGATION_DEFAULTS);
				this._bindTriggers();
			}

			_createClass(LocalNavigation, [{
				key: '_bindTriggers',
				value: function _bindTriggers() {
					var _this14 = this;

					// Close local nav when clicking the X
					this.$container.on('click', this.options.selectors.close, function (e) {
						_this14.close();
					});

					// Toggle opening and closing local nav from the active link
					this.$container.on('click', this.options.selectors.toggle, function (e) {
						if (!_this14.$container.hasClass(_this14.options.status.open)) {
							_this14.open();
						} else {
							_this14.close();
						}
					});
				}
			}, {
				key: 'open',
				value: function open() {
					this.$container.addClass(this.options.status.open);
				}
			}, {
				key: 'close',
				value: function close() {
					this.$container.removeClass(this.options.status.open);
				}
			}]);

			return LocalNavigation;
		}();

		theme.LocalNavigation = $.each($(), function (index, value) {
			return new LocalNavigation($(value));
		});

		// ------------------------------
		//  Initialization
		// ------------------------------

		theme.LocalNavigation = LocalNavigation;

		$(LOCAL_NAVIGATION_DEFAULTS.selectors.container).each(function (index, element) {
			new theme.LocalNavigation($(element));
		});
	}
})(window.theme = window.theme || {}, jQuery);
(function (theme, $) {
	$(function () {
		/**
   * This CustomFilterWidget contains common behaviours shared
   * by all custom widgets including tooltips, sliding up and down
   * of filter items, and clear all
   * @class
   */
		var CustomFilterWidget = function () {
			/**
    * @param {Object} options - Widget options
    * @param {jQuery} options.$container - The container of this filter widget
    */
			function CustomFilterWidget(options) {
				var _this15 = this;

				_classCallCheck(this, CustomFilterWidget);

				this.widget_elements = {
					$container: options.$container,
					$header: $(".js-filter-header", options.$container),
					$toolTipTrigger: $(".js-tooltip", options.$container),
					$filterDetails: $(".js-filter-details", options.$container),
					$filterClearAll: $(".js-filter-clear", options.$container)
				};

				// Widget headers contain different elements that
				// do different things if they're clicked on.
				// Check which element was selected
				this.widget_elements.$header.on("click", function (event) {
					// Check if the tooltip has been clicked
					if (_this15.constructor._checkTarget(_this15.widget_elements.$toolTipTrigger.get(0), event.target)) {
						return;
						// Check if the 'clear all' button has been clicked
					} else if (_this15.constructor._checkTarget(_this15.widget_elements.$filterClearAll.get(0), event.target)) {
						_this15.clearAll();
						// By default toggle the details container
					} else {
						var expanding = !_this15.widget_elements.$header.hasClass("active");
						_this15.widget_elements.$header.toggleClass("active").attr("aria-expanded", expanding ? "true" : "false");
						_this15.widget_elements.$filterDetails.slideToggle();
					}
				});

				this.widget_elements.$filterClearAll.on("click", function () {
					_this15.clearAll();
				});

				// Space/Enter keyboard activation for the header (role="button")
				this.widget_elements.$header.on("keydown", function (event) {
					if (event.key !== " " && event.key !== "Enter") return;
					if (event.target !== _this15.widget_elements.$header.get(0)) return;
					event.preventDefault();
					_this15.widget_elements.$header.trigger("click");
				});
			}

			/**
    * Clear all of this widget's filters
    * @memberOf CustomFilterWidget
    * @abstract
    */


			_createClass(CustomFilterWidget, [{
				key: 'clearAll',
				value: function clearAll() {
					console.warn("Clear all not implemented");
				}

				/**
     * Get the instantSearch friendly widget
     * @memberOf CustomFilterWidget
     * @abstract
     */

			}, {
				key: 'getWidget',
				value: function getWidget() {
					console.warn("Get widget not implemented");
				}

				/**
     * Get the dummywidget that can be used
     * when we only want an instantSearch context
     * to update its state
     * @memberOf CustomFilterWidget
     */

			}, {
				key: 'getDummyWidget',
				value: function getDummyWidget() {
					return this.dummyWidget;
				}

				/**
     * Toggle whether this widget should indicate that it has filtering applied
     * @param {Boolean} active - Whether to show or hide the filtering active status
     * @memberOf CustomFilterWidget
     */

			}, {
				key: 'toggleFilterActive',
				value: function toggleFilterActive(active) {
					this.widget_elements.$header.toggleClass("filter-active", active);
					this.widget_elements.$container.trigger("Filter:toggled");
				}

				/**
     * Check if an element is or is the descendent of another element
     * @param {object} container The parent element
     * @param {object} contains The possible element or child element
     */

			}, {
				key: 'setContainerState',


				// Dispay of show the container that has the filtering.
				value: function setContainerState(boolState) {
					if (this.widget_elements.$container) {
						if (boolState) {
							this.widget_elements.$container.show();
						} else {
							this.widget_elements.$container.hide();
						}
					}
				}
			}], [{
				key: '_checkTarget',
				value: function _checkTarget(container, contains) {
					if (!container) {
						return false;
					}

					return container === contains || $.contains(container, contains);
				}
			}]);

			return CustomFilterWidget;
		}();

		/**
   * The LabeledRefinementList implements instantSearch's connectRefinementList
   * in order to display a list of refinements with a label.
   * Note that the LabeledRefinementList is NOT a valid instantSearch widget,
   * but a wrapper around a connectRefinementList
   * @class
   * @extends CustomFilterWidget
   */


		var LabeledRefinementList = function (_CustomFilterWidget) {
			_inherits(LabeledRefinementList, _CustomFilterWidget);

			/**
    * @param {Object} options - Widget options
    * @param {jQuery} options.$container - Container of this widget
    * @param {Object} options.paraentContainer - The parent container of this widget
    */
			function LabeledRefinementList(options) {
				_classCallCheck(this, LabeledRefinementList);

				// Create the instantSearch connector
				var _this16 = _possibleConstructorReturn(this, (LabeledRefinementList.__proto__ || Object.getPrototypeOf(LabeledRefinementList)).call(this, options));

				_this16.connector = instantsearch.connectors.connectRefinementList(_this16.render.bind(_this16));

				_this16.options = options;
				_this16.attributeName = options.$container.data("filter-attribute");

				_this16.elements = {
					$container: options.$container,
					$itemContainer: $(".js-filter-items", options.$container)
				};
				// Unique ID prefix derived from nearest named ancestor, so mobile and desktop instances don't share IDs
				_this16._idScope = $(".js-filter-items", options.$container).closest('[id]').attr('id') || options.$container.closest('[id]').attr('id') || 'filter';

				// Create the instantSearch widget
				_this16.widget = _this16.connector({
					container: options.parentContainer,
					attributeName: _this16.attributeName,
					limit: 200,
					operator: "or",
					sortBy: ["name:asc"]
				});

				_this16.dummyWidget = new DummyLabeledRefinementList(_this16.attributeName);
				return _this16;
			}

			/**
    * The render function for this widget's connector.
    *
    * @param {Object} params - Widget and search parameters
    * @param {Boolean} isFirstRender - Whether it's the first time this widget renders
    * @memberOf LabeledRefinementList
    */


			_createClass(LabeledRefinementList, [{
				key: 'render',
				value: function render(params, isFirstRender) {
					var _this17 = this;

					// On first render add events
					if (isFirstRender) {
						this.helper = params.instantSearchInstance.helper;

						// Toggle refinements when items are selected
						this.elements.$itemContainer.on("change", ".js-refinement-toggle", function (event) {
							params.refine($(event.target).val());
						});
					}

					// Toggle active styling if there are any refinements applied
					this.toggleFilterActive(params.instantSearchInstance.helper.getRefinements(this.attributeName).length !== 0);

					// Empty the container and repopulate it with refinement items
					this.elements.$itemContainer.empty();

					// check if params.items is empty.. if so.. do not render.
					this.setContainerState(true);
					if (params.items.length) {
						params.items.forEach(function (item, index) {
							var id = 'refinementItem-' + _this17._idScope + '-' + _this17.attributeName + '-' + item.label + '-' + index;
							_this17.elements.$itemContainer.append('<div class="filter-widget__refinement">\n\t\t\t\t\t\t\t<input id="' + id + '" class="filter-widget__refinement-input js-refinement-toggle" type="checkbox" value="' + item.value + '" ' + (item.isRefined ? "checked" : "") + ' />\n\t\t\t\t\t\t\t<label class="filter-widget__refinement-label" for="' + id + '">' + item.label + '</label>\n\t\t\t\t\t\t</div>');
						});
					} else {
						this.setContainerState(false);
					}
				}

				/**
     * Clear all refinements
     * @override
     * @memberOf LabeledRefinementList
     */

			}, {
				key: 'clearAll',
				value: function clearAll() {
					if (this.helper) {
						this.helper.clearRefinements(this.attributeName).search();
					}
				}

				/**
     * Get the widget
     * @override
     * @memberOf LabeledRefinementList
     * @returns {Object} - The widget
     */

			}, {
				key: 'getWidget',
				value: function getWidget() {
					return this.widget;
				}
			}]);

			return LabeledRefinementList;
		}(CustomFilterWidget);

		/**
   * The DummyLabeledRefinementList class is a custom Algolia
   * instantSearch widget whose purpose is updating routing states
   * on search contexts that don't have a proper LabeledRefinementList
   * @class
   */


		var DummyLabeledRefinementList = function () {
			function DummyLabeledRefinementList(attributeName) {
				_classCallCheck(this, DummyLabeledRefinementList);

				this.attributeName = attributeName;
			}

			/**
    * Configuration of this widget
    * is the facet for filtering
    * @memberOf DummyLabeledRefinementList
    * @returns {Object}
    */


			_createClass(DummyLabeledRefinementList, [{
				key: 'getConfiguration',
				value: function getConfiguration() {
					return {
						disjunctiveFacets: [this.attributeName]
					};
				}

				/**
     * Update the routing state based on the search state
     * @param {Object} uiState - Current routing state
     * @param {Object} searchParameters - search state
     * @memberOf DummyLabeledRefinementList
     */

			}, {
				key: 'getWidgetState',
				value: function getWidgetState(uiState, _ref9) {
					var searchParameters = _ref9.searchParameters;

					var values = searchParameters.getDisjunctiveRefinements(this.attributeName);

					// Don't update the state if there are no changes
					if (values.length === 0 || uiState.refinementList && uiState.refinementList[this.attributeName] && uiState.refinementList[this.attributeName].every(function (value, index) {
						return value === values[index];
					})) {
						return uiState;
					}

					// Store the array of refinements
					return $.extend(true, {}, uiState, {
						refinementList: _defineProperty({}, this.attributeName, values)
					});
				}

				/**
     * Update the search state based on the routing state
     * @param {Object} searchParameters - The search state
     * @param {Object} uiState - The routing state
     * @memberOf DummyLabeledRefinementList
     */

			}, {
				key: 'getWidgetSearchParameters',
				value: function getWidgetSearchParameters(searchParameters, _ref10) {
					var _this18 = this;

					var uiState = _ref10.uiState;

					var values = uiState.refinementList && uiState.refinementList[this.attributeName];

					// If there are no values, don't update the search
					if (values === undefined) return searchParameters;

					// Add facet refinements for each value
					return values.reduce(function (sp, v) {
						return sp.addDisjunctiveFacetRefinement(_this18.attributeName, v);
					}, searchParameters.clearRefinements(this.attributeName));
				}

				/**
     * An empty init function to make this a valid
     * instantSearch widget
     * @memberOf DummyLabeledRefinementList
     */

			}, {
				key: 'init',
				value: function init() {}
			}]);

			return DummyLabeledRefinementList;
		}();

		/**
   * The DoubleFacetNumbericSelector is a custom instantSearch widget that
   * creates a two-handled slider to select a numeric range.
   * The numeric range is used to filter items that specify their own range in
   * two seperate numeric facets. Items whose range overlaps the selected range
   * at some point will be included.
   * @extends CustomFilterWidget
   */


		var DoubleFacetNumbericSelector = function (_CustomFilterWidget2) {
			_inherits(DoubleFacetNumbericSelector, _CustomFilterWidget2);

			/**
    *
    * @param {Object} options - Widget options
    * @param {jQuery} options.$container
    */
			function DoubleFacetNumbericSelector(options) {
				_classCallCheck(this, DoubleFacetNumbericSelector);

				var _this19 = _possibleConstructorReturn(this, (DoubleFacetNumbericSelector.__proto__ || Object.getPrototypeOf(DoubleFacetNumbericSelector)).call(this, options));

				_this19.firstRender = true;

				_this19.elements = {
					$container: options.$container,
					$slider: $(".js-filter-items", options.$container)
				};

				_this19.attributeNameMin = options.$container.data("filter-attribute-min");
				_this19.attributeNameMax = options.$container.data("filter-attribute-max");
				_this19.attributeUnit = options.$container.data("filter-unit");

				_this19.dummyWidget = new DummyDoubleFacetNumbericSelector(_this19.attributeNameMin, _this19.attributeNameMax);

				// Create the jQuery UI slider
				_this19.elements.$slider.slider({
					range: true,
					step: 0.01
				}).on("slidestart slidestop", function (event, ui) {
					// Add a class when a slide event occurs that is not the result of interacting with the handle
					// so that the handle can be animated with css
					if (event.originalEvent && event.originalEvent.target.classList && !event.originalEvent.target.classList.contains("ui-slider-handle")) {
						_this19.elements.$slider.toggleClass("animating", event.type === "slidestart");
					} else {
						_this19.elements.$slider.removeClass("animating");
					}
				}).on("slidechange", function (event, ui) {
					if (_this19.helper) {
						var value = ui.handleIndex ? Math.floor(ui.value) : Math.ceil(ui.value);

						if (ui.handleIndex == 0) {
							// If the min handle has been updated,
							// update the max refinement
							_this19.currentMin = value;
							_this19.helper.removeNumericRefinement(_this19.attributeNameMax);

							if (value !== _this19.min) {
								_this19.helper.addNumericRefinement(_this19.attributeNameMax, ">=", value);
							}
						} else {
							// If the max handle has been updated,
							// update the min refinement
							_this19.currentMax = value;
							_this19.helper.removeNumericRefinement(_this19.attributeNameMin);

							if (value !== _this19.max) {
								_this19.helper.addNumericRefinement(_this19.attributeNameMin, "<=", value);
							}
						}

						// Toggle whether to show the "clear all" button
						_this19.toggleFilterActive(_this19.currentMin !== _this19.min || _this19.currentMax !== _this19.max);

						// Update the handle labels
						_this19._updateHandleValue(ui.handleIndex, value, _this19.attributeUnit);

						_this19.helper.search();
					}
				}).on("slide", function (event, ui) {
					var value = ui.handleIndex ? Math.floor(ui.value) : Math.ceil(ui.value);
					// Update the handle labels
					_this19._updateHandleValue(ui.handleIndex, value, _this19.attributeUnit);
				});

				_this19.elements.$handles = $(".ui-slider-handle", _this19.elements.$slider);
				return _this19;
			}

			/**
    * Store the helper on load
    * @param {Object} initOptions - Algolia init options
    * @memberOf DoubleFacetNumbericSelector
    */


			_createClass(DoubleFacetNumbericSelector, [{
				key: 'init',
				value: function init(initOptions) {
					this.helper = initOptions.helper;
				}

				/**
     * Get the facets for filtering
     * @memberOf DoubleFacetNumbericSelector
     * @returns {Object}
     */

			}, {
				key: 'getConfiguration',
				value: function getConfiguration() {
					return {
						disjunctiveFacets: [this.attributeNameMin, this.attributeNameMax]
					};
				}

				/**
     * The widget's render function called by instantSearch
     * @param {Object} renderOptions - Algolia render options
     * @memberOf DoubleFacetNumbericSelector
     */

			}, {
				key: 'render',
				value: function render(renderOptions) {
					var minFacetStats = renderOptions.helper.lastResults.getFacetStats(this.attributeNameMin);
					var maxFacetStats = renderOptions.helper.lastResults.getFacetStats(this.attributeNameMax);

					var minFacetRefinement = renderOptions.helper.getNumericRefinement(this.attributeNameMin, "<=");
					var maxFacetRefinement = renderOptions.helper.getNumericRefinement(this.attributeNameMax, ">=");

					this.setContainerState(true);
					if (!minFacetStats || !maxFacetStats) {
						if (!minFacetRefinement && !maxFacetRefinement) {
							this.setContainerState(false);
						}
						return;
					}

					minFacetStats.min = Math.floor(minFacetStats.min);
					maxFacetStats.max = Math.ceil(maxFacetStats.max);

					// On first render set the min and the max values
					if (this.firstRender) {
						this.min = minFacetStats.min;
						this.max = maxFacetStats.max;

						this.elements.$slider.slider({
							min: this.min,
							max: this.max
						});

						this._initHandleAria();
						this.firstRender = false;
					}

					/**
      * If a filter is already applied on load, Algolia
      * will only report the min and the max values of
      * the filtered subset. The min and max values may change
      * as filters are removed. Update the widget to keep
      * the GUI as relevant as possible.
      */

					// Check if the min or max has been updated
					var minUpdated = minFacetStats.min < this.min;
					var maxUpdated = maxFacetStats.max > this.max;

					if (minUpdated || maxUpdated) {
						// Check if the min or max is currently selected
						var updateMin = this.min == this.currentMin;
						var updateMax = this.max == this.currentMax;

						this.min = minUpdated ? minFacetStats.min : this.min;
						this.max = maxUpdated ? maxFacetStats.max : this.max;

						// Update the min and max values
						this.elements.$slider.slider({
							min: this.min,
							max: this.max
						});

						// If a min or a max was previously selected,
						// update the current values to match to new
						// min or max respectively
						if (updateMin || updateMax) {
							var currentMin = updateMin ? this.min : this.currentMin;
							var currentMax = updateMax ? this.max : this.currentMax;

							this.elements.$slider.slider({
								values: [currentMin, currentMax]
							});
						}
					} else {
						// If there's been an update to the refinement,
						// update the position of the slider handles
						var minRefinement = renderOptions.helper.getNumericRefinement(this.attributeNameMin, "<=");
						var maxRefinement = renderOptions.helper.getNumericRefinement(this.attributeNameMax, ">=");

						var _currentMax = minRefinement ? minRefinement[0] : this.max;
						var _currentMin = maxRefinement ? maxRefinement[0] : this.min;

						if (this.currentMin !== _currentMin || this.currentMax !== _currentMax) {
							this.elements.$slider.slider({
								values: [_currentMin, _currentMax]
							});
						}
					}
				}

				/**
     * On clear all reset values to the min and max
     * @memberOf DoubleFacetNumbericSelector
     */

			}, {
				key: 'clearAll',
				value: function clearAll() {
					this.elements.$slider.slider({
						values: [this.min, this.max]
					});
				}

				/**
     * This object is a valid Algolia widget
     * @returns {Object} The Algolia instantSearch widget
     * @memberOf DoubleFacetNumbericSelector
     */

			}, {
				key: 'getWidget',
				value: function getWidget() {
					return this;
				}

				/**
     * Update the label of a handle
     * @param {Number} handleIndex - Handle index (0 - min, 1 - max)
     * @param {Number} value - Value to set
     * @param {String} unit - Unit of measurement.
     * @memberOf DoubleFacetNumbericSelector
     */

			}, {
				key: '_updateHandleValue',
				value: function _updateHandleValue(handleIndex, value, unit) {
					this.elements.$handles.eq(handleIndex).attr({
						"data-value": value.toFixed(0) + unit,
						"aria-valuenow": value
					});
				}

				/**
     * Set initial ARIA attributes on slider handles after min/max are known.
     * @memberOf DoubleFacetNumbericSelector
     */

			}, {
				key: '_initHandleAria',
				value: function _initHandleAria() {
					var unit = this.attributeUnit || "";
					this.elements.$handles = $(".ui-slider-handle", this.elements.$slider);
					this.elements.$handles.eq(0).attr({
						role: "slider",
						"aria-label": ("Minimum " + unit).trim(),
						"aria-valuemin": this.min,
						"aria-valuemax": this.max,
						"aria-valuenow": this.min
					});
					this.elements.$handles.eq(1).attr({
						role: "slider",
						"aria-label": ("Maximum " + unit).trim(),
						"aria-valuemin": this.min,
						"aria-valuemax": this.max,
						"aria-valuenow": this.max
					});
				}
			}]);

			return DoubleFacetNumbericSelector;
		}(CustomFilterWidget);

		/**
   * The DummyDoubleFacetNumbericSelector is an instantSearch widget
   * that mocks the DoubleFacetNumbericSelector to update the state
   * of search contexts that don't have a full DoubleFacetNumbericSelector
   * and its associated DOM elements
   * @class
   */


		var DummyDoubleFacetNumbericSelector = function () {
			function DummyDoubleFacetNumbericSelector(attributeNameMin, attributeNameMax) {
				_classCallCheck(this, DummyDoubleFacetNumbericSelector);

				this.attributeNameMin = attributeNameMin;
				this.attributeNameMax = attributeNameMax;
			}

			/**
    * Get the facets for filtering
    * @memberOf DummyDoubleFacetNumbericSelector
    * @returns {Object}
    */


			_createClass(DummyDoubleFacetNumbericSelector, [{
				key: 'getConfiguration',
				value: function getConfiguration() {
					return {
						disjunctiveFacets: [this.attributeNameMin, this.attributeNameMax]
					};
				}

				/**
     * Store search state information in the routing state
     * @param {Object} uiState - The routing state
     * @param {Object} searchParameters - The search state
     * @memberOf DummyDoubleFacetNumbericSelector
     */

			}, {
				key: 'getWidgetState',
				value: function getWidgetState(uiState, _ref11) {
					var searchParameters = _ref11.searchParameters;

					var minRefinement = searchParameters.getNumericRefinements(this.attributeNameMin);
					var maxRefinement = searchParameters.getNumericRefinements(this.attributeNameMax);

					var min = $.isEmptyObject(minRefinement) ? "" : minRefinement["<="][0];
					var max = $.isEmptyObject(maxRefinement) ? "" : maxRefinement[">="][0];

					// If no max or min values are set, don't write anything to the URL
					if (min === "" && max === "") {
						return uiState;
					}

					var stateString = min + ':' + max;

					// If there's been no change, don't update the routing state
					if (uiState && uiState.range && uiState.range[this.attributeNameMin] === stateString) {
						return uiState;
					}

					return $.extend(true, {}, uiState, {
						range: _defineProperty({}, this.attributeNameMin, stateString)
					});
				}

				/**
     * Update the search state based on values stored in the routing state
     * @param {Object} searchParameters - The search state to update
     * @param {Object} uiState - The routing state
     * @memberOf DummyDoubleFacetNumbericSelector
     */

			}, {
				key: 'getWidgetSearchParameters',
				value: function getWidgetSearchParameters(searchParameters, _ref12) {
					var uiState = _ref12.uiState;

					var value = uiState && uiState.range && uiState.range[this.attributeNameMin];

					// Don't do anything if no min/max values are specified
					if (!value || value.indexOf(":") === -1) {
						return searchParameters;
					}

					var _value$split$map = value.split(":").map(parseFloat),
					    _value$split$map2 = _slicedToArray(_value$split$map, 2),
					    min = _value$split$map2[0],
					    max = _value$split$map2[1];

					// Set search refinements based on stored
					// min/max values


					if (!isNaN(min)) {
						searchParameters = searchParameters.addNumericRefinement(this.attributeNameMin, "<=", min);
					}

					if (!isNaN(max)) {
						searchParameters = searchParameters.addNumericRefinement(this.attributeNameMax, ">=", max);
					}

					return searchParameters;
				}

				/**
     * An empty init function to make this a valid
     * instantSearch widget
     * @memberOf DummyDoubleFacetNumbericSelector
     */

			}, {
				key: 'init',
				value: function init() {}
			}]);

			return DummyDoubleFacetNumbericSelector;
		}();

		/**
   * The SingleNumbericToggle is a custom Algolia instantSearch widget
   * that allows a numeric attribute to be toggled between no refinement
   * and a value greater than 0
   * @class
   */


		var SingleNumbericToggle = function (_CustomFilterWidget3) {
			_inherits(SingleNumbericToggle, _CustomFilterWidget3);

			/**
    *
    * @param {Object} options - Class options
    * @param {jQuery} options.$container - Widget container
    */
			function SingleNumbericToggle(options) {
				_classCallCheck(this, SingleNumbericToggle);

				var _this20 = _possibleConstructorReturn(this, (SingleNumbericToggle.__proto__ || Object.getPrototypeOf(SingleNumbericToggle)).call(this, options));

				_this20.elements = {
					$toggle: $(".js-numeric-toggle", options.$container)
				};

				_this20.attributeName = options.$container.data("filter-attribute");
				_this20.firstRender = true;

				// Add or remove the refinement when the checkbox is checked
				_this20.elements.$toggle.on("change", function () {
					if (_this20.helper) {
						_this20.helper.removeNumericRefinement(_this20.attributeName);

						if (_this20.elements.$toggle[0].checked) {
							_this20.helper.addNumericRefinement(_this20.attributeName, ">=", 1);
						}
						_this20.helper.search();
					}
				});

				_this20.dummyWidget = new DummySingleNumbericToggle(_this20.attributeName);
				return _this20;
			}

			/**
    * This object is a valid Algolia widget
    * @returns {Object} The Algolia instantSearch widget
    * @memberOf SingleNumbericToggle
    */


			_createClass(SingleNumbericToggle, [{
				key: 'getWidget',
				value: function getWidget() {
					return this;
				}

				/**
     * Get the facets for filtering
     * @memberOf SingleNumbericToggle
     * @returns {Object}
     */

			}, {
				key: 'getConfiguration',
				value: function getConfiguration() {
					return {
						disjunctiveFacets: [this.attributeName]
					};
				}

				/**
     * Store the helper on load
     * @param {Object} initOptions - Algolia init options
     * @memberOf SingleNumbericToggle
     */

			}, {
				key: 'init',
				value: function init(initOptions) {
					this.helper = initOptions.helper;
				}

				/**
     * The Algolia instantSearch Widget render function
     * @param {Object} renderOptions - Algolia render options
     * @memberOf SingleNumbericToggle
     */

			}, {
				key: 'render',
				value: function render(renderOptions) {
					var refinementActive = !!renderOptions.helper.getNumericRefinement(this.attributeName, ">=");

					this.elements.$toggle.prop("checked", refinementActive);
					this.toggleFilterActive(refinementActive);
				}

				/**
     * Remove the refinement when the user selects
     * the "Clear All" button
     * @memberOf SingleNumbericToggle
     */

			}, {
				key: 'clearAll',
				value: function clearAll() {
					if (this.helper) {
						this.helper.removeNumericRefinement(this.attributeName);
						this.helper.search();
					}
				}
			}]);

			return SingleNumbericToggle;
		}(CustomFilterWidget);

		/**
   * The DummySingleNumbericToggle is an instantSearch widget
   * that mocks the SingleNumbericToggle to update the state
   * of search contexts that don't have a full SingleNumbericToggle
   * and its associated DOM elements
   * @class
   */


		var DummySingleNumbericToggle = function () {
			function DummySingleNumbericToggle(attributeName) {
				_classCallCheck(this, DummySingleNumbericToggle);

				this.attributeName = attributeName;
			}

			/**
    * Get the facets for filtering
    * @memberOf DummySingleNumbericToggle
    * @returns {Object}
    */


			_createClass(DummySingleNumbericToggle, [{
				key: 'getConfiguration',
				value: function getConfiguration() {
					return {
						disjunctiveFacets: [this.attributeName]
					};
				}

				/**
     * Store search state information in the routing state
     * @param {Object} uiState - The routing state
     * @param {Object} searchParameters - The search state
     * @memberOf DummySingleNumbericToggle
     */

			}, {
				key: 'getWidgetState',
				value: function getWidgetState(uiState, _ref13) {
					var searchParameters = _ref13.searchParameters;

					var refinement = searchParameters.getNumericRefinements(this.attributeName);

					// If refinement not set or there's been no change,
					// don't update the routing state
					if ($.isEmptyObject(refinement) || uiState && uiState.range && uiState.range[this.attributeName] === "enabled") {
						return uiState;
					}

					return $.extend(true, {}, uiState, {
						range: _defineProperty({}, this.attributeName, "enabled")
					});
				}

				/**
     * Update the search state based on values stored in the routing state
     * @param {Object} searchParameters - The search state to update
     * @param {Object} uiState - The routing state
     * @memberOf DummySingleNumbericToggle
     */

			}, {
				key: 'getWidgetSearchParameters',
				value: function getWidgetSearchParameters(searchParameters, _ref14) {
					var uiState = _ref14.uiState;

					var value = uiState && uiState.range && uiState.range[this.attributeName];

					// Enable the refinement if it is enabled
					if (value === "enabled") {
						searchParameters = searchParameters.addNumericRefinement(this.attributeName, ">=", 1);
					}

					return searchParameters;
				}

				/**
     * An empty init function to make this a valid
     * instantSearch widget
     * @memberOf DummySingleNumbericToggle
     */

			}, {
				key: 'init',
				value: function init() {}
			}]);

			return DummySingleNumbericToggle;
		}();

		/**
   * The CategoryToggle is a custom Algolia instantSearch widget
   * that allows a string attribute to be toggled between no refinement
   * and a value.
   * @class
   */


		var CategoryToggle = function (_CustomFilterWidget4) {
			_inherits(CategoryToggle, _CustomFilterWidget4);

			/**
    *
    * @param {Object} options - Class options
    * @param {jQuery} options.$container - Widget container
    */
			function CategoryToggle(options) {
				_classCallCheck(this, CategoryToggle);

				var _this21 = _possibleConstructorReturn(this, (CategoryToggle.__proto__ || Object.getPrototypeOf(CategoryToggle)).call(this, options));

				_this21.elements = {
					$toggle: $(".js-facet-toggle", options.$container)
				};

				_this21.attributeName = options.$container.data("filter-attribute");
				_this21.firstRender = true;

				// Add or remove the refinement when the checkbox is checked
				_this21.elements.$toggle.on("change", function () {
					if (_this21.helper) {
						_this21.helper.removeDisjunctiveFacetRefinement(_this21.attributeName);

						if (_this21.elements.$toggle[0].checked) {
							_this21.helper.addDisjunctiveFacetRefinement(_this21.attributeName, "Yes");
						}
						_this21.helper.search();
					}
				});

				_this21.dummyWidget = new DummyCategoryToggle(_this21.attributeName);
				return _this21;
			}

			/**
    * This object is a valid Algolia widget
    * @returns {Object} The Algolia instantSearch widget
    * @memberOf SingleNumbericToggle
    */


			_createClass(CategoryToggle, [{
				key: 'getWidget',
				value: function getWidget() {
					return this;
				}

				/**
     * Get the facets for filtering
     * @memberOf SingleNumbericToggle
     * @returns {Object}
     */

			}, {
				key: 'getConfiguration',
				value: function getConfiguration() {
					return {
						disjunctiveFacets: [this.attributeName]
					};
				}

				/**
     * Store the helper on load
     * @param {Object} initOptions - Algolia init options
     * @memberOf SingleNumbericToggle
     */

			}, {
				key: 'init',
				value: function init(initOptions) {
					this.helper = initOptions.helper;
				}

				/**
     * The Algolia instantSearch Widget render function
     * @param {Object} renderOptions - Algolia render options
     * @memberOf SingleNumbericToggle
     */

			}, {
				key: 'render',
				value: function render(renderOptions) {
					var refinementActive = !!renderOptions.helper.getRefinements(this.attributeName).length;

					this.elements.$toggle.prop("checked", refinementActive);
					this.toggleFilterActive(refinementActive);
				}

				/**
     * Remove the refinement when the user selects
     * the "Clear All" button
     * @memberOf SingleNumbericToggle
     */

			}, {
				key: 'clearAll',
				value: function clearAll() {
					if (this.helper) {
						this.helper.removeDisjunctiveFacetRefinement(this.attributeName);
						this.helper.search();
					}
				}
			}]);

			return CategoryToggle;
		}(CustomFilterWidget);

		/**
   * The DummyCategoryToggle is an instantSearch widget
   * that mocks the CategoryToggle to update the state
   * of search contexts that don't have a full CategoryToggle
   * and its associated DOM elements
   * @class
   */


		var DummyCategoryToggle = function () {
			function DummyCategoryToggle(attributeName) {
				_classCallCheck(this, DummyCategoryToggle);

				this.attributeName = attributeName;
			}

			/**
    * Get the facets for filtering
    * @memberOf DummySingleNumbericToggle
    * @returns {Object}
    */


			_createClass(DummyCategoryToggle, [{
				key: 'getConfiguration',
				value: function getConfiguration() {
					return {
						disjunctiveFacets: [this.attributeName]
					};
				}

				/**
     * Store search state information in the routing state
     * @param {Object} uiState - The routing state
     * @param {Object} searchParameters - The search state
     * @memberOf DummySingleNumbericToggle
     */

			}, {
				key: 'getWidgetState',
				value: function getWidgetState(uiState, _ref15) {
					var searchParameters = _ref15.searchParameters;

					var refinement = searchParameters.getDisjunctiveRefinements(this.attributeName);

					// If refinement not set or there's been no change,
					// don't update the routing state
					if ($.isEmptyObject(refinement) || uiState && uiState.category && uiState.category[this.attributeName] === "enabled") {
						return uiState;
					}

					return $.extend(true, {}, uiState, {
						category: _defineProperty({}, this.attributeName, "enabled")
					});
				}

				/**
     * Update the search state based on values stored in the routing state
     * @param {Object} searchParameters - The search state to update
     * @param {Object} uiState - The routing state
     * @memberOf DummySingleNumbericToggle
     */

			}, {
				key: 'getWidgetSearchParameters',
				value: function getWidgetSearchParameters(searchParameters, _ref16) {
					var uiState = _ref16.uiState;

					var value = uiState && uiState.category && uiState.category[this.attributeName];

					// Enable the refinement if it is enabled
					if (value === "enabled") {
						searchParameters = searchParameters.addDisjunctiveFacetRefinement(this.attributeName, "Yes");
					}

					return searchParameters;
				}

				/**
     * An empty init function to make this a valid
     * instantSearch widget
     * @memberOf DummySingleNumbericToggle
     */

			}, {
				key: 'init',
				value: function init() {}
			}]);

			return DummyCategoryToggle;
		}();

		/**
   * The SortWidget is an instantSearch widget that
   * changes the search index to change the sort order.
   * Uses a set of radio buttons where each one
   * has the value of an index.
   * @class
   */


		var SortWidget = function () {
			/**
    *
    * @param {jQuery} $container - The container of sort elements
    */
			function SortWidget($container) {
				var _this22 = this;

				_classCallCheck(this, SortWidget);

				var $flyout = $(".js-sort-flyout");

				this.elements = {
					$container: $container,
					$selectors: $(".js-sort-item", $container),
					$toggle: $(".js-toggle-sort"),
					$close: $(".js-sort-close", $flyout),
					$flyout: $flyout
				};

				// Track whether the change came from a pointer (mouse/touch) vs keyboard
				var _pointerChange = false;
				$container.on("mousedown touchstart", function () {
					_pointerChange = true;
				});

				$container.on("change", function (event) {
					if (_this22.helper) {
						_this22._index = event.target.value;
						_this22.helper.setIndex(_this22.index).search();
						if (_pointerChange) {
							_pointerChange = false;
							_this22._closeFlyout();
						}
					}
				});

				// Set events to toggle whether the sort options are visible or not
				this.elements.$toggle.on("click", function () {
					var opening = !_this22.elements.$flyout.hasClass("active");
					_this22.elements.$flyout.toggleClass("active");
					_this22.elements.$toggle.attr("aria-expanded", opening ? "true" : "false");
					if (opening) {
						_this22.elements.$flyout.removeAttr("aria-hidden").prop("inert", false);
						setTimeout(function () {
							var $first = _this22.elements.$flyout.find("input[type='radio']").first();
							if (!$first.length) $first = _this22.elements.$flyout.find("input, button").first();
							if ($first.length) $first.focus();
						}, 50);
					} else {
						_this22.elements.$flyout.attr("aria-hidden", "true").prop("inert", true);
					}
				});
				this.elements.$close.on("click", function () {
					return _this22._closeFlyout();
				});

				$(document).on("keydown.sort-flyout", function (event) {
					if (event.key === "Escape" && _this22.elements.$flyout.hasClass("active")) {
						_this22._closeFlyout();
					}
				});

				$(document).on("click.sort-flyout-outside", function (event) {
					if (_this22.elements.$flyout.hasClass("active") && !_this22.elements.$flyout[0].contains(event.target) && !_this22.elements.$toggle[0].contains(event.target)) {
						_this22._closeFlyout();
					}
				});
				this.elements.$selectors.on('change', function () {
					if ($(this).is(':checked')) {
						var searchParam = $(this).next('label').text();
						var copy = $('.refinery-label').data('copy');
						$('.refinery-label').html(copy + ' <strong>' + searchParam + '</strong>');
					}
				});
			}

			_createClass(SortWidget, [{
				key: '_closeFlyout',
				value: function _closeFlyout() {
					this.elements.$flyout.removeClass("active").attr("aria-hidden", "true").prop("inert", true);
					this.elements.$toggle.attr("aria-expanded", "false");
					this.elements.$toggle.focus();
				}

				// When the index is externally updated, check the appropriate radio button

			}, {
				key: 'init',


				/**
     * Save the search helper on init
     * @param {Object} initOptions - instantSearch init options
     * @memberOf SortWidget
     */
				value: function init(initOptions) {
					this.helper = initOptions.helper;
				}

				/**
     * Store the sorting index in the routing state
     * @param {Object} uiState - The routing state
     * @param {Object} searchParameters - The search state
     * @memberOf SortWidget
     */

			}, {
				key: 'getWidgetState',
				value: function getWidgetState(uiState, _ref17) {
					var searchParameters = _ref17.searchParameters;

					if (uiState && uiState.sort && uiState.sort === this.index) {
						return uiState;
					}

					return $.extend(true, {}, uiState, {
						sort: this.index
					});
				}

				/**
     * Update the selected index based on the index stored in
     * the routing state.
     *
     * @param {Object} searchParameters - The search state
     * @param {Object} uiState - The routing state
     * @memberOf SortWidget
     */

			}, {
				key: 'getWidgetSearchParameters',
				value: function getWidgetSearchParameters(searchParameters, _ref18) {
					var uiState = _ref18.uiState;

					var index = uiState && uiState.sort;

					if (!index) {
						return searchParameters;
					}

					this.index = index;
					searchParameters = searchParameters.setIndex(index);
					return searchParameters;
				}
			}, {
				key: 'index',
				set: function set(value) {
					var _this23 = this;

					this._index = value;
					this.elements.$selectors.get().find(function (item) {
						return item.value === _this23._index;
					}).checked = true;
				},
				get: function get() {
					return this._index;
				}
			}]);

			return SortWidget;
		}();

		/**
   * The PaginationManager acts as the source of truth for the pagination
   * state of whether is it infinite or paginated. It also handles toggling
   * between the two modes due to buttons presses and screen resizing
   * between mobile and desktop.
   * The class is a valid Algolia InstantSearch custom widget.
   * Note that on desktop pagination can either be with pagination buttons,
   * or infinite loading while scrolling.
   * On mobile the only mode is infinite loading using a "Load More" button
   * (no scrolling).
   * @class
   */


		var PaginationManager = function () {
			/**
    * @param {jQuery} $container - The container of the entire search context
    */
			function PaginationManager($container) {
				var _this24 = this;

				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

				_classCallCheck(this, PaginationManager);

				this.$container = $container;

				this.infiniteListeners = [];
				this.mobile = this._checkMobile();
				this.options = options;

				if (this.options.desktopDefaultInfinite) {
					// Overide the desktop default of using pagination
					this.infinite = true;

					if (!this.mobile) {
						this.setupScroll();
					}
				} else {
					// On desktop by default there is pagination
					// On mobile by default its infinite load
					this.infinite = this.mobile;
				}

				// Listen for window resizing,
				// only perform an action if there's been a change
				$(window).on("resize orientationchange", function () {
					var currentMobile = _this24._checkMobile();
					if (currentMobile !== _this24.mobile) {
						// When switching to mobile enable infinite without scrolling
						if (currentMobile) {
							_this24.infinite = true;
							_this24.removeScroll();
							// When switching to desktop while on the first page, switch to pagination
						} else if (!_this24.options.desktopDefaultInfinite && _this24.helper && _this24.helper.getPage() === 0) {
							_this24.toggleMode();
							// When switching to desktop on another page setup infinite loading
						} else {
							_this24.setupScroll();
						}

						_this24.mobile = currentMobile;
						_this24.infiniteListeners.forEach(function (f) {
							return f(_this24.infinite);
						});
					}
				});
			}

			/**
    * Toggle between infinite scrolling and paginated pagination.
    * Should only be called on desktop since mobile
    * does not use scroll listeners.
    * @memberof PaginationManager
    */


			_createClass(PaginationManager, [{
				key: 'toggleMode',
				value: function toggleMode() {
					var _this25 = this;

					this.infinite = this.options.desktopDefaultInfinite || !this.infinite;
					this.infiniteListeners.forEach(function (f) {
						return f(_this25.infinite);
					});
					this.helper.setPage(0).search();

					if (this.infinite) {
						this.setupScroll();
					} else {
						this.removeScroll();
					}
				}

				/**
     * A listner function can be passed to hook into pagination changes
     * @callback infiniteChanged
     * @param {Boolean} infinite - Whether or not scrolling is infinite.
     */
				/**
     * Add functions to listen to pagination mode changes
     * @param {infiniteChanged} listener - A function to call when the pagination mode has changed
     * @memberof PaginationManager
     */

			}, {
				key: 'onChange',
				value: function onChange(listener) {
					this.infiniteListeners.push(listener);
				}

				/**
     * On widget init store the helper.
     * @param {Object} initOptions - InstantSearch widget init options
     * @memberof PaginationManager
     */

			}, {
				key: 'init',
				value: function init(initOptions) {
					this.helper = initOptions.helper;
				}

				/**
     * Create the scroll listener
     * @memberof PaginationManager
     */

			}, {
				key: 'setupScroll',
				value: function setupScroll() {
					var _this26 = this;

					$(window).off("scroll.view_all").on("scroll.view_all", $.throttle(200, function () {
						_this26._checkInfiniteLoad();
					}));
				}
				/**
     * Remove the scroll listener
     * @memberof PaginationManager
     */

			}, {
				key: 'removeScroll',
				value: function removeScroll() {
					$(window).off("scroll.view_all");
				}

				/**
     * Check if we've scrolled past the threshold and
     * need to load the next page.
     * @memberof PaginationManager
     * @private
     */

			}, {
				key: '_checkInfiniteLoad',
				value: function _checkInfiniteLoad() {
					if (this.helper && this.helper.getPage() !== this.helper.lastResults.nbPages - 1 && !this.helper.hasPendingRequests() && this.$container.height() + this.$container.offset().top - 1000 < $(document).scrollTop() + $(window).height()) {
						this.helper.nextPage().search();
					}
				}

				/**
     * Check if we should apply mobile logic
     * @memberof PaginationManager
     * @private
     * @return {Boolean} - Whether the page is mobile
     */

			}, {
				key: '_checkMobile',
				value: function _checkMobile() {
					return $(window).width() <= theme.bp.md;
				}
			}]);

			return PaginationManager;
		}();

		/**
   * The PaginationWidget is a wrapper for the Algolia InstantSearch
   * Pagination connector. It binds to the interactive part of pagination
   * elements to trigger pagination events. It also generates pagination
   * blips (1,2,3,4...).
   * @class
   */


		var PaginationWidget = function () {
			/**
    * @param {jQuery} $container - The container of pagination objects
    * @param {PaginationManager} manager - The search context's pagination manager
    */
			function PaginationWidget($container, manager) {
				var _this27 = this;

				_classCallCheck(this, PaginationWidget);

				this.elements = {
					$container: $container,
					$previous: $(".js-pagination-prev", $container),
					$next: $(".js-pagination-next", $container),
					$blips: $(".js-pagination-blips", $container),
					$viewall: $(".js-pagination-viewall", $container),
					$loadMore: $(".js-pagination-loadmore", $container)
				};

				this.manager = manager;
				// Toggle infinte styling on mode change
				this.manager.onChange(function (infinite) {
					_this27.elements.$container.toggleClass("infinite", infinite);
				});

				// Setup the connector and widget
				this.connector = instantsearch.connectors.connectPagination(this.render.bind(this));
				this.widget = this.connector({
					containerNode: $container,
					padding: 2
				});
			}

			/**
    * The render function called by the Algolia instantSearch library
    * @param {Object} renderOpts - Widget rendering options
    * @param {Boolean} isFirstRendering - Is first render
    */


			_createClass(PaginationWidget, [{
				key: 'render',
				value: function render(renderOpts, isFirstRendering) {
					var _this28 = this;

					this.elements.$blips.empty();

					this.currentPage = renderOpts.currentRefinement;
					this.totalPages = renderOpts.nbPages;

					// Setup events on first render
					if (isFirstRendering) {
						// Listen to click events on links to specfic pages
						this.elements.$container.on("click", ".js-pagination-page, .js-pagination-prev, .js-pagination-next", function (event) {
							var page = $(event.target).data("page");
							if (page !== _this28.currentPage) {
								renderOpts.refine(page);
							}

							// Scroll back to top
							$([document.documentElement, document.body]).animate({
								scrollTop: $(".js-collection-products").offset().top - 200
							}, 500);

							return false;
						});
						// Listen to the button that swaps between pagination and infinite loading
						this.elements.$viewall.on("click", function () {
							_this28.manager.toggleMode();
						});
						// Listen to the mobile only load more button
						this.elements.$loadMore.on("click", function () {
							renderOpts.refine(_this28.currentPage + 1);
						});
					}

					// In the pagination mode update the next/prev buttons and
					// render the page blips
					if (!this.manager.infinite) {
						var previousPage = renderOpts.isFirstPage ? this.currentPage : this.currentPage - 1;
						var nextPage = renderOpts.isLastPage ? this.currentPage : this.currentPage + 1;

						if (renderOpts.isFirstPage) {
							this.elements.$previous.hide().attr({ "aria-hidden": "true", tabindex: "-1" });
						} else {
							this.elements.$previous.show().removeAttr("aria-hidden").removeAttr("tabindex");
						}
						if (renderOpts.isLastPage) {
							this.elements.$next.hide().attr({ "aria-hidden": "true", tabindex: "-1" });
						} else {
							this.elements.$next.show().removeAttr("aria-hidden").removeAttr("tabindex");
						}

						this._updateButton(previousPage, renderOpts, this.elements.$previous);
						this._updateButton(nextPage, renderOpts, this.elements.$next);

						renderOpts.pages.forEach(function (page) {
							_this28.elements.$blips.append('<a href="' + renderOpts.createURL(page) + '" class="js-pagination-page ' + (page === _this28.currentPage ? " active" : "") + '" data-page="' + page + '" aria-label="Page ' + (page + 1) + '"' + (page === _this28.currentPage ? ' aria-current="page"' : "") + '>' + (page + 1) + '</a>');
						});

						if (!renderOpts.pages.includes(this.totalPages - 1)) {
							this.elements.$blips.append('\n              <span>.......</span>\n              <a href="' + renderOpts.createURL(this.totalPages - 1) + '" class="js-pagination-page" data-page="' + (this.totalPages - 1) + '" aria-label="Page ' + this.totalPages + '">' + this.totalPages + '</a>\n            ');
						}
					}

					this.elements.$loadMore.toggle(!renderOpts.isLastPage);
				}

				/**
     * The the Algolia instantSearch widget
     * @memberof PaginationWidget
     * @return {Object}
     */

			}, {
				key: 'getWidget',
				value: function getWidget() {
					return this.widget;
				}

				/**
     * Update the url and data of a button to link to
     * a specifc page.
     * @param {Number} page - The page number to link to
     * @param {Object} renderOpts - The rendering options
     * @param {jQuery} $button - The button to update
     * @memberof PaginationWidget
     */

			}, {
				key: '_updateButton',
				value: function _updateButton(page, renderOpts, $button) {
					var url = renderOpts.createURL(page);
					$button.attr("href", url).data("page", page);
				}
			}]);

			return PaginationWidget;
		}();

		/**
   * The ViewAllSingle is a Algolia InstantSearch widget to handle
   * a toggle button that switches between view all and pagineted
   * pagination.
   * @class
   */


		var ViewAllSingle = function () {
			/**
    * @param {jQuery} $container - The container of view all button
    * @param {PaginationManager} manager - The search context's pagination manager
    */
			function ViewAllSingle($container, manager) {
				_classCallCheck(this, ViewAllSingle);

				this.$container = $container;
				this.manager = manager;
			}

			_createClass(ViewAllSingle, [{
				key: 'init',
				value: function init() {
					var _this29 = this;

					// Toggle infinte styling on mode change
					this.manager.onChange(function (infinite) {
						_this29.$container.toggleClass("infinite", infinite);
					});

					// Listen to the button that swaps between pagination and infinite loading
					$(".js-pagination-viewall", this.$container).on("click", function () {
						_this29.manager.toggleMode();
					});
				}
			}]);

			return ViewAllSingle;
		}();

		/**
   * The LoadMoreButton is a simple instantSearch
   * widget that wraps a "Load More" button and
   * increments the page when it is pressed.
   * This is used on the search page where the
   * only method of pagination is this button,
   *
   * @class
   */


		var LoadMoreButton = function () {
			function LoadMoreButton($button) {
				_classCallCheck(this, LoadMoreButton);

				this.$button = $button;
			}

			_createClass(LoadMoreButton, [{
				key: 'init',
				value: function init(initOptions) {
					var _this30 = this;

					this.helper = initOptions.helper;

					// Load the next page on click
					this.$button.on("click", function () {
						_this30.helper.nextPage().search();
					});
				}

				/**
     * Disable the button when on the last page
     * @param {Object} renderOptions - Render options
     */

			}, {
				key: 'render',
				value: function render(renderOptions) {
					this.$button.prop("disabled", this.helper.getPage() >= this.helper.lastResults.nbPages - 1);
				}
			}]);

			return LoadMoreButton;
		}();
		/**
   * The DualHitsWidget is a custom Algolia instantSearch
   * widget that renders product tiles.
   * It takes into account the current pagination mode and
   * updates or appends product tiles as appropriate.
   * @prop {Number} lastPage - The previously loaded page
   */


		var DualHitsWidget = function () {
			/**
    * @param {jQuery} $container - The container to place product tiles in
    * @param {jQuery} $informationBlock - An information block to render after 6 hits
    * @param {PaginationManager} paginationManager - The pagination manager
    */
			function DualHitsWidget($container, $informationBlock, paginationManager) {
				_classCallCheck(this, DualHitsWidget);

				this.elements = {
					$container: $container,
					$informationBlock: $informationBlock
				};
				this.paginationManager = paginationManager;
				this.lastPage = -1;
				this.firstRender = true;
				this.infoBlockPosition = this.elements.$container.data("info-block-position") || "middle";
			}

			/**
    * Group all variants with the same product id
    * @param {[Object]} hits - Array of Algolia product hits
    */


			_createClass(DualHitsWidget, [{
				key: '_rollUpHits',
				value: function _rollUpHits(hits) {
					return Object.values(hits.reduce(function (acc, hit) {
						if (acc[hit.id] === undefined) {
							hit.variants = [hit];
							acc[hit.id] = hit;
						} else {
							acc[hit.id].variants.push(hit);
						}

						return acc;
					}, {}));
				}

				/**
     * The instantSearch widget render function
     * @param {Object} renderOptions - Render options
     */

			}, {
				key: 'render',
				value: function render(renderOptions) {
					// There could be a difference between the requested and rendered page
					// if the results haven't been returned from Algolia yet
					var renderedPage = renderOptions.results.page;
					var requestedPage = renderOptions.helper.getPage();

					// Reset the container when on the first page or during normal pagination
					if (requestedPage === 0 || !this.paginationManager.infinite) {
						if (this.firstRender) {
							this.firstRender = false;
						}

						this.elements.$container.empty();
						this.lastPage = -1;
					}

					this.elements.$container.toggleClass("infoblock-visible", renderedPage === 0 || this.paginationManager.infinite);

					var tiles = this._rollUpHits(renderOptions.results.hits).map(function (item) {
						var productTile = theme.TileFactory.create("product", item);
						return productTile.render();
					});

					if (!this.paginationManager.infinite || this.lastPage < renderedPage) {
						var _$container = $('<div class="product-list container container--collection"></div>');
						var $output = void 0;

						// Wrap product tiles in '.container' elements before appending
						if (this.elements.$informationBlock.length > 0 && renderedPage === 0 && this.elements.$informationBlock.length > 0 && this.infoBlockPosition == "middle") {
							// Insert an information block after the 6th element
							if (tiles.length > 6) {
								$output = _$container.clone().append(tiles.slice(0, 6).join("")) // Add the first 6 tiles
								.add(this.elements.$informationBlock.children().clone()) // Add the information block
								.add(_$container.clone().append(tiles.slice(6).join(""))); // Add the remaining tiles
							} else {
								$output = _$container.append(tiles.join("")).add(this.elements.$informationBlock.children().clone()); // Add the information block after all the tiles
							}
						} else {
							$output = _$container.append(tiles.join(""));
						}

						// Append the product tiles and signal that loading is done
						this.elements.$container.append($output).removeClass("algolia-loading");
					}

					this.lastPage = renderedPage;
				}
			}]);

			return DualHitsWidget;
		}();

		/**
   * The SimpleHitsWidget is a custom Algolia instantSearch
   * widget that renders simple product tiles.
   */


		var SimpleHitsWidget = function () {
			/**
    * @param {jQuery} $container - The container to place product tiles in
    */
			function SimpleHitsWidget($container) {
				_classCallCheck(this, SimpleHitsWidget);

				this.elements = {
					$container: $container
				};
			}

			/**
    * Group all variants with the same product id
    * @param {[Object]} hits - Array of Algolia product hits
    */


			_createClass(SimpleHitsWidget, [{
				key: '_rollUpHits',
				value: function _rollUpHits(hits) {
					return Object.values(hits.reduce(function (acc, hit) {
						if (acc[hit.id] === undefined) {
							hit.variants = [hit];
							acc[hit.id] = hit;
						} else {
							acc[hit.id].variants.push(hit);
						}

						return acc;
					}, {}));
				}

				/**
     * The instantSearch widget render function
     * @param {Object} renderOptions - Render options
     */

			}, {
				key: 'render',
				value: function render(renderOptions) {
					var tiles = this._rollUpHits(renderOptions.results.hits).map(function (item) {
						var productTile = theme.TileFactory.create("simple-product", item, {
							style: ""
						});
						return productTile.render();
					});

					var $container = $('<div class="search-dropdown__results"></div>');
					var $output = void 0;

					$output = $container.append(tiles.join(""));

					// Append the product tiles and signal that loading is done
					this.elements.$container.html($output).removeClass("algolia-loading");
				}
			}]);

			return SimpleHitsWidget;
		}();

		/**
   * The ResultHitCount widget writes the
   * number of results in a container
   * @class
   */


		var ResultHitCount = function () {
			function ResultHitCount($container) {
				_classCallCheck(this, ResultHitCount);

				this.$container = $container;
			}

			_createClass(ResultHitCount, [{
				key: 'render',
				value: function render(renderOpts) {
					this.$container.html(renderOpts.results.nbHits);
				}
			}]);

			return ResultHitCount;
		}();

		/**
   * The SearchForm widget listens to form events on
   * the search box and updates the query based on
   * the entered search term
   * @class
   */


		var SearchForm = function () {
			function SearchForm($form) {
				_classCallCheck(this, SearchForm);

				this.$form = $form;
				this.$input = $(".js-search-box", this.$form);
			}

			_createClass(SearchForm, [{
				key: 'init',
				value: function init(initOptions) {
					var _this31 = this;

					var $html = $("html");
					this.helper = initOptions.helper;

					this.$form.on("submit", function (event) {
						event.preventDefault();
						_this31._updateQuery(_this31.$input.val());
					});

					this.$input.on("input", $.debounce(250, function () {
						_this31._updateQuery(_this31.$input.val());
						_this31.$input.val() !== "" ? $html.addClass("has-search-dropdown-open") : $html.removeClass("has-search-dropdown-open");

						$(".js-search-dropdown-cta").attr("href", "/search?q=" + _this31.$input.val());
					}));
				}

				/**
     * Update the current search query if the term is valid
     * @param {String} term - The search term
     * @memberOf SearchForm
     */

			}, {
				key: '_updateQuery',
				value: function _updateQuery(term) {
					if (!term && term !== "" || term.length < 3) {
						return;
					}

					this.helper.setQuery(term).search();
				}

				/**
     * Update the routing state based on the search state
     * @param {Object} uiState - Current routing state
     * @param {Object} searchParameters - search state
     * @memberOf SearchForm
     */

			}, {
				key: 'getWidgetState',
				value: function getWidgetState(uiState, _ref19) {
					var searchParameters = _ref19.searchParameters;

					var query = searchParameters.query;

					// Don't update the state if there are no changes
					if (!query || uiState.q === query) {
						return uiState;
					}

					// Store the query
					return $.extend(true, {}, uiState, {
						q: query
					});
				}

				/**
     * Update the search state based on the routing state
     * @param {Object} searchParameters - The search state
     * @param {Object} uiState - The routing state
     * @memberOf SearchForm
     */

			}, {
				key: 'getWidgetSearchParameters',
				value: function getWidgetSearchParameters(searchParameters, _ref20) {
					var uiState = _ref20.uiState;

					var query = uiState.q;

					// If there are no values, don't update the search
					if (query === undefined) return searchParameters;

					// Set the query
					return searchParameters.setQuery(query);
				}
			}]);

			return SearchForm;
		}();

		/**
   * A custom Algolia widget to output the
   * current search query to a specified container
   * @class
   */


		var ResultTerm = function () {
			function ResultTerm($container) {
				_classCallCheck(this, ResultTerm);

				this.$container = $container;
			}

			_createClass(ResultTerm, [{
				key: 'render',
				value: function render(renderOpts) {
					this.$container.text(renderOpts.helper.getQuery().query);
				}
			}]);

			return ResultTerm;
		}();

		/**
   * A customer Algolia widget to toggle a class
   * based on whether there are any results
   * @class
   */


		var ResultsToggle = function () {
			function ResultsToggle($container) {
				_classCallCheck(this, ResultsToggle);

				this.$container = $container;
				this.inactiveClass = this.$container.data("toggle-class");
			}

			_createClass(ResultsToggle, [{
				key: 'render',
				value: function render(renderOpts) {
					this.$container.toggleClass(this.inactiveClass, renderOpts.results.nbHits === 0);
				}
			}]);

			return ResultsToggle;
		}();

		/**
   * The FilterSortContexts creates the Algolia instantSearch
   * search contexts, creates all widgets, and handles state swapping.
   * @class
   */


		var FilterSortContexts = function () {
			function FilterSortContexts($container) {
				var _this32 = this;

				_classCallCheck(this, FilterSortContexts);

				this.elements = {
					$container: $container,
					$filterWidgetContainer: $(".js-filter-flyout-widgets", $container),
					$collectionHitsContainer: $(".js-collection-products", $container),
					$filterNavContainer: $(".js-filter-nav", $container),
					$applyButton: $(".js-filter-apply", $container),
					$filterFlyout: $(".js-filter-flyout", $container),
					$informationBlock: $(".js-product-information-block", $container).eq(0),
					$sort: $(".js-collection-sort", $container),
					$collectionPagination: $(".js-pagination-container", $container),
					$hitCount: $(".js-hit-results-count", $container),
					$searchCount: $(".js-search-results-count", $container),
					$searchLoadMore: $(".js-search-load-more", $container),
					$searchForm: $(".js-hook-search"),
					$searchTerms: $(".js-search-terms", $container),
					$searchResultsToggle: $(".js-search-results-toggle", $container),
					$searchDropdownHitsContainer: $(".js-search-dropdown-results", $container),
					$viewAllSingle: $(".js-viewall-single", $container)
				};

				// TODO: rename to shopify_products
				this.initialIndex = theme.algolia_keys.prefix + 'products';

				var filters = [];
				var searchFilters = [];
				var initial_filter_parameters = {
					distinct: 100
				};
				var initial_search_parameters = Object.assign({}, initial_filter_parameters);

				initial_filter_parameters.hitsPerPage = 10;
				initial_search_parameters.hitsPerPage = 9;

				filters.push("tags:b2c");

				// Split the context between collection and search
				filters.push("NOT meta.field.do_not_display:true");
				searchFilters = [].concat(filters);

				if (this.elements.$container.data("collection-handle")) {
					filters.push("collections:" + this.elements.$container.data("collection-handle"));
				}

				if (filters.length > 0) {
					initial_filter_parameters.filters = filters.join(" AND ");
				}

				if (searchFilters.length > 0) {
					initial_search_parameters.filters = searchFilters.join(" AND ");
				}

				/**
     * 1. INITIALIZE SEARCH CONTEXTS
     * Two search contexts are created. The main displayContext renders
     * this. Filtering is seperated into a second context which allows
     * us to "preview" filter operations and apply/reset filter operations
     * to the main search context.
     * Widgets in the filter context have their own "Dummy" widgets in the
     * display context to handle Algolia Routing (updates to url bar).
     * Full responsibility of the context:
     * Display Context:
     *     -Renders hits
     *     -Sorting
     *     -Dummy filter widgets
     *     -Routing (search state in url bar)
     *     -Pagination
     *     -Results count
     * Filter Context:
     *     -Filter widgets
     */

				var contextOptions = {
					indexName: this.initialIndex,
					routing: true
				};

				if (theme.search) {
					contextOptions.searchClient = theme.search;
				} else {
					contextOptions.appId = theme.algolia_keys.appId;
					contextOptions.apiKey = theme.algolia_keys.apiKey;
				}

				var searchContextOptions = Object.assign({}, contextOptions);

				contextOptions.searchParameters = initial_filter_parameters;
				searchContextOptions.searchParameters = initial_search_parameters;

				this.displayContext = instantsearch(contextOptions);
				this.searchContext = instantsearch(searchContextOptions);
				theme.search = theme.search || this.displayContext.client;

				this.filterContext = instantsearch({
					indexName: this.initialIndex,
					routing: false,
					searchClient: theme.search
				});

				/**
     * 2. SETUP THE PAGINATION MANAGER
     */

				// data-force-infinite may be on a specific element in the matched set
				// (e.g. the search section), not necessarily the first element.
				var $forceInfiniteEl = this.elements.$container.filter("[data-force-infinite]");
				if (!$forceInfiniteEl.length) {
					$forceInfiniteEl = this.elements.$container.first();
				}

				var pagination_options = {
					desktopDefaultInfinite: $forceInfiniteEl.is("[data-force-infinite]")
				};

				this.paginationManager = new PaginationManager($forceInfiniteEl, pagination_options);
				this.displayContext.addWidget(this.paginationManager);

				/**
     * 3. INITIALIZE FILTER WIDGETS
     */
				new initFilterNav($container, this.filterContext, this.displayContext);

				/**
     * 4. INITIALIZE DUAL HITS WIDGET
     */
				if (this.elements.$collectionHitsContainer.length > 0) {
					var hitsWidget = new DualHitsWidget(this.elements.$collectionHitsContainer, this.elements.$informationBlock, this.paginationManager);
					this.displayContext.addWidget(hitsWidget);
				}

				/**
     * 5. INITIALIZE SIMPLE HITS WIDGET
     */
				if (this.elements.$searchDropdownHitsContainer.length > 0) {
					var _hitsWidget = new SimpleHitsWidget(this.elements.$searchDropdownHitsContainer);
					this.searchContext.addWidget(_hitsWidget);
				}

				/**
     * 6. INITIALIZE SORT WIDGET
     */
				if (this.elements.$sort.length > 0) {
					var sortWidget = new SortWidget(this.elements.$sort);
					this.displayContext.addWidget(sortWidget);
				}

				/**
     * 7. INITIALIZE PAGINATION WIDGETS
     */
				if (this.elements.$collectionPagination.length > 0) {
					var pagninationWidget = new PaginationWidget(this.elements.$collectionPagination, this.paginationManager);
					this.displayContext.addWidget(pagninationWidget.getWidget());
				}

				// The load more button for the search page
				if (this.elements.$searchLoadMore.length > 0) {
					var loadMoreWidget = new LoadMoreButton(this.elements.$searchLoadMore);
					this.displayContext.addWidget(loadMoreWidget);
				}

				if (this.elements.$viewAllSingle.length > 0) {
					var viewAllButton = new ViewAllSingle(this.elements.$viewAllSingle, this.paginationManager);
					this.displayContext.addWidget(viewAllButton);
				}

				/**
     * 8. INITIALIZE RESULTS COUNT WIDGET
     */
				if (this.elements.$hitCount.length > 0) {
					var _hitsWidget2 = new ResultHitCount(this.elements.$hitCount);
					this.displayContext.addWidget(_hitsWidget2);

					var searchHitsWidget = new ResultHitCount(this.elements.$searchCount);
					this.searchContext.addWidget(searchHitsWidget);
				}

				/**
     * 9. SETUP SEARCH FORM
     */
				if (this.elements.$searchForm.length > 0) {
					var searchFormWidget = new SearchForm(this.elements.$searchForm);
					this.searchContext.addWidget(searchFormWidget);

					if (theme.template.name === "search") {
						this.displayContext.addWidget(searchFormWidget);
					}
				}

				/**
     * 10. SETUP TERM WIDGET
     */

				if (this.elements.$searchTerms.length > 0) {
					var termsWidget = new ResultTerm(this.elements.$searchTerms);
					this.searchContext.addWidget(termsWidget);
				}

				/**
     * 11. SETUP RESULTS TOGGLE WIDGET
     */
				if (this.elements.$searchResultsToggle.length > 0) {
					var toggle = new ResultsToggle(this.elements.$searchResultsToggle);
					this.displayContext.addWidget(toggle);
				}

				/**
     * 12. SETUP FILTER FLYOUT EVENTS
     */
				this.elements.$filterFlyout.on("Flyout:open", function () {
					_this32.elements.$filterFlyout.addClass("flyout-open");
					// Update state again to push events such as sort and pagination
					_this32._forwardState();
				}).on("Flyout:close", function () {
					_this32.elements.$filterFlyout.removeClass("flyout-open");
					// Reset the state when the user cancels or closes the flyout
					_this32._forwardState();
				});

				this.elements.$applyButton.on("click", function () {
					_this32.elements.$filterFlyout.trigger("Flyout:trigger-close");
					_this32._acceptState();
				});

				// Desktop filter nav filtering - when a user clicks on a filter label or clear btn, the filtering is applied
				this.elements.$filterNavContainer.on("click", function (e) {
					var $target = $(e.target);
					var $filterLabel = $target.hasClass("filter-widget__refinement-label");
					var $clearBtn = $target.hasClass("js-filter-clear");
					if ($filterLabel || $clearBtn) $.debounce(300, function () {
						return _this32._acceptState();
					})();
				});

				// Desktop filter nav filtering - uses a slider to filter
				this.elements.$filterNavContainer.on("slidestop", ".js-filter-items", function () {
					$.debounce(300, function () {
						return _this32._acceptState();
					})();
				});

				// Desktop filter nav filtering - uses checkboxes to filter
				this.elements.$filterNavContainer.on("click", ".collection-filter__numeric-toggle-label", $.debounce(300, function () {
					_this32._acceptState();
				}));

				/**
     * 13. START THE SEARCH AND SET INITIAL STATE
     */
				this.displayContext.start();
				this.searchContext.start();
				this.filterContext.start();

				this._forwardState();
			}

			/**
    * Update the filter context with the current state.
    * Resets the filter context
    * @memberOf FilterSortContexts
    * @private
    */


			_createClass(FilterSortContexts, [{
				key: '_forwardState',
				value: function _forwardState() {
					this.filterContext.helper.setState(this.displayContext.helper.getState()).search();
				}

				/**
     * Apply any updates from the filter context to
     * the main display context
     * @memberOf FilterSortContexts
     * @private
     */

			}, {
				key: '_acceptState',
				value: function _acceptState() {
					this.displayContext.helper.setState(this.filterContext.helper.getState()).search();
				}
			}]);

			return FilterSortContexts;
		}();

		var initFilterNav = function initFilterNav($container, $filterContext, $displayContext) {
			_classCallCheck(this, initFilterNav);

			this.elements = {
				$container: $container,
				$filterContext: $filterContext,
				$displayContext: $displayContext
			};
			$(".js-filter-widget", this.elements.$filterWidgetContainer).get().map(function (value) {
				var $widget = $(value);
				// Create a new widget based on specified type
				switch ($widget.data("filter-type")) {
					case "refinement":
						return new LabeledRefinementList({
							parentContainer: $container[0],
							$container: $widget
						});
					case "doublenumeric":
						return new DoubleFacetNumbericSelector({
							$container: $widget
						});
					case "numerictoggle":
						return new SingleNumbericToggle({
							$container: $widget
						});
					case "facettoggle":
						return new CategoryToggle({
							$container: $widget
						});
				}
			}).forEach(function (widget) {
				if (!widget) {
					return;
				}

				// Add the final widgets to the contexts
				$filterContext.addWidget(widget.getWidget());
				$displayContext.addWidget(widget.getDummyWidget());
			});
		};

		var $container = $(".js-search-context-container");

		if ($container.length > 0) {
			if (window.theme.template.name === "collection" || window.theme.template.name === "search") {
				new FilterSortContexts($container);
			} else {
				var initialized = false;
				var $input = $(".js-search-box");
				$input.on("input.initialize", function () {
					if (!initialized) {
						var query = $input.val();
						if (query && query.length >= 2) {
							initialized = true;
							new FilterSortContexts($container);
							$input.off("input.initialize");
						}
					}
				});
			}
		}
	});
})(window.theme = window.theme || {}, jQuery);

/**
 * PRODUCTS
 *
 * @description Keeps track of all the products on the page
 * @namespace products
 */

(function (theme, $) {
	/**
  * Class representing the products object.
  */
	var Products = function () {

		/**
   * Creates an instance of Products.
   *
   * @param {object} [products] - An object of product objects with the handle as the key.
   * @constructs Products
   * @memberof Products
   */
		function Products(products) {
			_classCallCheck(this, Products);

			this._list = products || {};
		}

		// ------------------------------
		//  Getters and Setters
		// ------------------------------

		/**
   * The product list object.<br><br>
   * @example
   * // Get the product list
   * theme.products.list
   *
   * @type {object}
   * @memberof Products
   */


		_createClass(Products, [{
			key: 'update',


			// ------------------------------
			//  Methods
			// ------------------------------

			/**
    * Update the product list.
    * If the product doesn't exist, it will be added.
    * If the product exists, it will be updated. Parameters would be updated, not replaced.
    *
    * @param {(object|object[])} products - Product, object of products or array of products to add to the list.
    * @fires products_add
    * @fires products_change
    * @memberof Products
    * @example
    * // Examples use the following list:
    * // {
    * // 	product-a: { handle: 'product-a', title: 'Product A' },
    * // 	product-b: { handle: 'product-b', title: 'Product B' }
    * // }
    *
    * // Add 1 product
    * theme.products.update({ handle: 'product-c', title: 'Product C' });
    *
    * // Add product array
    * theme.products.update([
    * 	{ handle: 'product-c', title: 'Product C' },
    * 	{ handle: 'product-d', title: 'Product D' }
    * ]);
    *
    * // Add multiple product object
    * theme.products.update({
    * 	product-c: { handle: 'product-c', title: 'Product C' },
    * 	product-d: { handle: 'product-d', title: 'Product D' }
    * });
    *
    * // If the product exists, it will update the passed parameters
    * // Will result in product a having the following structure:
    * // { handle: 'product-a', title: 'Product A', price: 1200 }
    * theme.products.update({ handle: 'product-a', price: 1200 });
    */
			value: function update(products) {
				var _this33 = this;

				if (!products || (typeof products === 'undefined' ? 'undefined' : _typeof(products)) !== 'object') {
					return false;
				}

				// Convert to array if single product is passed
				if (products.handle) {
					products = [products];
				} else if (!Array.isArray(products)) {
					// Convert object of products into array of products
					products = Object.keys(products).map(function (key) {
						return products[key];
					}).filter(function (product) {
						return product.handle;
					});
				}

				products.forEach(function (product) {
					if (product.handle) {
						// If the product doesn't exists, add it, otherwise update it
						if (!_this33._list[product.handle]) {
							_this33._list[product.handle] = product;

							/**
        * Products have been added to the global list.
        * The event is attached to the document element.<br><br>
        *
        * @event products_add
        * @property {object} product_added - The added product
        * @memberof Products
        * @example
        * $(document).on('products_add', function(event, product_added) {});
        */
							$(document).trigger('products_add', product);
						} else {
							var product_updated = theme.utils.modifyObject(_this33._list[product.handle], product);
							_this33._list[product.handle] = product_updated;

							/**
        * Product has been updated on the global list.
        * The event is attached to the document element.<br><br>
        *
        * @event products_update
        * @property {object} product_updated - The updated product
        * @memberof Products
        * @example
        * $(document).on('products_update', function(event, product) {});
        */
							$(document).trigger('products_update', product_updated);
						}
					}
				});
			}
		}, {
			key: 'list',
			get: function get() {
				return this._list;
			},
			set: function set(cart) {
				// Don't allow the list to be overwritten
				return false;
			}
		}]);

		return Products;
	}();

	// Global export and initialization
	// Uses the products stored by the global object if available


	theme.products = new Products(theme.products && theme.products.list ? theme.products.list : {});
})(window.theme = window.theme || {}, jQuery);
/**
 * FLYOUT LIBRARY
 *
 * @description Handles flyout elements.
 * @namespace Flyout
 *
 * TODO: Option to hide flyout when disabled or disable flyout functionality when disabled
 */
(function (theme, $) {

	/**
  * Class names.
  *
  * @private
  * @const
  * @type {Object}
  */
	var CLASSES = {
		noScroll: 'no-scroll',
		flyoutActive: {
			left: 'flyout-active-left',
			right: 'flyout-active-right'
		},
		flyoutHidden: {
			left: 'flyout-hidden-left',
			right: 'flyout-hidden-right'
		}

		/**
   * Class representing a flyout element.
   *
   * @classdesc Creates Flyout objects out of elements with the class <code>js-flyout</code> and the data attribute <code>data-flyout-id</code>, where the value is a unique id. The element can optionally have a <code>data-flyout-options</code> attribute, where the value is a JSON object that can have
   *<br><br>
   * 1) a <code>max</code> and/or <code>min</code> property with a value, indicating the maximum or minimum screensize (in pixels) on which the flyout will be enabled.
   * <br>
   * 2) a <code>direction</code> property with the value <code>left</code> or <code>right</code>, which indicates which side the flyout will display from. The default direction is <code>right</code>.
   * <br><br>
   * A Flyout object requires trigger elements to open/close the flyout, with the data attribute <code>data-flyout-open</code>, <code>data-flyout-close</code>, or <code>data-flyout-toggle</code>. The value of the data attribute must be the data-flyout-id of the flyout element being targeted
   *
   * @example
   * <div class="flyout js-flyout" data-flyout-id="my-flyout" data-flyout-options="{'direction':'right','max':500,'min':200}">
   * This Is My Flyout
   * </div>
   * <button data-flyout-toggle="my-flyout">Toggle Flyout</button>
   *
   * @property {object} elements - Contains the flyout and its triggers
   * @property {string} id - The flyout ID
   * @property {json} options - options for the flyout
   * @property {string} [options.direction] - direction from which the flyout will appear
   * @property {string} [options.max] - max screen width at which this will be enabled
   * @property {string} [options.min] - min screen width at which this will be enabled
   * @property {string} direction - Optional direction extracted from options; default is right
   * @property {string} max - Optional max extracted from options
   * @property {string} min - Optional min extracted from options
   */

	};
	var Flyout = function () {

		/**
   * Creates an instance of Flyout.
   *
   * @param {jQuery} $flyout - The flyout element.
   * @constructs Flyout
   * @memberof flyout
   */
		function Flyout($flyout) {
			_classCallCheck(this, Flyout);

			if (!$flyout) {
				console.error('Flyout.constructor: No element was passed.');
				return false;
			}

			this.elements = {
				flyout: $flyout
			};
			this.id = $flyout.data('flyout-id') || false;
			this.options = $flyout.data('flyout-options') || false;

			if (typeof this.options == 'string') {
				eval('this.options=' + this.options);
			}

			this.direction = this.options.direction && (this.options.direction == 'left' || this.options.direction == 'right') ? this.options.direction : 'right';

			this.max = this.options.max && Math.floor(this.options.max) != this.options.max && !$.isNumeric(this.options.max) || this.max < 0 ? -1 : this.options.max;
			this.min = this.options.min && Math.floor(this.options.min) != this.options.min && !$.isNumeric(this.options.min) || this.options.min < 0 ? -1 : this.options.min;

			this.disabled = this._isDisabled();
			this.hidden = false;

			if (this.id) {
				this._bindTriggers();
				this._addRoles();
				this._hideFlyout();
				this._run();
			}
		}

		// ------------------------------
		//  Methods
		// ------------------------------

		/**
   *	Listens and re-checks on window resize to see if the flyout should be disabled
   *
   * @private
   * @memberof Flyout
   */


		_createClass(Flyout, [{
			key: '_run',
			value: function _run() {
				var _this34 = this;

				$(window).resize(function () {
					_this34._refresh();
				});
			}

			/**
    * checks to see if flyout should be disabled, rebinds triggers, hides the flyout.
    *
    * @private
    * @memberof Flyout
    */

		}, {
			key: '_refresh',
			value: function _refresh() {
				this.disabled = this._isDisabled();
				this._bindTriggers();
				this._addRoles();
				this._hideFlyout(false);
			}

			/**
    * Checks if window size is smaller than min or larger than max.
    *
    * @private
    * @memberof Flyout
    */

		}, {
			key: '_isDisabled',
			value: function _isDisabled() {
				if (this.max == -1 || this.min == -1) {
					return true;
				}

				var disabled = this.max < $(window).outerWidth() || this.min > $(window).outerWidth();

				if (disabled) {
					this.elements.flyout.removeClass('flyout');
				} else {
					this.elements.flyout.addClass('flyout');
				}
				return disabled;
			}

			/**
    * Adds accessibility roles to a trigger element.
    *
    * @param {jQuery} $elem - The trigger to check for accessibility roles.
    * @private
    * @memberof Flyout
    */

		}, {
			key: '_addRole',
			value: function _addRole($elem) {
				var tag = ($elem.prop('tagName') || '').toLowerCase();
				if (tag && tag !== 'button' && tag !== 'a' && $elem.attr('type') !== 'submit' && !$elem.attr('role') && $elem.attr('aria-hidden') !== 'true') {
					$elem.attr('role', 'button');
				}
			}

			/**
    * Adds accessibility roles to all trigger elements. Must be run after this._bindTriggers.
    *
    * @private
    * @memberof Flyout
    */

		}, {
			key: '_addRoles',
			value: function _addRoles() {
				var _this35 = this;

				$([this.elements.toggle, this.elements.open, this.elements.close]).each(function (index, element) {
					_this35._addRole($(element));
				});
			}

			/**
    * Internal method that binds flyout triggers, based on the flyout element's ID, and adds them to <code>flyout.elements</code>. Handles click events. Note that trigger elements which are loaded through AJAX will have to be re-bound.
    *
    * @private
    * @memberof Flyout
    */

		}, {
			key: '_bindTriggers',
			value: function _bindTriggers() {
				var _this36 = this;

				this.elements.toggle = $('[data-flyout-toggle=' + this.id + ']');
				this.elements.open = $('[data-flyout-open=' + this.id + ']');
				this.elements.close = $('[data-flyout-close=' + this.id + ']');

				if (this.disabled) {
					$(this.elements.toggle).off('click.flyout');
					$(this.elements.open).off('click.flyout');
					$(this.elements.close).off('click.flyout');
					return false;
				}

				$(this.elements.toggle).off('click.flyout keypress.flyout').on('click.flyout keypress.flyout', function (e) {
					if (e.type == 'click' || e.key === 'Enter') {
						e.preventDefault();
						_this36.elements.last_clicked = $(e.target).closest('button, a, input, select, textarea, [tabindex]');
						_this36.toggle();
					}
				});

				$(this.elements.open).off('click.flyout keypress.flyout').on('click.flyout keypress.flyout', function (e) {
					if (e.type == 'click' || e.key === 'Enter') {
						e.preventDefault();
						_this36.elements.last_clicked = $(e.target).closest('button, a, input, select, textarea, [tabindex]');
						_this36.open();
					}
				});

				$(this.elements.close).off('click.flyout keypress.flyout').on('click.flyout keypress.flyout', function (e) {
					if (e.type == 'click' || e.key === 'Enter') {
						e.preventDefault();
						_this36.close();
					}
				});

				$(document).off('keydown.flyout.' + this.id).on('keydown.flyout.' + this.id, function (e) {
					if (e.key === 'Escape' && !_this36.hidden) {
						_this36.close();
					}
				});

				this.elements.flyout.off('Flyout:trigger-close').on('Flyout:trigger-close', function () {
					_this36.close();
				});

				// Listen to global close events, and close this flyout
				var broadcast_close_event = 'Flyout:broadcast-close.' + this.id;
				$(document).off(broadcast_close_event).on(broadcast_close_event, function () {
					_this36.close();
				});

				// Get an array of elements to compare click events against
				var object_click_map = Object.values(this.elements).reduce(function (acc, element) {
					return acc.concat(element.get());
				}, []);
				var document_click_event = 'click.flyout.' + this.id + ' touchend.flyout.' + this.id;
				$(document).off(document_click_event).on(document_click_event, function (event) {
					// Check if we've clicked any elements related to this flyout
					var clicked_element = object_click_map.some(function (element) {
						return _this36.constructor._checkTarget(element, event.target);
					});

					// Close the flyout if we've clicked something that was not related to this flyout
					if (!clicked_element) {
						_this36.close();
					}
				});
			}

			/**
    * Internal method that hides the flyout element based on the direction it will open from.
    *
    * @param {Boolean} [hide=true] - Whether to force hide the flyout if enabled and already opened
    * @private
    * @memberof Flyout
    */

		}, {
			key: '_hideFlyout',
			value: function _hideFlyout() {
				var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

				if (this.disabled) {
					this.elements.flyout.removeClass(CLASSES.flyoutHidden[this.direction] + " " + CLASSES.flyoutActive[this.direction]);
					this.hidden = false; // Flyout is disabled, hide again on enable
					$('body').removeClass(CLASSES.noScroll);
				} else if (!this.hidden && hide) {
					this.elements.flyout.addClass(CLASSES.flyoutHidden[this.direction]).attr('aria-hidden', 'true').prop('inert', true);
					this.hidden = true;
				}
			}

			/**
    * Check if an element is or is the descendent of another element
    * @param {object} container The parent element
    * @param {object} contains The possible element or child element
    */

		}, {
			key: 'open',


			/**
    * Opens the flyout in the specified direction. Adds the class <code>flyout-active-${direction}</code> to the flyout element, removes the class <code>flyout-hidden-${direction}</code>.
    *
    * @fires Flyout:open
    * @fires Flyout:broadcast-close
    * @memberof Flyout
    */
			value: function open() {
				var _this37 = this;

				/**
     * A flyout element has been opened. Event is attached to a .js-flyout element.
     *
     * @event Flyout:open
     * @memberof Flyout
     * @example
     * $(.js-flyout).on('Flyout:open', function(event) { });
     */

				// Broadcast that a flyout is opening
				$(document).trigger('Flyout:broadcast-close');

				$('body').addClass(CLASSES.noScroll);

				this.elements.flyout.show().removeClass(CLASSES.flyoutHidden[this.direction]).addClass(CLASSES.flyoutActive[this.direction]).removeAttr('aria-hidden inert tabindex').prop('inert', false).on('transitionend webkittransitionEnd otransitionEnd MStransitionEnd', function (e) {
					$(this).trigger('Flyout:open');
					$(this).off(e);
				});

				$(this.elements.open).attr('aria-expanded', 'true');
				$(this.elements.toggle).attr('aria-expanded', 'true');

				// Move focus to first focusable element inside the flyout
				var focusableEls = this.elements.flyout.find('a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), ' + 'textarea:not([tabindex="-1"]), input[type="text"]:not([tabindex="-1"]), ' + 'input[type="number"]:not([tabindex="-1"]), input[type="radio"]:not([tabindex="-1"]), ' + 'input[type="checkbox"]:not([tabindex="-1"]), select:not([tabindex="-1"])').filter(':visible').filter(function (_, el) {
					return !el.closest('[aria-hidden="true"]');
				});
				var $first = focusableEls.first();
				var $last = focusableEls.last();
				requestAnimationFrame(function () {
					$first.focus();
				});

				this.elements.flyout.off('keydown.focustrap').on('keydown.focustrap', function (e) {
					if (e.key !== 'Tab') return;
					var liveFocusable = _this37.elements.flyout.find('a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), ' + 'textarea:not([tabindex="-1"]), input[type="text"]:not([tabindex="-1"]), ' + 'input[type="number"]:not([tabindex="-1"]), input[type="radio"]:not([tabindex="-1"]), ' + 'input[type="checkbox"]:not([tabindex="-1"]), select:not([tabindex="-1"])').filter(':visible').filter(function (_, el) {
						return !el.closest('[aria-hidden="true"]');
					});
					var $trapFirst = liveFocusable.first();
					var $trapLast = liveFocusable.last();
					if (e.shiftKey) {
						if (document.activeElement === $trapFirst[0]) {
							e.preventDefault();
							$trapLast.focus();
						}
					} else {
						if (document.activeElement === $trapLast[0]) {
							e.preventDefault();
							$trapFirst.focus();
						}
					}
				});

				if (this.id == 'cart-flyout') {
					this.elements.flyout.find('.js-cart-flyout-validation').prop('checked', false).trigger('change');
				}

				if (this.options.hideBackground) {
					this._hideBackground();
				}

				this.hidden = false;
			}
		}, {
			key: '_hideBackground',
			value: function _hideBackground() {
				var SKIP = 'script, style, link, noscript, [aria-hidden="true"]';
				var PRESERVE = 'h1, .skip-to-content';
				var $node = this.elements.flyout;
				var $parent = $node.parent();
				while ($parent.length && !$parent.is('body')) {
					$parent.children().not($node).not(SKIP).not(PRESERVE).each(function () {
						$(this).attr({ 'aria-hidden': 'true', 'data-flyout-bg-hidden': 'true' });
					});
					$node = $parent;
					$parent = $node.parent();
				}
				// Hide direct body siblings (e.g. #modal--landing, analytics frames)
				$('body').children().not($node).not(SKIP).not(PRESERVE).each(function () {
					$(this).attr({ 'aria-hidden': 'true', 'data-flyout-bg-hidden': 'true' });
				});
			}
		}, {
			key: '_showBackground',
			value: function _showBackground() {
				$('[data-flyout-bg-hidden]').removeAttr('aria-hidden data-flyout-bg-hidden');
			}

			/**
    * Closes the flyout in the opposite direction from which it opened.
    * Removes the <code>flyout-active-${direction}</code> class from the flyout element, adds the <code>flyout-hidden-${direction}</code> class.
    *
    * @fires Flyout:close
    * @memberof Flyout
    */

		}, {
			key: 'close',
			value: function close() {
				// No need to hide elements if already hidden
				if (this.hidden) {
					return;
				}

				$('body').removeClass(CLASSES.noScroll);
				$(this.elements.open).attr('aria-expanded', 'false');
				$(this.elements.toggle).attr('aria-expanded', 'false');
				this.elements.flyout.off('keydown.focustrap');
				this.elements.flyout.removeClass(CLASSES.flyoutActive[this.direction]).attr({ 'tabindex': '-1', 'aria-hidden': 'true' }).prop('inert', true).addClass(CLASSES.flyoutHidden[this.direction]);

				/**
     * A flyout element has been closed. Event is attached to a .js-flyout element.
     *
     * @event Flyout:close
     * @memberof Flyout
     * @example
     * $(.js-flyout).on('Flyout:close', function(event) { });
     */

				this.elements.flyout.on('transitionend webkittransitionEnd otransitionEnd MStransitionEnd', function (e) {
					//$(this).hide();
					$(this).off(e);
					$(this).trigger('Flyout:close');
				});
				this.hidden = true;

				if (this.options.hideBackground) {
					this._showBackground();
				}

				if (this.elements.last_clicked) {
					this.elements.last_clicked.focus();
				} else if (this.elements.toggle.length) {
					this.elements.toggle.first().focus();
				} else if (this.elements.open.length) {
					this.elements.open.first().focus();
				}
			}

			/**
    * Toggles the flyout depending on its current state.
    *
    * @memberof Flyout
    * @fires Flyout:toggle
    */

		}, {
			key: 'toggle',
			value: function toggle() {

				/**
     * A flyout element has been toggled. Event is attached to a .js-flyout element.
     *
     * @event Flyout:toggle
     * @memberof Flyout
     * @example
     * $(.js-flyout).on('Flyout:toggle', function(event) { });
     */

				this.elements.flyout.trigger('Flyout:toggle');

				if (!this.hidden) {
					this.close();
				} else {
					this.open();
				}
			}
		}], [{
			key: '_checkTarget',
			value: function _checkTarget(container, contains) {
				if (!container) {
					return false;
				}

				return container === contains || $.contains(container, contains);
			}
		}]);

		return Flyout;
	}();

	// ------------------------------
	//  Initialization
	// ------------------------------

	theme.Flyout = Flyout;

	theme.Flyouts = $('.js-flyout').get().reduce(function (acc, cur) {
		var flyout = new theme.Flyout($(cur));
		acc[flyout.id] = flyout;
		return acc;
	}, {});
})(window.theme = window.theme || {}, jQuery);
/**
 * DROPDOWN LIBRARY
 *
 * @description Handles all dropdown functionality.
 * @namespace dropdown
 */

(function (theme, $) {
	/**
  * Default settings
  * @private
  * @const
  * @type {Object}
  */

	var DEFAULTS = {
		closeMenuOnSelect: false,
		showSelectionInLabel: true
		/**
   * Class names
   * @private
   * @const
   * @type {Object}
   */
	};var CLASSES = {
		active: 'active',
		open: 'open'
	};

	/**
  * Creates an Option object representing an option in a dropdown list.
  * @classdesc will be accessed by Dropdown class constructor
  * @property {string} value - The html content of $element
  * @property {array.<jQuery>} elements - The DOM elements constituting the Option. Generally has only one item.
  * @property {jQuery} elements.option - The main DOM element.
  */

	var Option = function () {

		/**
   * Creates an instance of Option.
   *
   * @param {jQuery} $element - The DOM element to initialize on.
   * @param {number} [id] - The id to add to the element.
   * @constructs Option
   * @memberof Option
   */
		function Option($element, id) {
			var _this38 = this;

			_classCallCheck(this, Option);

			if (!$element) {
				return false;
			}

			this.value = $element.html();

			this.elements = {
				option: $element

				// Assign a unique id to the option
			};if (id) {
				this.elements.option.data('option-id', id);
			}

			// Add event listeners that calls set()
			this.elements.option.off('click.dropdown').on('click.dropdown', function () {
				_this38.set();
			});
		}

		/**
   * Is set to happen on click, triggers an event that Dropdown.bindOptions is listening for
   * @fires Dropdown:option-set
   * @memberof Option
   */


		_createClass(Option, [{
			key: 'set',
			value: function set() {
				this.elements.option.trigger('Dropdown:option-set', this.value);
			}
		}]);

		return Option;
	}();

	/**
  * Class representing the dropdown.
  * @classdesc makes Dropdowns. <br><br>
  * Usage: executed on a dropdown container element with the class <code>js-dropdown</code>, containing
  * <ol>
 	* <li> a label element with the class <code>js-dropdown-label</code> </li> <li> a list element with the class <code>js-dropdown-list</code>, or a  <code>ul</code> element. Must contain child elements with the class <code>js-dropdown-option</code>, or <code>li</code> elements.</li>
 	* <li>Can also contain an optional trigger element with the class <code>js-dropdown-trigger</code> which will toggle the dropdown menu open and closed- if none are found, this will default to the label element.
 	* </li>
  * </ol>
  * <br><br>
  * The <code>js-dropdown</code> container element can optionally have a data-dropdown-settings attribute in JSON format, to set behaviour for this dropdown. Consult constructor documentation for setting names and values.
  *
  * @example
  * <div class="js-dropdown">
 		<span class="js-dropdown-label">Dropdown Title</span>
 		<ul class="js-dropdown-list">
 			<li class="js-dropdown-option">Option 1</li>
 			<li class="js-dropdown-option">Option 2</li>
 			<li class="js-dropdown-option">Option 3</li>
 		</ul>
 	</div>
  * @property {boolean} expanded - Boolean which determines whether the dropdown is open or closed.
 * @property {object} options - Keeps track of the dropdown's options, represented as Option instances.
 * @property {array} elements - An array of DOM elements that are parts of the dropdown.
 * @property {jQuery} elements.dropdown - The dropdown container DOM element
 * @property {jQuery} elements.list - The dropdown list DOM element, identified by class '.js-dropdown-list'. If none are found, it will be set to any <code>ul</code> child element of the $dropdown container element.
 * @property {jQuery} elements.label - The dropdown label DOM element, identified by class '.js-dropdown-label'.
 * @property {jQuery} [elements.trigger=elements.label] - The DOM element to trigger the menu to open or close, identified by class '.js-dropdown-trigger'. If not set,default will be the label element.
 * @property {jQuery} $selected - Holds the DOM element which displays the currently selected option.
 * @property {Option} _selected_option - Holds the Option instance corresponding to the currently selected option
  */

	var Dropdown = function () {

		/**
  	 * Creates an instance of Dropdown.
  	 * @constructs Dropdown
  	 * @param {jQuery} $dropdown - The dropdown container DOM element.
  	 * @param {object} settings - settings to be set on the dropdown. Derived from, in order of descending importance: The data-dropdown-settings attribute of the $dropdown element, the settings passed into the constructor, and the default settings.
  	 * @param {boolean} [settings.closeMenuOnSelect = false] - if true, menu will close when an option is chosen.
  	 * @param {boolean} [settings.showSelectionInLabel = true] - if true, label will change to show currently selected option.
  	 * @memberof Dropdown
  	 */

		function Dropdown($dropdown, settings) {
			var _this39 = this;

			_classCallCheck(this, Dropdown);

			this.expanded = false;
			this._selected_option;

			var dropdownSettings = $dropdown.data('dropdown-settings');
			this.settings = $.extend({}, DEFAULTS, settings, dropdownSettings);

			this.elements = {
				dropdown: $dropdown,
				list: $dropdown.find('.js-dropdown-list').length ? $dropdown.find('.js-dropdown-list') : $dropdown.find('ul'),
				label: $dropdown.find('.js-dropdown-label'),
				trigger: $dropdown.find('.js-dropdown-trigger')

				// If no trigger is specified, use the label
			};if (this.elements.trigger.length === 0) {
				this.elements.trigger = this.elements.label;
			}

			this.bindOptions();

			// Trigger toggle event handler
			this.elements.trigger.off('click.dropdown').on('click.dropdown', function () {
				_this39.toggle();
			});

			// When clicking away from the dropdown, close this menu if it's expanded.
			$(document).on('click.dropdown', function (e) {
				var $clicked_elements = $(e.target).parents().addBack();
				if (!$clicked_elements.is(_this39.elements.dropdown)) {
					if (_this39.expanded) {
						_this39.close();
					}
				}
			});
		}

		// ------------------------------
		//  Getters and Setters
		// ------------------------------

		/**
   * The DOM element corresponding to the currently selected dropdown option. Has a setter and a getter.
   * The setter expects a DOM element as argument, and will also set this._selected_option, add the 'active' class to the DOM element, and change the label DOM element to display the same html as the selected element.
   *
   * @type {jQuery}
   * @fires Dropdown:update
   * @memberof Dropdown
   */


		_createClass(Dropdown, [{
			key: 'bindOptions',


			// ------------------------------
			//  Methods
			// ------------------------------

			/**
    * Consolidates all the list options on the dropdown, and populates this.options with Option objects
    *
    * @memberof Dropdown
    */
			value: function bindOptions() {
				var _this40 = this;

				var _ = this;
				this.options = {};
				this.elements.options = this.elements.list.find('.js-dropdown-option').length ? this.elements.list.find('.js-dropdown-option') : this.elements.list.find('li');
				this.elements.options.each(function (index, element) {
					var id = theme.utils.uniqueNumber();
					_this40.options[id] = new Option($(element), id);
				});

				// when Option fires its dropdown_option-set event from a click on an option element, set this.$selected to that option element.
				// See also: the setter function for $selected, which will execute as a result of this.
				// If closeMenuOnSelect is true, this will also close the menu.
				this.elements.options.on('dropdown_option-set', function () {
					if (_.settings.closeMenuOnSelect) {
						_.close();
					}
					if (!$(this).hasClass('js-option-disabled')) {
						_.$selected = $(this);
					}
				});
			}

			/**
    * Opens the dropdown menu.
    *
    * @fires Dropdown:open
    * @memberof Dropdown
    */

		}, {
			key: 'open',
			value: function open() {
				this.expanded = true;
				this.elements.list.slideDown();

				/**
     * The dropdown element has opened
     * @event Dropdown:open
     */

				this.elements.dropdown.addClass(CLASSES.open).trigger('Dropdown:open');
				this.elements.dropdown.find('.menu').addClass(CLASSES.open);
			}

			/**
    * Closes the dropdown menu.
    * @fires Dropdown:close
    * @memberof Dropdown
    */

		}, {
			key: 'close',
			value: function close() {
				this.expanded = false;
				this.elements.list.slideUp();

				/**
     * The dropdown element has closed
     * @event Dropdown:close
     */

				this.elements.dropdown.removeClass(CLASSES.open).trigger('Dropdown:close');
				this.elements.dropdown.find('.menu').removeClass(CLASSES.open);
			}

			/**
    * Determines whether the dropdown menu should be opened or closed.
    *
    * @memberof Dropdown
    * @fires Dropdown:toggle
    */

			/**
    * The dropdown element has been toggled
    * @event Dropdown:toggle
    */

		}, {
			key: 'toggle',
			value: function toggle() {

				this.elements.dropdown.trigger('Dropdown:toggle');

				if (this.expanded) {
					this.close();
				} else {
					this.open();
				}
			}
		}, {
			key: '$selected',
			set: function set($option) {

				if (!$option || !$option.data('option-id')) {
					return false;
				}

				var option_id = $option.data('option-id');

				// Get the Option object in this.options with the same id
				var option = this.options[option_id];

				// update this._selected_option to that Option Object
				this._selected_option = option;

				// Updates active classes on the options
				this.elements.options.not($option).removeClass(CLASSES.active);
				option.elements.option.addClass(CLASSES.active);

				// Change label to display the clicked value
				if (this.settings.showSelectionInLabel) {
					this.elements.label.html(option.value);
				}
				// Fire an event that returns the Option object
				this.elements.dropdown.trigger('Dropdown:update', option);
			}
			/**
    * the currently selected option has changed
    * @event Dropdown:update
    */

			,
			get: function get() {
				return this._selected_option;
			}
		}]);

		return Dropdown;
	}();

	// Initialize your dropdowns


	$(function () {
		$('.js-dropdown').each(function () {
			new Dropdown($(this));
		});
	});

	theme.dropdown = Dropdown;
})(window.theme = window.theme || {}, jQuery);
/**
 * TILE FACTORY
 *
 * @description Renders product and article tiles with various options.
 * @namespace tile
 */

(function (theme) {
	var TileFactory = function () {
		function TileFactory() {
			_classCallCheck(this, TileFactory);
		}

		_createClass(TileFactory, null, [{
			key: 'create',


			/**
    * Creates a tile of a given type.
    *
    * @param {string} [type] - The type of tile to create; includes 'product' and 'article'. Leaving it blank will create a generic tile.
    * @param {object} data - The data used to render the tile (e.g. title, url, image, etc).
    * @param {object} [options] - The options for the tile such as the style or any other additional classes to apply.
    * @returns {Tile} - Returns appropriate type of tile.
    *
    * @example
    * // Create a product tile
    * theme.TileFactory.create('product');
    *
    * // Create a generic tile
    * theme.TileFactory.create();
    */
			value: function create(type, data, options) {
				data = data || {};
				var tile;
				switch (type) {
					case 'product':
						tile = new ProductTile(data, options);
						break;
					case 'simple-product':
						tile = new SimpleProductTile(data, options);
						break;
					default:
						console.warn('TileFactory.create: No tile type was passed. Generic tile created.');
						tile = new Tile(data, options);
				}
				return tile;
			}
		}]);

		return TileFactory;
	}();

	/**
  * Class representing a generic tile.
  */


	var Tile = function () {

		/**
   * Creates an instance of Tile.
   *
   * @typedef TileOptions
   * @type {object}
   * @property {string} [style='responsive'] - The style to be applied to the tile.
   * @property {string} [classes] - Additional classes to apply to the tile.
   * @property {boolean} [addToCart=false] - Include an Add To Cart button with product tile.
   * @property {integer} [maxLength=300] - Include an Add To Cart button with product tile.
   *
   * @param {object} data - The object containing the data necessary to render the tile (e.g. title, url, image, etc).
   * @param {TileOptions} [options] - Options used for rendering. Default includes <code>style: 'repsonsive'</code>.
   */
		function Tile(data, options) {
			_classCallCheck(this, Tile);

			this._data = {
				title: data.title || '',
				url: data.url || '',
				image_url: data.image ? theme.utils.getSizedImageUrl(data.image, '500x500_crop_center') : theme.default_tile_image
			};
			this._options = {
				style: 'responsive'
			};
			if (options) {
				this.options = options;
			}
		}

		/**
   * Sets the tile's options.
   *
   * @param {object} options - Options to set. Existing options will be updated.
   *
   * @example
   * // Change the tile style and add additional classes
   * let tile = theme.TileFactory.create();
   * tile.options = { style: 'large', classes: 'example-class-1 example-class-2' };
   */


		_createClass(Tile, [{
			key: 'render',


			/**
    * Renders the tile to be displayed.
    *
    * @returns {jQuery} - Returns the tile element to be rendered on the page.
    *
    * @example
    * let tile = theme.TileFactory.create();
    * tile.render();
    */
			value: function render() {
				var tile = [];

				tile.push('' + '<div class="tile' + (this._options.style ? ' tile--' + this._options.style : '') + '">' + (this._options.classes ? ' ' + this._options.classes : '') + '">');

				if (this._data.image_url) {
					tile.push('' + '<div class="tile__image">' + '<a href="' + this._data.url + '" class="discrete">' + '<img src="' + this._data.image_url + '" alt="' + this._data.title + '"/>' + '</a>' + '</div>');
				}

				tile.push('' + '<div class="tile__info">' + '<a href="' + this._data.url + '" class="discrete">' + '<span class="title">' + this._data.title + '</span>' + '</a>' + '</div>' + '</div>');

				return $(tile.join(''));
			}
		}, {
			key: 'options',
			set: function set(options) {
				if (!options || (typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
					console.error('ProductTile.set: Invalid argument.');
					return;
				}
				if (options.maxLength && (!$.isNumeric(options.maxLength) || options.maxLength < 0)) {
					console.warn('Tile.options: Invalid value for property \'maxLength\'; must be a positive integer. Value will not be changed.');
					delete options.maxLength;
				}

				this._options = theme.utils.modifyObject(this._options, options);
			}

			/**
    * Returns the tile's current options.
    *
    * @example
    * //Get tile options
    * let tile = theme.TileFactory.create();
    * tile.options;
    *
    * // Outputs the default options if none are set.
    * // { style: "responsive" }
    */
			,
			get: function get() {
				return this._options;
			}
		}]);

		return Tile;
	}();

	/**
  * Class representing a Product Tile.
  */


	var ProductTile = function (_Tile) {
		_inherits(ProductTile, _Tile);

		/**
   * Creates an instance of Product Tile.
   *
   * @param {object} data - The object containing the data necessary to render the product tile (e.g. title, price, weight range, etc).
   * @param {TileOptions} [options] - Options used for rendering.
   */
		function ProductTile(data, options) {
			_classCallCheck(this, ProductTile);

			var _this41 = _possibleConstructorReturn(this, (ProductTile.__proto__ || Object.getPrototypeOf(ProductTile)).call(this, data));

			_this41._data = data;
			_this41._data.url = data.url || '/products/' + (data.handle || '');
			_this41._data.vendor_url = '/collections/' + (data.vendor || '').handleize();
			_this41._data.product_id = data.id || '';
			_this41._data.variant_id = data.objectID || '';
			_this41._data.variant_options = data.options || [];
			_this41._data.tags = data.tags || [];

			_this41._options = {
				style: 'responsive',
				addToCart: true
			};

			if (options) {
				_this41.options = options;
			}
			return _this41;
		}

		/**
   * Renders the product tile to be displayed.
   *
   * @returns {jQuery} - Returns the product tile element to be rendered on the page.
   *
   * @example
   * let productTile = theme.TileFactory.create('product', data);
   * productTile.render();
   */


		_createClass(ProductTile, [{
			key: 'render',
			value: function render() {
				var _this42 = this;

				var productStrain = function (product) {
					return '<div class="strain">\n\t\t\t\t\t\t' + function (metafield) {
						var compounds = '';
						var compound_unit = '&percnt;';
						var compound_unit_mg = 'mg/g';

						if (metafield.class === 'Capsules' || metafield.sub_class && metafield.sub_class.includes('Capsule')) {
							compound_unit_mg = ' mg/cap';
						} else if (metafield.class === 'Concentrates' || metafield.class === 'Flower' || metafield.class === 'Ground/Milled') {
							compound_unit_mg = 'mg/g';
						} else if (product.product_type === 'Oil' || metafield.class.includes('Oil')) {
							compound_unit_mg = ' mg/ml';
						} else if (metafield.class == 'Ingestible Extracts & Capsules') {
							if (metafield.sub_class && metafield.sub_class.includes('Liquid') || metafield.sub_class.includes('Spray')) {
								compound_unit_mg = ' mg/ml';
							} else if (metafield.sub_class && metafield.sub_class.includes('Tabs')) {
								compound_unit_mg = ' mg/pcs';
							}
						} else if (metafield.class === 'Cartridges') {
							compound_unit_mg = 'mg/ml';
						} else if (metafield.class === 'Liquid') {
							compound_unit_mg = ' /ml';
						} else if (metafield.class === 'Beverages') {
							compound_unit_mg = 'mg/unit';
						} else if (metafield.class === 'Chocolate' || metafield.class === 'Edibles') {
							compound_unit_mg = 'mg/piece';
						} else if (metafield['sub-department'] === 'Topicals') {
							compound_unit_mg = 'mg/unit';
						}

						// Display THC
						if (metafield.thc_range_min !== undefined && metafield.thc_range_max !== undefined || metafield.thc_range_min_mg !== undefined && metafield.thc_range_max_mg !== undefined || metafield.thc_range_min_unit !== undefined && metafield.thc_range_max_unit !== undefined) {

							compounds += '<div class="strain-composite">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="compound">' + theme.locales.product.strain.thc + '</span>';

							if (metafield.thc_range_min !== undefined && metafield.thc_range_max !== undefined) {
								compounds += '<span class="percentage">\n\t\t\t\t\t\t\t\t\t\t\t\t\t' + (metafield.thc_range_min === metafield.thc_range_max ? '' + metafield.thc_range_max + compound_unit : metafield.thc_range_min + ' - ' + metafield.thc_range_max + compound_unit) + '\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							if (metafield.thc_range_min !== undefined && metafield.thc_range_max !== undefined && (metafield.thc_range_min_mg !== undefined && metafield.thc_range_max_mg !== undefined || metafield.thc_range_min_unit !== undefined && metafield.thc_range_max_unit !== undefined)) {
								compounds += '<br/>';
							}
							if (metafield.thc_range_min_mg !== undefined || metafield.thc_range_max_mg !== undefined || metafield.thc_range_min_unit !== undefined || metafield.thc_range_max_unit !== undefined) {
								var thc_range = void 0;
								if (metafield.thc_range_min_mg !== undefined && metafield.thc_range_max_mg !== undefined) {
									// MIN - MAX
									if (metafield.thc_range_min_mg === metafield.thc_range_max_mg) {
										thc_range = metafield.thc_range_min_mg;
									} else {
										thc_range = metafield.thc_range_min_mg + ' - ' + metafield.thc_range_max_mg;
									}
								} else if (metafield.thc_range_min_mg !== undefined) {
									// MIN
									thc_range = metafield.thc_range_min_mg;
								} else if (metafield.thc_range_max_mg !== undefined) {
									// MAX
									thc_range = metafield.thc_range_max_mg;
								} else if (metafield.thc_range_min_unit !== undefined || metafield.thc_range_max_unit !== undefined) {
									if (metafield.thc_range_min_unit === metafield.thc_range_max_unit) {
										thc_range = metafield.thc_range_min_unit;
									} else {
										thc_range = metafield.thc_range_min_unit + ' - ' + metafield.thc_range_max_unit;
									}
								} else if (metafield.thc_range_min_unit !== undefined) {
									// MIN
									thc_range = metafield.thc_range_min_unit;
								} else if (metafield.thc_range_max_unit !== undefined) {
									// MAX
									thc_range = metafield.thc_range_max_unit;
								}

								compounds += '<span class="milligram">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' + thc_range + compound_unit_mg + '\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							compounds += '</div>';
						}

						// Display CBD
						if (metafield.cbd_range_min !== undefined && metafield.cbd_range_max !== undefined || metafield.cbd_range_min_mg !== undefined && metafield.cbd_range_max_mg !== undefined || metafield.cbd_range_min_unit !== undefined && metafield.cbd_range_max_unit !== undefined) {
							compounds += '<div class="strain-composite">\n\t\t\t\t\t\t\t\t\t\t\t<span class="compound">' + theme.locales.product.strain.cbd + '</span>';
							if (metafield.cbd_range_min !== undefined && metafield.cbd_range_max !== undefined) {
								compounds += '<span class="percentage">\n\t\t\t\t\t\t\t\t\t\t\t\t' + (metafield.cbd_range_min === metafield.cbd_range_max ? '' + metafield.cbd_range_max + compound_unit : metafield.cbd_range_min + ' - ' + metafield.cbd_range_max + compound_unit) + '\n\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							if (metafield.cbd_range_min !== undefined && metafield.cbd_range_max !== undefined && (metafield.cbd_range_min_mg !== undefined && metafield.cbd_range_max_mg !== undefined || metafield.cbd_range_min_unit !== undefined && metafield.cbd_range_max_unit !== undefined)) {
								compounds += '<br/>';
							}

							if (metafield.cbd_range_min_mg !== undefined || metafield.cbd_range_max_mg !== undefined || metafield.cbd_range_min_unit !== undefined || metafield.cbd_range_max_unit !== undefined) {
								var cbd_range = void 0;

								if (metafield.cbd_range_min_mg !== undefined && metafield.cbd_range_max_mg !== undefined) {
									// MIN - MAX
									if (metafield.cbd_range_min_mg === metafield.cbd_range_max_mg) {
										cbd_range = metafield.cbd_range_min_mg;
									} else {
										cbd_range = metafield.cbd_range_min_mg + ' - ' + metafield.cbd_range_max_mg;
									}
								} else if (metafield.cbd_range_min_mg !== undefined) {
									// MIN
									cbd_range = metafield.cbd_range_min_mg;
								} else if (metafield.cbd_range_max_mg !== undefined) {
									// MAX
									cbd_range = metafield.cbd_range_max_mg;
								} else if (metafield.cbd_range_min_unit !== undefined || metafield.cbd_range_max_unit !== undefined) {
									if (metafield.cbd_range_min_unit === metafield.cbd_range_max_unit) {
										cbd_range = metafield.cbd_range_min_unit;
									} else {
										cbd_range = metafield.cbd_range_min_unit + ' - ' + metafield.cbd_range_max_unit;
									}
								} else if (metafield.cbd_range_min_unit !== undefined) {
									// MIN
									cbd_range = metafield.cbd_range_min_unit;
								} else if (metafield.cbd_range_max_unit !== undefined) {
									// MAX
									cbd_range = metafield.cbd_range_max_unit;
								}

								compounds += '<span class="milligram">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' + cbd_range + compound_unit_mg + '\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							compounds += '</div>';
						}
						return compounds;
					}(product.meta && product.meta.field ? product.meta.field : {}) + '\n\t\t\t\t\t\t<p class="strain-type">\n\t\t\t\t\t\t\t' + (product.meta && product.meta.field && product.meta.field.plant_type ? product.meta.field.plant_type : '') + '\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>';
				}(this._data);

				// NOTE: Missing compare_at_price
				var productPrice = function (product) {
					var min_price = 0;
					var max_price = 0;

					var min_variant = product.variants[0];
					var max_variant = product.variants[product.variants.length - 1];

					// Find the minimum and maximum priced variants

					var _product$variants$red = product.variants.reduce(function (acc, variant) {
						if (acc.min_variant.price > variant.price) {
							acc.min_variant = variant;
						}

						if (acc.max_variant.price < variant.price) {
							acc.max_variant = variant;
						}

						return acc;
					}, {
						min_variant: product,
						max_variant: product
					});

					min_variant = _product$variants$red.min_variant;
					max_variant = _product$variants$red.max_variant;


					min_price = min_variant.price;
					max_price = max_variant.price;

					if (product.tags.indexOf('b2b') > -1) {
						var min_excise = min_variant.meta && min_variant.meta.field && min_variant.meta.field.excise / 100 || 0;
						var max_excise = max_variant.meta && max_variant.meta.field && max_variant.meta.field.excise / 100 || 0;

						min_price = min_variant.price - min_excise;
						max_price = max_variant.price - max_excise;
					}

					return '<p class="price">\n\t\t\t\t\t<span class="price-amount">\n\t\t\t\t\t\t' + (theme.utils.toMoney(min_price) + (min_price < max_price ? '  &hyphen; ' + theme.utils.toMoney(max_price) : '')) + '\n\t\t\t\t\t</span>\n\t\t\t\t</p>';
				}(this._data);

				var productVariants = function (product) {
					if (product.variants_count >= 1) {
						var variants = '<div class="sizes">Sizes: ';

						var sizes = new Set();
						var sortedVariants = product.variants.sort(function (variant_a, variant_b) {
							return variant_b.price - variant_a.price;
						});
						sortedVariants.forEach(function (variant, index, array) {
							if ('do_not_display' in variant.meta.field && variant.meta.field.do_not_display === 'false' || variant.meta.field.do_not_display === undefined) {
								variant.option1.length ? sizes.add(variant.option1) : false;
							}
						});
						var sizeList = Array.from(sizes).reverse().join(', ');
						variants += sizeList;
						variants += '</div>';
						return sizeList.length ? variants : '';
					}
				}(this._data);

				var productSubtitle = function (product) {
					try {
						return product.meta.field.class;
					} catch (error) {
						return "";
					}
				}(this._data);

				var collection = "";
				var brand_link = "";

				try {
					collection = this._data.collections.find(function (coll) {
						return ~coll.indexOf(_this42._data.meta.field.brand.handleize().replace(/--/g, '-'));
					});
					brand_link = collection ? '/collections/' + collection : '';
				} catch (error) {
					console.warn(error);
					brand_link = this._data.url;
				}

				var brand = this._data.meta && this._data.meta.field && this._data.meta.field.brand || this._data.title;

				var productTile = '<div class="tile tile--product product-tile' + (!!~this._data.tags.indexOf('coming_soon') ? ' product-tile--coming-soon' : '') + ((this._options.style ? ' tile--' + this._options.style : '') + (this._options.classes ? ' ' + this._options.classes : '')) + '">\n\t\t\t\t\t<a class="tile-image discrete product-image" href="' + this._data.url + '" title="' + this._data.title + '" aria-hidden="true" tabindex="-1">\n\t\t\t\t\t\t<img src="' + (this._data.image || theme.default_tile_image) + '" alt=""/>\n\t\t\t\t\t</a>\n\t\t\t\t\t<div class="tile-details">\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t' + (brand_link ? '<a class="tile-brand discrete" href="' + brand_link + '" title="' + brand + '">' + brand + '</a>' : '<span class="tile-brand">' + brand + '</span>') + '\n\t\t\t\t\t\t\t<h2 class="tile-title">\n\t\t\t\t\t\t\t\t<a class="discrete" href="' + this._data.url + '">' + this._data.title + '</a>\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p class="tile-class">' + productSubtitle + '</p>\n\t\t\t\t\t\t\t' + productStrain + '\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t' + productPrice + '\n\t\t\t\t\t\t\t' + (productVariants ? productVariants : '') + '\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>';

				// Return a string for the widget
				return productTile;
			}
		}]);

		return ProductTile;
	}(Tile);

	/**
  * Class representing a Simple Product Tile.
  */


	var SimpleProductTile = function (_ProductTile) {
		_inherits(SimpleProductTile, _ProductTile);

		/**
   * Creates an instance of Simple Product Tile.
   *
   * @param {object} data - The object containing the data necessary to render the simple product tile (e.g. title, price, weight range, etc).
   * @param {TileOptions} [options] - Options used for rendering.
   */
		function SimpleProductTile(data, options) {
			_classCallCheck(this, SimpleProductTile);

			return _possibleConstructorReturn(this, (SimpleProductTile.__proto__ || Object.getPrototypeOf(SimpleProductTile)).call(this, data, options));
		}

		/**
   * Renders the simple product tile to be displayed.
   *
   * @returns {jQuery} - Returns the simple product tile element to be rendered on the page.
   *
   * @example
   * let simpleProductTile = theme.TileFactory.create('simple-product', data);
   * simpleProductTile.render();
   */


		_createClass(SimpleProductTile, [{
			key: 'render',
			value: function render() {
				var productStrain = function (product) {
					return '<div class="simple-tile__strain">\n\t\t\t\t\t\t' + function (metafield) {
						var compounds = '';
						var compound_unit = '&percnt;';
						var compound_unit_mg = 'mg/g';

						if (metafield.class === 'Capsules') {
							compound_unit_mg = ' mg/cap';
						} else if (metafield.class === 'Concentrates' || metafield.class === 'Flower' || metafield.class === 'Ground/Milled') {
							compound_unit_mg = 'mg/g';
						} else if (product.product_type === 'Oil') {
							compound_unit_mg = ' mg/ml';
						} else if (metafield.class === 'Cartridges') {
							compound_unit_mg = 'mg/ml';
						} else if (metafield.class === 'Liquid') {
							compound_unit_mg = ' /ml';
						} else if (metafield.class === 'Beverages') {
							compound_unit_mg = 'mg/unit';
						} else if (metafield.class === 'Chocolate' || metafield.class === 'Edibles') {
							compound_unit_mg = 'mg/piece';
						} else if (metafield['sub-department'] === 'Topicals') {
							compound_unit_mg = 'mg/unit';
						}

						// Display THC
						if (metafield.thc_range_min !== undefined && metafield.thc_range_max !== undefined || metafield.thc_range_min_mg !== undefined && metafield.thc_range_max_mg !== undefined || metafield.thc_range_min_unit !== undefined && metafield.thc_range_max_unit !== undefined) {

							compounds += '<div class="simple-tile__strain-composite">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="simple-tile__compound">' + theme.locales.product.strain.thc + '</span>';
							if (metafield.thc_range_min !== undefined && metafield.thc_range_max !== undefined) {
								compounds += '<span class="simple-tile__percentage">\n\t\t\t\t\t\t\t\t\t\t\t\t\t' + (metafield.thc_range_min === metafield.thc_range_max ? '' + metafield.thc_range_max + compound_unit : metafield.thc_range_min + ' - ' + metafield.thc_range_max + compound_unit) + '\n\t\t\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							if (metafield.thc_range_min !== undefined && metafield.thc_range_max !== undefined && (metafield.thc_range_min_mg !== undefined && metafield.thc_range_max_mg !== undefined || metafield.thc_range_min_unit !== undefined && metafield.thc_range_max_unit !== undefined)) {
								compounds += '<br/>';
							} else if (metafield.thc_range_min_unit !== undefined && metafield.thc_range_max_unit !== undefined) {
								var thc_range = void 0;
								if (metafield.thc_range_min_unit === metafield.thc_range_max_unit) {
									thc_range = metafield.thc_range_min_unit;
								} else {
									thc_range = metafield.thc_range_min_unit + ' - ' + metafield.thc_range_max_unit;
								}

								compounds += '<span class="simple-tile__milligram">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' + thc_range + compound_unit_mg + '\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							if (metafield.thc_range_min_mg !== undefined || metafield.thc_range_max_mg !== undefined) {
								var _thc_range = void 0;
								if (metafield.thc_range_min_mg !== undefined && metafield.thc_range_max_mg !== undefined) {
									// MIN - MAX
									if (metafield.thc_range_min_mg === metafield.thc_range_max_mg) {
										_thc_range = metafield.thc_range_min_mg;
									} else {
										_thc_range = metafield.thc_range_min_mg + ' - ' + metafield.thc_range_max_mg;
									}
								} else if (metafield.thc_range_min_mg !== undefined) {
									// MIN
									_thc_range = metafield.thc_range_min_mg;
								} else {
									// MAX
									_thc_range = metafield.thc_range_max_mg;
								}
								compounds += '<span class="simple-tile__milligram">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' + _thc_range + compound_unit_mg + '\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							compounds += '</div>';
						}

						// Display CBD
						if (metafield.cbd_range_min !== undefined && metafield.cbd_range_max !== undefined || metafield.cbd_range_min_mg !== undefined && metafield.cbd_range_max_mg !== undefined || metafield.cbd_range_min_unit !== undefined && metafield.cbd_range_max_unit !== undefined) {
							compounds += '<div class="simple-tile__strain-composite">\n\t\t\t\t\t\t\t\t\t\t\t<span class="simple-tile__compound">' + theme.locales.product.strain.cbd + '</span>';
							if (metafield.cbd_range_min !== undefined && metafield.cbd_range_max !== undefined) {
								compounds += '<span class="simple-tile__percentage">\n\t\t\t\t\t\t\t\t\t\t\t\t' + (metafield.cbd_range_min === metafield.cbd_range_max ? '' + metafield.cbd_range_max + compound_unit : metafield.cbd_range_min + ' - ' + metafield.cbd_range_max + compound_unit) + '\n\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							if (metafield.cbd_range_min !== undefined && metafield.cbd_range_max !== undefined && (metafield.cbd_range_min_mg !== undefined && metafield.cbd_range_max_mg !== undefined || metafield.cbd_range_min_unit !== undefined && metafield.cbd_range_max_unit !== undefined)) {
								compounds += '<br/>';
							} else if (metafield.cbd_range_min_unit !== undefined && metafield.cbd_range_max_unit !== undefined) {
								var _thc_range2 = void 0;
								if (metafield.cbd_range_min_unit === metafield.cbd_range_max_unit) {
									_thc_range2 = metafield.cbd_range_min_unit;
								} else {
									_thc_range2 = metafield.cbd_range_min_unit + ' - ' + metafield.cbd_range_max_unit;
								}

								compounds += '<span class="simple-tile__milligram">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' + _thc_range2 + compound_unit_mg + '\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							if (metafield.cbd_range_min_mg !== undefined || metafield.cbd_range_max_mg !== undefined) {
								var cbd_range = void 0;
								if (metafield.cbd_range_min_mg !== undefined && metafield.cbd_range_max_mg !== undefined) {
									// MIN - MAX
									if (metafield.cbd_range_min_mg === metafield.cbd_range_max_mg) {
										cbd_range = metafield.cbd_range_min_mg;
									} else {
										cbd_range = metafield.cbd_range_min_mg + ' - ' + metafield.cbd_range_max_mg;
									}
								} else if (metafield.cbd_range_min_mg !== undefined) {
									// MIN
									cbd_range = metafield.cbd_range_min_mg;
								} else {
									// MAX
									cbd_range = metafield.cbd_range_max_mg;
								}
								compounds += '<span class="simple-tile__milligram">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t' + cbd_range + compound_unit_mg + '\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>';
							}
							compounds += '</div>';
						}
						return compounds;
					}(product.meta && product.meta.field ? product.meta.field : {}) + '\n\t\t\t\t\t</div>';
				}(this._data);

				var productSubtitle = function (product) {
					try {
						return product.meta.field.class;
					} catch (error) {
						return "";
					}
				}(this._data);

				var productTile = '<div class="simple-tile' + ((this._options.style ? ' simple-tile--' + this._options.style : '') + (this._options.classes ? ' ' + this._options.classes : '')) + '">\n\t\t\t\t\t<a class="simple-tile__image discrete" href="' + this._data.url + '" tabindex="-1" aria-hidden="true">\n\t\t\t\t\t\t<img src="' + (this._data.image || theme.default_tile_image) + '" alt="">\n\t\t\t\t\t</a>\n\t\t\t\t\t<div class="simple-tile__content">\n\t\t\t\t\t\t<h2 class="simple-tile__title"><a href="' + this._data.url + '" title="' + this._data.title + '">' + this._data.title + '</a></h2>\n\t\t\t\t\t\t<p class="simple-tile__class">' + productSubtitle + '</p>\n\t\t\t\t\t\t' + productStrain + '\n\t\t\t\t\t</div>\n\t\t\t\t</div>';

				// Return a string for the widget
				return productTile;
			}
		}]);

		return SimpleProductTile;
	}(ProductTile);

	theme.TileFactory = TileFactory;
})(window.theme = window.theme || {}, jQuery);
$(function () {

	// opens a modal when a modal CTA element is clicked
	// targets anything with the modal-cta class
	$(document).on('click', '.js-modal-cta', function (e) {
		e.preventDefault();
		openModal($(this).attr('href'));
	});

	// closes a modal when closing elements are clicked
	// targets modal backdrops and any closers within a modal
	$(document).on('click', function (e) {
		var $target = $(e.target);
		var isClose = $target.hasClass('js-modal-close') || $target.closest('.js-modal-close').length;
		var isBackdrop = $target.hasClass('modal') || $target.hasClass('modal-alignment');
		if (isClose || isBackdrop) {
			var $modal = $target.closest('.modal');
			closeModal($modal);
		}
	});

	// closes an open modal when ESC is pressed
	$(document).keyup(function (e) {
		if (e.keyCode == 27) {
			if ($('.modal--open').length) {
				closeModal($('.modal--open').first());
			}
		}
	});

	// opens a modal
	// freezes and blurs the rest of the page
	// selector represents a $('.modal')'s id
	// if there is no modal, this will disable buttons that link to it
	function openModal(modalSelector) {

		if ($(modalSelector).length) {
			var modalsContainerSelector = '#modals';
			if ($(modalsContainerSelector).length) {
				$(modalsContainerSelector).append($(modalSelector));
			} else {
				$('body').append('<div id="modals"></div>');
				$(modalsContainerSelector).append($(modalSelector));
			}
			$(modalSelector).addClass('modal--open');
			$('body').addClass('body--freeze');
		} else {
			$('.modal-cta[href="' + modalSelector + '"]').attr('disabled', 'disabled');
		}
	}

	// closes a modal
	// unfreezes and unblurs the rest of the page
	// $target represents a $('.modal')
	function closeModal($target) {
		$('body').removeClass('body--freeze');
		$target.removeClass('modal--open');
	}

	window.openModal = function (modalSelector) {
		openModal(modalSelector);
	};
});
/**
 * STICKY LIBRARY
 *
 * @description Handles sticky elements.
 * @namespace sticky
 */

(function (theme, $) {

	/**
 * Class representing the sticky object.
  *
  * @classdesc The Sticky class is used to create sticky objects out of elements with the data attribute <code>data-sticky</code>. The <code>js-sticky</code> class is added once the element reaches the top of the document on scroll.
  * <br><br>
  * Breakpoints may be passed optionally as data in json format.
  * <br><br>
  * @example <div data-sticky></div>
  * @example <div data-sticky='{"min":"768"}'></div>
  * @example <div data-sticky='{"min":"425","max":"768"}'></div>
  *
  * @property {json} [options] - Optional breakpoints
  * @property {integer} [max] - Disable sticky after this breakpoint; extracted from options
  * @property {integer} [min] - Disable sticky before this breakpoint; extracted from options
  * @property {boolean} disabled - Indicates if the sticky is disabled based on breakpoints
  * @property {boolean} stuck - Indicates if the sticky is stuck
 */
	var Sticky = function () {

		/**
  * Creates an instance of Sticky.
  *
  * @param {HTMLElement} $element - The sticky element
  * @constructs Sticky
  * @memberof Sticky
  */
		function Sticky($element) {
			_classCallCheck(this, Sticky);

			if (!$element) {
				console.error('Sticky.constructor: No element was passed.');
				return false;
			}
			this.sticky = $element;
			this.options = $element.data('sticky') || {};
			this.max = this.options.hasOwnProperty('max') && Math.floor(this.options.max) != this.options.max && !$.isNumeric(this.options.max) || this.max < 0 ? -1 : this.options.max;
			this.min = this.options.hasOwnProperty('min') && Math.floor(this.options.min) != this.options.min && !$.isNumeric(this.options.min) || this.options.min < 0 ? -1 : this.options.min;
			this.disabled = this._isDisabled();
			this.offset = Math.max($element.offset().top - $(document).scrollTop(), 0);
			this.stuck = false;

			this._run();
		}

		// ------------------------------
		//  Methods
		// ------------------------------

		/**
   * Internal method that handles the main functionality of the sticky object. Calls the <code>update()</code> on document scroll and <code>refresh()</code> on window resize.
   *
   * @private
   * @memberof Sticky
   */


		_createClass(Sticky, [{
			key: '_run',
			value: function _run() {
				var _ = this;
				_.update();
				$(document).scroll(function () {
					_.update();
				});
				$(window).resize(function () {
					_.refresh();
				});
			}

			/**
    * Internal method that checks if the sticky is disabled based on breakpoints passed as options.
    *
    * @private
    * @memberof Sticky
    */

		}, {
			key: '_isDisabled',
			value: function _isDisabled() {
				if (this.max == -1 || this.min == -1) {
					return true;
				}
				return this.max < $(window).width() || this.min > $(window).width();
			}

			/**
    * Checks if the sticky element is disabled, then sticks or unsticks the element according to the offset.
    *
    * @memberof Sticky
    */

		}, {
			key: 'update',
			value: function update() {
				if (this.disabled) {
					return false;
				}
				$(document).scrollTop() > this.offset ? this.stick() : this.unstick();
			}

			/**
    * Calculates the offset of the sticky element from the top of the document and calls the update function if the element is not disabled.
    *
    * @memberof Sticky
    */

		}, {
			key: 'refresh',
			value: function refresh() {
				this.offset = Math.max($(this.sticky).offset().top - $(document).scrollTop(), 0);
				this.disabled = this._isDisabled();
				if (this.disabled) {
					this.update();
				}
			}

			/**
    * Sticks the sticky element.
    *
    * @fires stick
    * @memberof Sticky
    */

		}, {
			key: 'stick',
			value: function stick() {

				/**
     * Adds the class <code>js-sticky</code> class to the sticky element.
     *
     * @event stick
     * @memberof Sticky
     */
				this.stuck = true;
				$(this.sticky).addClass('js-sticky').trigger('stick');
			}

			/**
    * Unsticks the sticky element.
    *
    * @fires unstick
    * @memberof Sticky
    */

		}, {
			key: 'unstick',
			value: function unstick() {

				/**
     * Removes the class <code>js-sticky</code> from the sticky element.
     *
     * @event unstick
     * @memberof Sticky
     */
				this.stuck = false;
				$(this.sticky).removeClass('js-sticky').trigger('unstick');
			}
		}]);

		return Sticky;
	}();

	// ------------------------------
	//  Initiallization
	// ------------------------------

	theme.sticky = Sticky;

	$('[data-sticky]').each(function () {
		new theme.sticky($(this));
	});
})(window.theme = window.theme || {}, jQuery);

(function (theme, $) {
	var THCRegulator = function () {
		function THCRegulator(options) {
			_classCallCheck(this, THCRegulator);

			var defaults = {
				limit: 30,
				plant_limit: 4,
				selectors: {
					variant_selector: '.js-product-container',
					atc_button: '.product-atc'
				}
			};

			this.cart = theme.cart.content;
			this.settings = $.extend(options, defaults);
		}

		_createClass(THCRegulator, [{
			key: 'regulator',
			value: function regulator(event, variant, product) {
				var is_valid_variant = this.validVariant(variant, product);

				return is_valid_variant;
			}
		}, {
			key: 'getTotal',
			value: function getTotal() {
				return theme.cart.content.items.reduce(function (acc, item) {
					return acc + (item.properties && "_thc" in item.properties ? parseFloat(item.properties["_thc"]) * item.quantity : 0);
				}, 0);
			}
		}, {
			key: 'getTotals',
			value: function getTotals() {
				return theme.cart.content.items.reduce(function (acc, item) {
					var thc = item.properties && '_thc' in item.properties ? parseFloat(item.properties["_thc"]) * item.quantity : 0;
					var plants = item.product_type === "Plants" ? item.quantity : 0;

					acc.thc += thc;
					acc.plants += plants;

					return acc;
				}, {
					thc: 0,
					plants: 0
				});
			}
		}, {
			key: 'getAvailable',
			value: function getAvailable() {
				return this.settings.limit - this.getTotal();
			}

			// Returns true if the variant can be added to the cart.

		}, {
			key: 'validVariant',
			value: function validVariant(variant, product) {
				var current_totals = this.getTotals();
				var variant_thc = parseFloat(variant.thc);
				var product_type = product.type;

				return (current_totals.thc + variant_thc <= parseFloat(this.settings.limit) || current_totals.thc + variant_thc == 0) && !(product_type === "Plants" && current_totals.plants >= this.settings.plant_limit);
			}
		}]);

		return THCRegulator;
	}();

	// ------------------------------
	//  Initialization
	// ------------------------------

	theme.THCRegulator = new THCRegulator();
})(window.theme = window.theme || {}, jQuery);
/*

	We will be short-circuiting most of the option selection logic in here (the logic that listens for
	'select' or 'change' events on option inputs and produces a variant ID)

	Instead, we will be producing a variant ID

*/

/**
 * VARIANT SELECTOR LIBRARY
 *
 * @description Handles selection of variants, determines state of a selection, and broadcasts related events
 * @namespace variantSelector
 */

(function (theme, $) {
	/**
  * The VariantSelector manages attaching events and triggers between
  * variant selector elements and the variant selector engine.
  * Settings can be specified in the constructor or a 'data-variant-selector' attribute
  * on the container.
  * @class
  * @example
  * //<div class="js-my-variant-selector" data-variant-selector="{ update_atc: false }">
  * //    <!-- ... -->
  * //</div>
  * let variant_selector = new VariantSelector($('.js-my-variant-selector'), { selectors: { atc_button: '.js-my-atc' }});
  */
	var VariantSelector = function () {
		/**
   *
   * @param {jQuery} $container - The container encompassing all variant selector DOM elements
   * @param {Object} [settings] - Configurable Variant Selector settings
   * @param {Object} [settings.selectors] - Selectors for selecting DOM elements
   * @param {string} [settings.selectors.option_selector='.js-option-selector'] - Input elements for selecting a variant option's value
   * @param {string} [settings.selectors.id_field='[name="id"]'] - Selector for the form element holding the id value of the selected variant.
   * This is usually some sort of input element with name="id".
   * @param {string} [settings.selectors.$atc_button='[type="submit"]'] - Selector for the Add to Cart button.
   * This is usually the submit button for your form. It will get enabled/disabled based on the selected variant and whether it is in stock.
   * @param {Boolean} [settings.update_atc=true] - Whether the atc button show be enabled/disabled and the id_field set
   * @constructs VariantSelector
   *
   */
		function VariantSelector($container, settings) {
			var _this44 = this;

			_classCallCheck(this, VariantSelector);

			var defaults = {
				selectors: {
					option_selector: '.js-option-selector',
					size_selector: '.js-size-option',
					flavour_selector: '#flavour-option',
					id_field: '[name="id"]',
					atc_button: '[type="submit"]',
					flavor: '.js-variant-flavor',
					allergens: '.js-variant-allergens',
					caffeine_content: '.js-variant-caffeine-content',
					selling_units: '.js-variant-selling-units',
					upc_code: '.js-variant-upc-code',
					sku: '.js-variant-sku',
					nutrition_table: '.js-variant-nutrition-table',
					ingredients: '.js-variant-ingredients',
					stock_message: '.js-variant-stock-message',
					carousel: '.js-product-images-slider'
				},
				update_atc: true,
				debug: false
			};

			this.thc_regulator = theme.THCRegulator;
			this.$container = $container;

			var data_options = this.$container.data('variant-selector');
			this.options = $.extend({}, defaults, data_options, settings);

			this.elements = {
				$id_field: $(this.options.selectors.id_field, this.$container),
				$atc_button: $(this.options.selectors.atc_button, this.$container),
				$option_selectors: $(this.options.selectors.option_selector, this.$container),
				$flavour_selector: $(this.options.selectors.flavour_selector, this.$container),
				$size_selectors: $(this.options.selectors.size_selector, this.$container),
				$allergens: $(this.options.selectors.allergens, this.$container),
				$caffeine_content: $(this.options.selectors.caffeine_content, this.$container),
				$selling_units: $(this.options.selectors.selling_units, this.$container),
				$upc_code: $(this.options.selectors.upc_code, this.$container),
				$sku: $(this.options.selectors.sku, this.$container),
				$nutrition_table: $(this.options.selectors.nutrition_table, this.$container),
				$ingredients: $(this.options.selectors.ingredients, this.$container),
				$stock_message: $(this.options.selectors.stock_message, this.$container),
				$carousel: $(this.options.selectors.carousel, this.$container)
			};

			this.$thc_property = $('.js-thc-property', this.$container);
			this.$excise = $('.js-excise-property', this.$container);

			if (this.options.update_atc) {

				this.$container.on('variant-selector__selection-complete', function (event, variant) {
					_this44.clearAtcClasses();

					// update the input value of the Variant ID Input (which Shopify cares about)
					_this44.setIdField(variant.id);

					_this44.options.debug ? console.log('complete selection with variant', variant) : false;

					if (_this44.elements.$flavour_selector.length && !_this44.elements.$flavour_selector.val().length) {
						_this44.elements.$flavour_selector.val(variant.option2);
					}

					_this44.elements.$allergens.html(variant.allergens);
					_this44.elements.$caffeine_content.html(variant.caffeine_content);
					_this44.elements.$selling_units.html(variant.selling_units);
					_this44.elements.$upc_code.html(variant.upc);
					_this44.elements.$sku.html(variant.sku);
					_this44.elements.$ingredients.html(variant.ingredients ? variant.ingredients : 'N/A');

					var stock_message = '';

					if (variant.inventory_quantity <= 0) {
						stock_message = theme.locales.product.variant_stock_html.zero;
					} else if (variant.inventory_quantity == 1) {
						stock_message = theme.locales.product.variant_stock_html.one;
					} else if (variant.inventory_quantity > 1 && variant.inventory_quantity < 101) {
						stock_message = theme.locales.product.variant_stock_html.other;
					}

					var $stock_message = $('<span>' + stock_message + '</span>');
					$stock_message.find('.js-variant-stock-count').text(variant.inventory_quantity);

					_this44.elements.$stock_message.html($stock_message);

					if (variant.nutrition_table) {
						_this44.elements.$nutrition_table.attr('src', theme.utils.getSizedImageUrl(variant.nutrition_table, '384x')).show().next().hide();
					} else {
						_this44.elements.$nutrition_table.hide().next().show();
					}

					if (variant.available && (variant.inventory_management !== "shopify" || variant.inventory_policy === "continue" || variant.inventory_quantity > 0)) {

						_this44.$excise.val(variant.excise);
						_this44.elements.$carousel.removeClass('product-images__main-slider--out-of-stock');
						// Verifies if the THC limit has been reached
						if (_this44.thc_regulator.regulator(event, variant, theme.products.list[_this44.$container.data('product-handle')])) {
							_this44.elements.$flavour_selector.removeAttr('disabled');
							_this44.$thc_property.val(variant.thc);
							_this44.enableAtc();
						} else {
							_this44.setAtcTHCSurplus();
							_this44.disableAtc();
						}
					} else {
						_this44.setAtcOutofstock();
						_this44.disableAtc();
						_this44.elements.$carousel.addClass('product-images__main-slider--out-of-stock');
					}
				});
				this.$container.on('variant-selector__selection-illegal variant-selector__selection-incomplete', function (e) {
					_this44.options.debug ? console.log("Selection incomplete or illegal") : false;

					if (_this44.elements.$flavour_selector.length && e.type === "variant-selector__selection-incomplete") {
						_this44.elements.$flavour_selector.removeAttr('disabled');
						if (_this44.elements.$flavour_selector.val() == '') {
							_this44.setAtcIncomplete();
						}
					} else {
						_this44.setAtcIncomplete();
					}
					_this44.disableAtc();
				});
			}

			// Create the variant selector object with associated fields and selected values
			if (this.elements.$option_selectors.length > 0) {
				this.variant_selector = new VariantSelectorEngine({
					product_handle: this.$container.data('product-handle'),
					$event_root: this.$container,
					selected_values: this.elements.$option_selectors.get().reduce(function (acc, cur) {
						if (cur.checked) {
							acc[cur.getAttribute('name')] = cur.value;
						}
						return acc;
					}, {})
				});

				// Set the PDP's (Product Display Page's) radio buttons or select dropdowns as triggers for the variant selector
				this.elements.$option_selectors.each(function (index, element) {
					if (element.tagName === 'SELECT') {
						_this44.variant_selector.addTrigger($(element), 'change', element.getAttribute('name'), function () {
							return element.value;
						});
					} else {
						_this44.variant_selector.addTrigger($(element), 'change', element.getAttribute('name'), element.value);
					}
				});
			}

			// Once the cart is updated, the variant selector get updated as well
			$(document).on('cart_set', function (event, cart) {
				_this44.variant_selector.updateVariantSelector();
			});
		}

		/**
   * Enable the Add to Cart button
   * @memberof VariantSelector
   */


		_createClass(VariantSelector, [{
			key: 'enableAtc',
			value: function enableAtc() {
				this.elements.$atc_button.prop('disabled', false);
			}

			/**
    * Disable the Add to Cart button
    * @memberof VariantSelector
    */

		}, {
			key: 'disableAtc',
			value: function disableAtc() {
				this.elements.$atc_button.prop('disabled', true);
			}

			/**
    * Update the form's id field with the currently selected variant
    * @param {number} variantId - The selected variant
    * @memberof VariantSelector
    */

		}, {
			key: 'setIdField',
			value: function setIdField(variantId) {
				if (this.check_id_field) {
					this.elements.$id_field.filter(function (index, element) {
						return parseInt(element.value) === variantId;
					}).prop("checked", true);
				} else {
					this.elements.$id_field.val(variantId);
				}
			}
		}, {
			key: 'clearAtcClasses',
			value: function clearAtcClasses() {
				this.elements.$atc_button.removeClass('product-atc--incomplete--weight product-atc--incomplete--size product-atc--incomplete--flavour product-atc--outofstock product-atc--surplusthc');
			}
		}, {
			key: 'setAtcIncomplete',
			value: function setAtcIncomplete() {
				this.elements.$atc_button.addClass('product-atc--incomplete--flavour');
			}
		}, {
			key: 'setAtcOutofstock',
			value: function setAtcOutofstock() {
				this.elements.$atc_button.addClass('product-atc--outofstock');
			}
		}, {
			key: 'setAtcTHCSurplus',
			value: function setAtcTHCSurplus() {
				this.elements.$atc_button.addClass('product-atc--surplusthc');
			}
		}]);

		return VariantSelector;
	}();

	/**
  * Variant selector class holds the product and its
  * variants, determines state of the variant selector based
  * on selected options
  * @example
  * // Example construction configurations
  * let settings = {};
  * settings.product_handle = 'green-top';
  * settings.selected_values = {
  *     'color': $('.product__form-swatches:checked')
  * };
  *
  * let variant_selector = new VariantSelectorEngine(settings);
  */


	var VariantSelectorEngine = function () {

		/**
   * @constructs VariantSelectorEngine
   * @memberof VariantSelectorEngine
   * @param {Object} settings - Variant Selector settings
   * @param {string} settings.product_handle - Product handle for this variant selector
   * @param {Object.<string, string>} [settings.selected_values] - A map of option names to values {"option_name": "value", ... } to indicates preselected values
   * @param {jQuery} [settings.$event_root=$()] - Root element for triggering events
   */
		function VariantSelectorEngine(settings) {
			var _this45 = this;

			_classCallCheck(this, VariantSelectorEngine);

			this.settings = settings;
			this.product = theme.products.list[settings.product_handle];
			this.$event_root = settings.$event_root || $();
			this.debug = false;

			// Create a map of option_names to option values
			this.variant_options = this.product.options_with_values.reduce(function (acc, cur) {
				acc[cur.name] = new VariantOption(cur, _this45.$event_root);
				return acc;
			}, {});

			if (Object.keys(this.settings.selected_values).length) {
				// Pre-select default options
				Object.keys(this.settings.selected_values).forEach(function (option) {
					return _this45.variant_options[option].selected = _this45.settings.selected_values[option];
				});

				this.updateVariantSelector();
			}
		}

		/**
   * A getvalue function can be passed to dynamically determine the value of a trigger
   * @callback getOptionTriggerValue
   * @param {jQuery} $element - The DOM element triggering the option change
   * @returns {string} The selected value
   */

		/**
   * Add a trigger to select a specific value for an option
   * @param {jQuery} $element - DOM element triggering an event
   * @param {string} event - Event name
   * @param {string} name - Option name being updated
   * @param {(string|getOptionTriggerValue)} value - Can be a string or a callback function to get the value
   * @memberOf VariantSelectorEngine
   *
   * @example
   * // Some examples for different types of elements that could be
   * // used to select options
   *
   * // A simple button that sets a single value
   * variant_selector.addTrigger($('product__button-green'), 'click', 'color', 'green');
   *
   * // A set of radio buttons for a single option
   * // (for example a set of colour swatches)
   * $('product__color-swatch').each((index, element) =>
   *     variant_selector.addTrigger($(element), 'change', 'color', element.value)
   * );
   *
   * // An example where all selectors are selected and the option is determined procedurally
   * $('product__selector').each((index, element) =>
   *     variant_selector.addTrigger($(element), 'change', element.getAttribute('name'), element.value)
   * );
   *
   * // An example where instead of setting the value, a function to retrieve the value is provided.
   * // Useful for cases like dropdown boxes.
   * const $color_dropdown = $('product__color-dropdown');
   * variant_selector.addTrigger($color_dropdown, 'change', 'color', () => $color_dropdown.val());
   */


		_createClass(VariantSelectorEngine, [{
			key: 'addTrigger',
			value: function addTrigger($element, event, name, value) {
				var _this46 = this;

				// Attach the event
				String.prototype.capitalize = function () {
					return this.replace(/(?:^|\s)\S/g, function (a) {
						return a.toUpperCase();
					});
				};
				$element.on(event, function () {
					var selectValue = void 0;

					// Determine if we have the value or must call the function
					if (typeof value === 'function') {
						selectValue = value($element);
					} else {
						selectValue = value;
					}

					if ($element.hasClass('js-size-option') && $element.data('dropdownOptions').length) {
						var $flavourDropdown = $('#flavour-option');
						$flavourDropdown.empty();
						var flavourOptions = $element.data('dropdownOptions').split(',');
						$flavourDropdown.append(new Option("Select a flavour", "", true, true));
						flavourOptions.forEach(function (option) {
							var flavourOption = new Option(option.capitalize(), option);
							$flavourDropdown.append(flavourOption);
						});
					}

					_this46.updateSelection(name, selectValue);
				});
			}

			/**
    * Update the variant selector with a new value for an option and
    * trigger events
    *
    * @param {string} option_name - The name of the option being updated
    * @param {string} option_value - The new value of the updated option
    * @fires VariantSelectorEngine#selection_update
    */

		}, {
			key: 'updateSelection',
			value: function updateSelection(option_name, option_value) {
				this.debug ? console.log('updateSelection with', option_name + ':' + option_value) : false;
				this.variant_options[option_name].selected = option_value;

				this.updateVariantSelector();
			}

			/**
    * Directly set the variant selected by ID
    *
    * @param {number} variant_id - Variant Id to select
    * @example
    * // Example setting variants based on events from radio buttons
    * $variant_radios.on('change', event =>
    *     variant_selector.setVariant(parseInt(event.target.value))
    * );
    */

		}, {
			key: 'setVariant',
			value: function setVariant(variant_id) {
				var _this47 = this;

				var variant = this.product.variants.find(function (variant) {
					return variant.id === variant_id;
				});

				this.product.options_with_values.forEach(function (value, index) {
					return _this47.variant_options[value.name].selected = variant.options[index];
				});

				this.updateVariantSelector();
			}

			/**
    * Find the possible variants meeting the selected options and
    * call methods to update the variant selector appropriately
    * @fires VariantSelectorEngine#variant-selector__selection_update
    */

		}, {
			key: 'updateVariantSelector',
			value: function updateVariantSelector() {
				var _this48 = this;

				// Find the variant that matches the currently selected set of options
				var possibleVariants = this.product.variants.filter(function (variant) {
					return Object.keys(_this48.variant_options).every(function (currentValue) {
						return (
							// If there is no value selected for an option, allow all variants with the option
							_this48.variant_options[currentValue].selected === undefined || variant[_this48.variant_options[currentValue].option_index] === _this48.variant_options[currentValue].selected
						);
					});
				});

				// Filter down variants so each option value can get a list of elements associated to it
				var filterDownVariants = this.product.variants || [];
				Object.keys(this.variant_options).forEach(function (option) {
					Object.keys(_this48.variant_options[option].values).forEach(function (value_key) {
						var value = _this48.variant_options[option].values[value_key];

						if (filterDownVariants.length !== 0) {
							value.associatedVariants = filterDownVariants.filter(function (variant) {
								return variant[_this48.variant_options[option].option_index] === value.value;
							});
						} else {
							value.associatedVariants = null;
						}
					});

					// Before moving to the next option, filter down variants by the currently selected value for the option
					filterDownVariants = filterDownVariants.filter(function (variant) {
						return variant[_this48.variant_options[option].option_index] === _this48.variant_options[option].selected;
					});
				});

				// Notify all listeners of the selection update
				/**
     * Selection update, a trigger attempted to
     * change the selected options
     *
     * @event VariantSelectorEngine#variantSelector:variant-selector__selection_update
     * @property {Object[]} possibleVariants - A list of possibly selected variants. This could be 0, 1, or many variants.
     * See the selection_complete, selection_illegal, and selection_incomplete events for more information on these cases.
     * @example
     * // Do something when the variant selector is updated. See VariantSelectorEngine#selection_update
     * // for why the returned variants can be a variable number (not just 1).
     * $variantSelector.on('variant-selector__selection-update', (event, variants) =>
     *     console.log('Possible number of variants that can be selected:', variants.length)
     * );
     */
				this.$event_root.trigger('variant-selector__selection-update', possibleVariants);
				this.debug ? console.log('selection update completed, here are possible variants', possibleVariants) : false;
				if (possibleVariants.length === 1) {
					this.selectionComplete(possibleVariants[0]);
				} else if (possibleVariants.length === 0) {
					this.selectionIllegal();
				} else {
					this.selectionIncomplete(possibleVariants);
				}
			}

			/**
    * Perform events when one valid variant was detected
    *
    * @param {Object} variant - Selected variant
    * @fires VariantSelectorEngine#variant-selector__selection_complete
    */

		}, {
			key: 'selectionComplete',
			value: function selectionComplete(variant) {
				/**
     * A selection was triggered and one variant was selected.
     * The selected options correspond to a single variant.
     * The "Happy Path" scenario for variant selection.
     *
     * @event VariantSelectorEngine#variantSelector:variant-selector__selection_complete
     * @property {Object} variant - The selected variant
     * @example
     * // Do something when a single variant has been selected
     * $variantSelector.on('variant-selector__selection-complete', (event, variant) =>
     *     $atcButton.prop('disabled', !variant.available)
     * );
     *
     * // Do something when not all options have been selected
     * $variantSelector.on('variant-selector__selection-complete', (event, variant) =>
     *     // Remind the user to select a color if none were selected
     *     if(variant_selector.variant_options['color'].selected) {
     *         $product_message.empty();
     *     } else {
     *         $product_message.html('Please select a color');
     *     }
     * );
     */
				this.$event_root.trigger('variant-selector__selection-complete', variant);
			}

			/**
    * Perform events when no variant was found
    *
    * @fires VariantSelectorEngine#variant-selector__selection_illegal
    */

		}, {
			key: 'selectionIllegal',
			value: function selectionIllegal() {
				/**
     * A selection was triggered and no variants could be selected.
     * This could be a case where, for example, the selected color is
     * 'green' and size is 'small,' but no variant exists that is green
     * and small.
     *
     * @event VariantSelectorEngine#variantSelector:variant-selector__selection_illegal
     */
				this.$event_root.trigger('variant-selector__selection-illegal');
			}

			/**
    * Peform events when multiple variants meet the selection criteria
    *
    * @param {Object[]} possibleVariants - List of valid variants for the current selection
    * @fires VariantSelectorEngine#variant-selector__selection_incomplete
    */

		}, {
			key: 'selectionIncomplete',
			value: function selectionIncomplete(possibleVariants) {
				/**
     * A selection was triggered and multiple variants meet the selection criteria.
     * This would occur in scenarios where, for example, color is 'green' but no size
     * is selected (ie it is undefined). Therefore all variants that are 'green' will
     * be returned.
     *
     * @event VariantSelectorEngine#variantSelector:variant-selector__selection_incomplete
     * @property {Object[]} possibleVariants - A list of possibly selected variants
    */
				this.$event_root.trigger('variant-selector__selection-incomplete', possibleVariants);
			}
		}]);

		return VariantSelectorEngine;
	}();

	/**
  * A class to hold a product's option and associated values
  */


	var VariantOption = function () {

		/**
   * @constructs VariantOption
   * @param {Object} option - The option encapsulated by this class
   * @param {string} option.name - The name of the option
   * @param {string} option.position - The 1 indexed position of the option
   * @param {string[]} option.values - The list of values for this option
   * @param {jQuery} $event_root - The trigger origin for events
   */
		function VariantOption(option, $event_root) {
			var _this49 = this;

			_classCallCheck(this, VariantOption);

			this.name = option.name;
			this.option_index = 'option' + option.position;
			this.$event_root = $event_root;

			this.values = option.values.reduce(function (acc, cur) {
				acc[cur] = new VariantOptionElement(cur, _this49.name, _this49.$event_root);
				return acc;
			}, {});

			// Setup event delegates
			this.listeners = {

				option_updated: []
			};
			this.event_names = {
				option_updated: 'variant-selector__option-updated--' + this.name
			};
		}

		/**
   * @returns {string} The selected value for this option, can be undefined for no selection
   */


		_createClass(VariantOption, [{
			key: 'addValueEventListener',


			/**
    * Add an event to listen to a specific value
    * @param {string} event_name - Event name
    * @param {string} value - Value to listen on
    * @param {function} listener - Function to call when the event is triggered
    * @listens VariantOptionElement#selected
    * @listens VariantOptionElement#deselect
    * @listens VariantOptionElement#activated
    * @listens VariantOptionElement#deactivated
    * @listens VariantOptionElement#variantsUpdated
    */
			value: function addValueEventListener(event_name, value, listener) {
				var option_value = this.values[value];

				if (option_value) {
					option_value.addEventListener(event_name, listener);
				}
			}
		}, {
			key: 'selected',
			get: function get() {
				if (this._selected) {
					return this._selected.value;
				} else {
					return undefined;
				}
			}

			/**
    * Set the selected value for this option, pass a falsy value to
    * unselect the value for this option
    *
    * @param {string} value - Selected value
    * @fires VariantOption#option_updated
    */
			,
			set: function set(value) {
				if (this._selected) {
					this._selected.deselect();
				}

				if (value) {
					this._selected = this.values[value];
					this._selected.select();
				} else {
					this._selected = undefined;
				}

				/**
     * A value has been selected for this option.
     * The name of the event is 'variant-selector__option_updated--OPTION_NAME', where
     * 'OPTION_NAME' is the option to listen to.
     * @event VariantOption#variantSelector:variant-selector__option_updated
     * @property {string} value - The newly selected value
     * @example
     * // Perform an update when a specific color option is updated
     * $variantSelector.on('variant-selector__option_updated--color', (event, value) => $color_message.html('Selected Color: ' + value));
     */
				this.$event_root.trigger(this.event_names.option_updated, value);
			}
		}]);

		return VariantOption;
	}();

	/**
  * A class to hold a value for an option
  */


	var VariantOptionElement = function () {

		/**
   * @constructs VariantOptionElement
   * @param {string} value - Value name of this value
   * @param {jQuery} $event_root - Origin element for triggering events
   */
		function VariantOptionElement(value, option_name, $event_root) {
			_classCallCheck(this, VariantOptionElement);

			this.value = value;
			this.$event_root = $event_root;

			this._associated_variants = null;
			var event_suffix = '--' + option_name + '--' + value;

			this.event_names = {
				selected: 'variant-selector__selected' + event_suffix,
				deselect: 'variant-selector__deselect' + event_suffix,
				activated: 'variant-selector__activated' + event_suffix,
				deactivated: 'variant-selector__deactivated' + event_suffix,
				variants_updated: 'variant-selector__variants-updated' + event_suffix
			};
		}

		/**
   * Associate a list of variants for this value of an option
   * If the list is empty then deactivate the value
   *
   * @param {Variant[]} variants - A list of possibly valid variants
   * @fires VariantOptionElement#variant-selector__variants-updated
   */


		_createClass(VariantOptionElement, [{
			key: 'deselect',


			/**
    * Notify listeners that this value is no longer selected
    * @fires VariantOptionElement#variant-selector__deselect
    */
			value: function deselect() {
				/**
     * This value has been deselected.
     * The name of the event is 'variant-selector__deselect--OPTION_NAME--OPTION_VALUE', where
     * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
     * @event VariantOptionElement#variantSelector:variant-selector__deselect
     */
				this.$event_root.trigger(this.event_names.deselect);
			}

			/**
    * Notify listeners that this value has been selected
    * @fires VariantOptionElement#selected
    */

		}, {
			key: 'select',
			value: function select() {
				/**
     * This value has been selected
     * The name of the event is 'variant-selector__selected--OPTION_NAME--OPTION_VALUE', where
     * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
     *
     * @event VariantOptionElement#variantSelector:variant-selector__selected
     * @example
     * // Show and hide an element when green selected
     * $variantSelector.on('variant-selector__selected--color--green', () =>
     *     $green_badge.show()
     * );
     * $variantSelector.on('variant-selector__deselect--color--green', () =>
     *     $green_badge.hide()
     * );
     */
				this.$event_root.trigger(this.event_names.selected);
			}

			/**
    * Notify listeners that this value has been deactivated
    * since there are no possible variants that could be selected
    * @fires VariantOptionElement#variant-selector__deactivated
    */

		}, {
			key: 'deactivate',
			value: function deactivate() {
				/**
     * This value cannot be used to select variants because
     * none exist.
     * The name of the event is 'variant-selector__deactivated--OPTION_NAME--OPTION_VALUE', where
     * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
     *
     * @event VariantOptionElement#variantSelector:variant-selector__deactivated
     */
				this.$event_root.trigger(this.event_names.deactivated);
			}

			/**
    * Notify listeners that this value has been activated
    * and variants can be selected for
    * @fires VariantOptionElement#variant-selector__activated
    */

		}, {
			key: 'activate',
			value: function activate() {
				/**
     * This value can be used to select variants.
     * The name of the event is 'variant-selector__activated--OPTION_NAME--OPTION_VALUE', where
     * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
     *
     * @event VariantOptionElement#variantSelector:variant-selector__activated
     * @example
     * // An example where we procedurally set selectors to be enabled/disabled
     * $('product__selector').each((index, element) => {
     *     let $element = $(element);
     *     $variantSelector.on(`variant-selector__activated--${element.getAttribute('name')}--${element.value}` () =>
     *         $element.removeClass('disabled')
     *     );
     *     $variantSelector.on(`variant-selector__deactivated--${element.getAttribute('name')}--${element.value}`, () =>
     *         $element.addClass('disabled')
     *     );
     * });
     */
				this.$event_root.trigger(this.event_names.activated);
			}
		}, {
			key: 'associatedVariants',
			set: function set(variants) {
				if (variants === []) {
					this.deactivate();
				} else {
					this.activate();
				}

				this._associated_variants = variants;

				/**
     * A list of variants has been associated to this value.
     * The name of the event is 'variant-selector__variants-updated--OPTION_NAME--OPTION_VALUE', where
     * 'OPTION_NAME' is the option's name and 'OPTION_VALUE' is the respective value to listen to.
     * @event VariantOptionElement#variantSelector:variant-selector__variants-updated
     * @property {Variant[]} variants - Variants that could be selected
     * @example
     * // An example where we use variantsUpdated to set stock values for option selectors
     * // to for example show them in a tooltip
     * $('product__selector-size').each((index, element) => {
     *     let $element = $(element);
     *     $variantSelector.on('variant-selector__variants-updated--size--' + element.value, (event, variants) => {
     *         // Variants.length should be 0 or 1 since in this example 'size'
     *         // is the last option
     *         if (variants.length > 0) {
     *             $element.data('stock', variants[0].inventory_quantity);
     *         }
     *     });
     * });
     */
				this.$event_root.trigger(this.event_names.variants_updated, variants);
			},
			get: function get() {
				return this._associated_variants;
			}
		}]);

		return VariantOptionElement;
	}();

	theme.variantSelector = VariantSelector;

	// Initialize variant selectors on the page.
	$(function () {
		theme.product_vs = $('.js-product-container').get().reduce(function (acc, element) {
			var $element = $(element);
			acc[$element.data('product-handle')] = new VariantSelector($element);

			return acc;
		}, {});

		var $slider = $('.js-product-images-slider');
		var $sliderImages = $('.js-product-image');

		if ($sliderImages.length > 1) {
			$slider.on('init', function () {
				$slider.parent().addClass('product-slider-initialized');
			}).slick({
				dots: true,
				arrows: true,
				prevArrow: '<a class="arrow-left"><span uk-icon="chevron-left"></span></a>',
				nextArrow: '<a class="arrow-right"><span uk-icon="chevron-right"></span></a>',
				appendDots: $('.js-main-slider-dots'),
				appendArrows: $('.js-main-slider-dots'),
				infinite: true,
				responsive: [{
					breakpoint: 640,
					settings: {
						arrows: true,
						prevArrow: '<a class="arrow-left"><span uk-icon="chevron-left"></span></a>',
						nextArrow: '<a class="arrow-right"><span uk-icon="chevron-right"></span></a>',
						appendArrows: $('.js-product-images-slider')
					}
				}]
			});
		}

		var $detailsSlider = $('.js-details-slider');
		var $toggleButton = $('.js-details-toggle', $detailsSlider);

		$toggleButton.on('click', function () {
			$detailsSlider.toggleClass('show-details');
		});

		var $disclaimer = $('.js-product-disclaimer');
		$('.js-shake-disclaimer').on('click', function () {
			$disclaimer.addClass('shake');

			setTimeout(function () {
				$disclaimer.removeClass('shake');
			}, 1000);
		});
	});
})(window.theme = window.theme || {}, jQuery);

// ------------------------------
// PARTIALS
// ------------------------------
/**
 * Script to unfocus elements on click,
 * while maintaining keyboard focus states.
 */

(function ($) {
	function initialize() {
		var $unfocus = $('.js-unfocus');

		$unfocus.on('click', function (e) {
			$(e.target).blur();
		});
	}

	// Document ready
	$(function () {
		initialize();
	});

	// Section update
	$(document).on('shopify:section:load', function () {
		initialize();
	});
})(jQuery);
(function ($) {
	/**
  * Function that can be used to hide the unhovered state animation on pageload
  */
	$('.js-animation-preload').each(function () {
		var $this = $(this);
		var timeout = $(this).data('preload-timeout');

		if (Math.floor(timeout) != timeout || !$.isNumeric(timeout) || timeout < 0) {
			console.warn('_animation.js: Value of \'data-preload-timeout\' is invalid or undefined.');
			return;
		}
		setTimeout(function () {
			$this.removeAttr('data-preload-timeout');
			$this.removeData('preload-timeout');
			$this.removeClass('js-animation-preload');
		}, timeout);
	});
})(jQuery);
(function ($) {
	var $window = $(window);
	var $register_password = $('#register_password');
	var $confirm_password = $('#confirm_password');

	function enableAccountToggles() {
		$('.account .js-toggle').each(function () {
			var breakpoint = $(this).data('toggle-breakpoint');
			var $content = $(this).next('.js-content');

			this.enabled = breakpoint && ($window.width() <= breakpoint.max || $window.width() > breakpoint.min) || !breakpoint;

			if (this.enabled && $content.is(':visible')) {
				$(this).addClass('active');
				$content.addClass('expanded');
			} else if (!this.enabled) {
				$(this).removeClass('active');
				$content.removeClass('collapsed');
				$content.show();
			}
		});
	}

	// Initialize toggles and content viibility
	enableAccountToggles();

	// Toggle content on click or keyboard (Enter/Space)
	$('.account .js-toggle').on('click keydown', function (e) {
		if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
		if (e.type === 'keydown') e.preventDefault();
		var $content = $(this).next('.js-content');
		if (this.enabled) {
			var enabled = theme.utils.toggleContent($content);
			if (enabled) {
				$(this).addClass('active').attr('aria-expanded', 'true');
			} else {
				$(this).removeClass('active').attr('aria-expanded', 'false');
			}
		}
	});

	// Match passwords
	$('#create_customer').on('submit', function (e) {
		if ($register_password.val() !== $confirm_password.val()) {
			e.preventDefault();

			$confirm_password.add($register_password).addClass('has-error');

			if (!$('#password-match-error').length) {
				$confirm_password.after('<p id="password-match-error" class="error">Passwords do not match</p>');
			}
		}
	});

	// Refresh content on window resize
	$window.resize(function () {
		enableAccountToggles();
	});
})(jQuery);

(function ($) {
	// Enable register submit button on consent
	$('.js-register-consent').change(function () {
		var $submit = $(this).closest('form').find('[type=submit]');
		$submit.prop('disabled', !!$('.js-register-consent').not(':checked').length);
	});
})(jQuery);

// Password reset
(function ($) {
	var $pw_reset_default = $('#pw_reset_default');
	var $pw_reset_success = $('#pw_reset_success');
	var $pw_reset_error = $('#pw_reset_error');

	$('.account__form--modal#reset_password form').on('submit', function (e) {
		e.preventDefault();

		var url = $(this).attr('action');
		var data = $(this).serialize();

		$.ajax({
			url: url,
			type: 'post',
			data: data,
			success: function success() {
				$pw_reset_default.addClass('hidden');
				$pw_reset_success.removeClass('hidden');
				$pw_reset_error.addClass('hidden');
			},
			error: function error() {
				$pw_reset_default.addClass('hidden');
				$pw_reset_success.addClass('hidden');
				$pw_reset_error.removeClass('hidden');
			}
		});
	});
})(jQuery);
(function ($) {
	// Increment & Decrement

	$(document).on('click', '.js-qty-inc, .js-qty-dec', $.debounce(500, function (e) {
		e.preventDefault();
		setCartQuantity($(this));
	}));

	function setCartQuantity($btn) {
		var $input = $btn.closest('.js-cart-item').find('.js-cart-qty');
		var value = parseInt($input.val());
		var new_value = void 0;
		var min = parseInt($input.attr('min'));
		var max = parseInt($input.attr('max'));

		if ($btn.hasClass('js-qty-inc')) {
			// Increment
			new_value = value < max ? ++value : max || ++value;
		} else {
			// Decrement
			new_value = value > (min || 0) ? --value : min || 0;
		}

		$input.val(new_value).change();
	}
})(jQuery);
// Floating labels
(function ($) {
	function floatLabels() {
		var $label = $(this).closest('label');
		if ($(this).val() != '' && $(this).val() != null) {
			$label.addClass('has-content');
		} else {
			$label.removeClass('has-content');
		}
	}

	$('.text-input input, .text-input--special input, .textarea textarea, .select select').each(floatLabels);
	$('.text-input input, .text-input--special input, .textarea textarea, .select select').on('blur change', floatLabels);
})(jQuery);

// Search
(function ($) {
	$('.search-box').on('keyup', $.throttle(1000, function () {
		var $submit = $(this).closest('.nav-menu__links--tools').find('.js-search-submit');
		if ($(this).val() != "") {
			$(this).addClass('has-content');
			if ($submit.length) $submit.addClass('is-searchable');
		} else {
			$(this).removeClass('has-content');
			if ($submit.length) $submit.removeClass('is-searchable');
		}
	}));

	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	if (isIE11) {
		var $search_submit = $('.js-search-submit');
		$search_submit.on('click', function () {
			$('#' + $search_submit.attr('form')).submit();
		});
	}
})(jQuery);

(function ($) {
	// Regular slide down effect for submenus
	function toggleContent(trigger) {
		var $parent = $(trigger).parent('.js-expand');
		var $content = $(trigger).next('.js-expand-content');

		if ($(window).width() <= theme.bp.md) {
			if ($parent.hasClass('expanded')) {
				$parent.removeClass('expanded');
				$content.slideUp();
				$(trigger).attr('aria-expanded', 'false');
				$content.attr('aria-hidden', 'true');
			} else {
				$parent.addClass('expanded');
				$content.slideDown();
				$(trigger).attr('aria-expanded', 'true');
				$content.attr('aria-hidden', 'false');
			}
		}
	}

	// Workaround for submenus with 2 columns, this function will create a smooth slide down effect without displacing the items in the columns
	function toggleContentSpecial(trigger) {
		var $parent = $(trigger).parent('.js-expand-special');
		var $content = $(trigger).next('.js-expand-special-content');

		if (!trigger.init) {
			trigger.init = true;
			trigger.settings = {
				collapsed: $parent.outerHeight(),
				expanded: $parent.outerHeight() + $content.outerHeight()
			};
			$parent.css('height', trigger.settings.collapsed);
		}

		if ($parent.hasClass('expanded')) {
			$parent.removeClass('expanded');
			$parent.outerHeight(trigger.settings.collapsed);
			$(trigger).attr('aria-expanded', 'false');
		} else {
			$parent.addClass('expanded');
			$parent.outerHeight(trigger.settings.expanded);
			$(trigger).attr('aria-expanded', 'true');
		}
	}

	function toggleSubmenus() {
		$('.js-flyout.flyout .js-expand-trigger').on('click keypress', function () {
			toggleContent(this);
			return false;
		});

		$('.js-flyout.flyout .js-expand-special-trigger').on('click keypress', function () {
			toggleContentSpecial(this);
			return false;
		});
	}

	function refreshSubmenuListener() {
		$('.js-flyout.flyout .js-expand-trigger').off();
		$('.js-flyout.flyout .js-expand-special-trigger').off();
		toggleSubmenus();

		if ($(window).width() > theme.bp.md) {
			$('.js-flyout .js-expand-content').attr('style', '').removeAttr('aria-hidden');
			$('.js-expand-trigger, .js-expand-special-trigger').attr('aria-expanded', 'false');
			$('.js-expand').removeClass('expanded').blur();
		} else {
			// On mobile, hide all collapsed submenus from AT
			$('.js-expand:not(.expanded) .js-expand-content').attr('aria-hidden', 'true');
		}
	}

	var SidebarItem = function () {
		function SidebarItem(container, manager) {
			var _this50 = this;

			_classCallCheck(this, SidebarItem);

			this.$container = $(container);
			this.$trigger = $('.js-expand-sidebar-trigger', this.$container);
			this.manager = manager;

			this.$trigger.on('click mouseover keypress', function (e) {
				if (e.type == 'click' || e.type == 'mouseover' || e.key === 'Enter') {
					_this50.manager.clearAll();
					_this50.$container.parent().addClass('sidebar-open');
					_this50.$container.addClass('active');
					if (_this50.$trigger.next().outerHeight() > _this50.$container.parent().outerHeight()) {
						_this50.$container.parent().css('height', _this50.$trigger.next().outerHeight());
					}
				}
			});
		}

		_createClass(SidebarItem, [{
			key: 'clear',
			value: function clear() {
				this.$container.removeClass('active');
				this.$container.parent().css('height', 'auto').removeClass('sidebar-open');
			}
		}]);

		return SidebarItem;
	}();

	var SidebarToggle = function () {
		function SidebarToggle($container) {
			var _this51 = this;

			_classCallCheck(this, SidebarToggle);

			this.sidebarItems = $('.js-expand-sidebar', $container).get().map(function (element) {
				return new SidebarItem(element, _this51);
			});

			$container.closest('.js-expand-sidebar-closeall').on('mouseleave', function () {
				_this51.clearAll();
			});
		}

		_createClass(SidebarToggle, [{
			key: 'clearAll',
			value: function clearAll() {
				this.sidebarItems.forEach(function (element) {
					return element.clear();
				});
			}
		}]);

		return SidebarToggle;
	}();

	// Initialise aria-hidden on all submenu content at page load


	if ($(window).width() <= theme.bp.md) {
		$('.js-expand-content').attr('aria-hidden', 'true');
	}

	$(window).on('resize', $.debounce(250, refreshSubmenuListener));

	// Escape key closes open desktop submenus and returns focus to the trigger
	$(document).on('keydown', function (e) {
		if (e.key !== 'Escape') return;
		var $open = $('.menu__item.has-submenu.expanded');
		if ($open.length && $(window).width() > theme.bp.md) {
			$open.removeClass('expanded');
			$open.find('.js-expand-trigger').first().attr('aria-expanded', 'false').focus();
		}
	});

	toggleSubmenus();

	// Desktop: update aria-expanded via focusin/focusout on the submenu containers
	$('.menu__item.has-submenu').each(function () {
		var $item = $(this);
		var $trigger = $item.find('.js-expand-trigger').first();

		$item.on('focusin', function () {
			if ($(window).width() > theme.bp.md) {
				$trigger.attr('aria-expanded', 'true');
			}
		}).on('focusout', function (e) {
			if ($(window).width() > theme.bp.md && !$item[0].contains(e.relatedTarget)) {
				$trigger.attr('aria-expanded', 'false');
			}
		});
	});

	$('.js-expand-sidebar-group').each(function (index, value) {
		return new SidebarToggle($(value));
	});
})(jQuery);
$(function () {
	function syncSlickInert($carousel) {
		$carousel.find('.slick-slide').each(function () {
			if ($(this).hasClass('slick-active')) {
				$(this).removeAttr('inert');
			} else {
				$(this).attr('inert', '');
			}
		});
	}

	/* Initializes a slick carousel */
	$('.featured-collection__products').each(function () {
		var $carousel = $(this);

		// accessibility: false disables Slick's own tabindex/aria-hidden management.
		// We manage inert on non-active slides instead to keep hidden slides out of
		// the tab order without Slick's broken ADA loop re-enabling them.
		// init must be bound before .slick() so it fires on initialization.
		$carousel.on('init afterChange', function () {
			syncSlickInert($carousel);
		}).slick({
			accessibility: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			dots: false,
			speed: 300,
			arrows: true,
			infinite: true,
			centerMode: false,
			prevArrow: '<button type="button" class="arrow-left" aria-label="Previous"><span uk-icon="chevron-left" aria-hidden="true"></span></button>',
			nextArrow: '<button type="button" class="arrow-right" aria-label="Next"><span uk-icon="chevron-right" aria-hidden="true"></span></button>',
			responsive: [{
				breakpoint: theme.bp.sm,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 300,
					arrows: true,
					centerMode: true,
					centerPadding: '20%'
				}
			}]
		});
	});
});

$(function () {
	/* Slick needs no get Reinitialized on window Resize after it was destroyed */
	$(window).on('load resize orientationchange', function () {

		/*  Brand Slider init
  */
		$('.suppliers__brands').each(function () {
			var $carousel = $(this);
			/* Initializes a slick carousel */
			if ($(window).width() > theme.bp.sm) {
				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.on('init reInit afterChange', function (e, slick) {
						if (slick.slideCount > 4) {
							$carousel.find('.slick-slide').removeClass('slick-transparent');
							var $centerSlide = $carousel.find('.slick-center');
							var $leftOffCanvasSlide = $centerSlide.prev().prev().prev();
							var $rightOffCanvasSlide = $centerSlide.next().next();

							$leftOffCanvasSlide.addClass('slick-transparent');
							$leftOffCanvasSlide.prev().addClass('slick-transparent');
							$rightOffCanvasSlide.addClass('slick-transparent');
							$rightOffCanvasSlide.next().addClass('slick-transparent');
						}
					}).slick({
						slidesToShow: 4,
						slidesToScroll: 1,
						dots: false,
						speed: 300,
						arrows: true,
						infinite: true,
						centerMode: true,
						focusOnSelect: true,
						prevArrow: '<button type="button" class="arrow-left" aria-label="Previous"><span uk-icon="chevron-left" aria-hidden="true"></span></button>',
						nextArrow: '<button type="button" class="arrow-right" aria-label="Next"><span uk-icon="chevron-right" aria-hidden="true"></span></button>',
						centerPadding: $carousel.find('.brand').outerWidth(true) / 2
					});

					var brand_width = $carousel.find('.brand').width() / 2 + 'px';
					$carousel.find('.slick-list').css('padding', '0 ' + brand_width);
				}
			} else {
				if ($carousel.hasClass('slick-initialized')) {
					$carousel.slick('unslick');
				}
			}
		});

		/*  Modal Brand Detail Slider
  */
		$('.modal--supplier__brands').each(function () {
			var $carousel = $(this);
			/* Initializes a slick carousel */
			if (!$carousel.hasClass('slick-initialized')) {
				$carousel.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
					speed: 300,
					arrows: true,
					infinite: true,
					centerMode: true,
					centerPadding: 0,
					prevArrow: '<button type="button" class="arrow-left" aria-label="Previous"><span uk-icon="chevron-left" aria-hidden="true"></span></button>',
					nextArrow: '<button type="button" class="arrow-right" aria-label="Next"><span uk-icon="chevron-right" aria-hidden="true"></span></button>'
				});
			}
		});

		/*  Go to appropriate logo when opening modal
  */
		$(function () {
			$(document).on('click', '.suppliers .js-modal-cta', function (e) {
				var modalSelector = $(this).attr('href');
				var slick_index = $(this).data('slick-index'); // The current index
				var brand_index = $(this).data('brand-index'); // Alternative index

				// When the window size is too small, slick.js gets removed from the brand listing.
				// Since 'modalSelector' depends on receiving the 'slick-index' for the modal, I provided
				// an alternative index when slick is not initialized.
				var currentIndex = slick_index ? slick_index : brand_index;
				$(modalSelector).find('.modal--supplier__brands').slick('slickGoTo', currentIndex, true);
			});
		});
	});

	$('.js-supplier-brand-images').each(function () {
		var $slider = $(this);
		var as_nav_for = $slider.data('asnavfor');

		$slider.slick({
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '33.33%',
			asNavFor: as_nav_for,
			infinite: true,
			dots: false,
			speed: 300,
			arrows: true,
			focusOnSelect: true,
			prevArrow: '<button type="button" class="arrow-left" aria-label="Previous"><span uk-icon="chevron-left" aria-hidden="true"></span></button>',
			nextArrow: '<button type="button" class="arrow-right" aria-label="Next"><span uk-icon="chevron-right" aria-hidden="true"></span></button>',
			responsive: [{
				breakpoint: theme.bp.sm,
				settings: {
					slidesToShow: 1,
					centerPadding: '0px'
				}
			}]
		});
	});

	$('.js-supplier-brand-descriptions').each(function () {
		var $slider = $(this);
		var as_nav_for = $slider.data('asnavfor');
		$slider.slick({
			slidesToShow: 1,
			asNavFor: as_nav_for,
			fade: true,
			infinite: true,
			dots: false,
			speed: 300,
			arrows: false
		});
	});
});
(function ($) {
	var count = $('.usage-slick__tile').length;
	var slidesToShow = Math.min(count, 3);
	// centerMode adds padding that peeks at adjacent slides — only useful when there are
	// more slides than shown (4+). With 1-3 tiles it clips the outermost slides.
	var centerMode = count > 3;
	var infinite = count > 3;

	$('.usage-slick').slick({
		slidesToShow: slidesToShow,
		slidesToScroll: 1,
		dots: false,
		infinite: infinite,
		autoplay: 0,
		centerMode: centerMode,
		variableWidth: false,
		draggable: false,
		prevArrow: '<button type="button" class="arrow-left" aria-label="Previous"><span uk-icon="chevron-left" aria-hidden="true"></span></button>',
		nextArrow: '<button type="button" class="arrow-right" aria-label="Next"><span uk-icon="chevron-right" aria-hidden="true"></span></button>',
		responsive: [{
			breakpoint: 996,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				infinite: true,
				autoplay: 0,
				pauseOnHover: false,
				centerMode: false,
				variableWidth: false,
				draggable: true,
				prevArrow: '<button type="button" class="arrow-left" aria-label="Previous"><span uk-icon="chevron-left" aria-hidden="true"></span></button>',
				nextArrow: '<button type="button" class="arrow-right" aria-label="Next"><span uk-icon="chevron-right" aria-hidden="true"></span></button>'
			}
		}]
	});
})(jQuery);

//=require partials/footer.js
(function (theme, $) {
	var WishList = function () {
		function WishList() {
			_classCallCheck(this, WishList);

			this.wishlist = null;
			this.session = null;
			this.id = null;
			this.selected_variants = [];
			this.$containers = $('.js-gift-reggie-wishlist-button');
			this.clicked_text = theme.locales.product.wishlist.view;
			this.unclicked_text = theme.locales.product.wishlist.add;
			this.$wishlist_container = $('body').find('.wishlist-notication');
			this.$button_template = $('<button class="a js-wishlist-button wishlist__button">' + this.unclicked_text + '</button>');
			this.$product_container = null;
			this.variant_selectors = $('.js-wishlish-variant-button');

			this.initializeSession();
		}

		// ------------------------------
		//  Methods
		// ------------------------------

		_createClass(WishList, [{
			key: 'initializeSession',
			value: function initializeSession() {
				var _this52 = this;

				var customer = theme.customer;
				var variant_ids = [];
				var gift_reggie_connection = null;

				if (customer && this.$containers.length) {
					gift_reggie_connection = GiftReggie.getSession(customer.id, customer.email, customer.gift_reggie.shared_secret);

					gift_reggie_connection.then(function (session) {
						_this52.setSession = session;

						_this52.get().then(function (data) {
							if (theme.cart.content.attributes.wishlist === undefined) {
								_this52.wishlist = data.wishlist;
								_this52.id = data.wishlist.id;

								if (_this52.wishlist) {
									var variants = _this52.wishlist.products;

									for (var i = 0; i < variants.length; ++i) {
										variant_ids.push(variants[i].variant_id);
										_this52.selected_variants[variants[i].variant_id] = 1;
									}

									_this52.pushToCart(variant_ids);
								}
							} else {
								var _variant_ids = JSON.parse(theme.cart.content.attributes.wishlist);
								for (var _i = 0; _i < _variant_ids.length; ++_i) {
									_this52.selected_variants[_variant_ids[_i]] = 1;
								}
							}
						}).always(function () {
							_this52.generateUserInterface();
						});
					});
				}
			}
		}, {
			key: 'generateUserInterface',
			value: function generateUserInterface() {
				var $wishlist_buttons = $('.js-gift-reggie-wishlist-button');
				var _this = this;

				$wishlist_buttons.each(function (i, value) {
					_this.appendButton($(this));
				});
			}
		}, {
			key: 'pushToCart',
			value: function pushToCart(variant_ids) {
				return theme.cart.updateAttributes({
					wishlist_id: this.id,
					wishlist_variant_ids: variant_ids
				});
			}
		}, {
			key: 'selectedVariantId',
			value: function selectedVariantId($product_container) {
				var variant_id = $product_container.find('.js-product-form input[type=radio]:checked').val();
				return variant_id;
			}
		}, {
			key: 'toggleButton',
			value: function toggleButton($element, id) {
				var $wishlist_button = $($element.find('.js-wishlist-button'));

				if (this.selected_variants[id]) {
					$wishlist_button.addClass('js-manage-wishlist');
					$wishlist_button.text(this.clicked_text); // change the button to selected
				} else {
					$wishlist_button.removeClass('js-manage-wishlist');
					$wishlist_button.text(this.unclicked_text).attr; // unselect button
				}
			}
		}, {
			key: 'appendButton',
			value: function appendButton($element) {
				var _ = this;
				var $wishlist_buttons = this.$button_template;
				var $variant_buttons = this.variant_selectors;

				// Set the proper button text for pre-selected variant
				$wishlist_buttons.html($element.hasClass('wishlist-active') ? this.clicked_text : this.unclicked_text);

				$wishlist_buttons.appendTo($element).click(function () {
					var $this = $(this);

					_.$product_container = $this.closest('.product-variant-selector');
					var id = _.selectedVariantId(_.$product_container);

					if (id) {
						if (!_.getSession || $(this).hasClass('js-manage-wishlist')) {
							_.sendToWishListManager();
							return false;
						}

						if (!_.getWishlist) {
							_.open().done(function (data) {
								_.setWishlist = data.wishlist;
								_.add(id);
							});
						} else {
							if (!_.selected_variants[id]) {
								_.add(id);
							} else {
								_.remove(id);
							}
						}
					} else {
						_.errorMessage('Variant id could not be found.');
					}

					return false;
				});

				$variant_buttons.click(function () {
					var $this = $(this);
					var label_id = $this.prop('for');

					_.$product_container = $this.closest('.product-variant-selector');
					var id = _.$product_container.find('input[type=radio][id=' + label_id + ']').val();

					_.toggleButton(_.$product_container, id);
				});
			}
		}, {
			key: 'add',
			value: function add(id) {
				var _this53 = this;

				this.getSession.addWishlist(id).done(function () {
					_this53.selected_variants[id] = 1;
					var variant_ids = Object.keys(_this53.selected_variants);

					_this53.toggleButton(_this53.$product_container, id);
					_this53.pushToCart(variant_ids);
				}).fail(function (data) {
					_this53.listLimitError(data);
				});
			}
		}, {
			key: 'remove',
			value: function remove(id) {
				var _this54 = this;

				this.getSession.removeWishlist(id).done(function () {
					delete _this54.selected_variants[id];
					var variant_ids = Object.keys(_this54.selected_variants);

					_this54.toggleButton(_this54.$product_container, id);
					_this54.pushToCart(variant_ids);
				});
			}
		}, {
			key: 'get',
			value: function get() {
				return this.getSession.getWishlist();
			}
		}, {
			key: 'open',
			value: function open() {
				return this.getSession.openWishlist();
			}
		}, {
			key: 'errorMessage',
			value: function errorMessage(error) {
				console.error('WishList: ', error);
			}
		}, {
			key: 'listLimitError',
			value: function listLimitError(data) {
				var error_title = '<h2>' + window.theme.shop + '</h2>';
				var error_message = '<p>' + data.responseJSON.error + ' Click <a href="/apps/giftregistry/wishlist?lang=' + window.theme.shop.locale + '">here</a> to manage it.</p>';

				this.$wishlist_container.find('.wishlist-notication__text').empty().append(error_title).append(error_message);

				this.$wishlist_container.show();
			}
		}, {
			key: 'sendToWishListManager',
			value: function sendToWishListManager() {
				var sub_domain = window.theme.shop.locale.substring(0, 2);
				window.location.replace('/apps/giftregistry/wishlist?lang=' + sub_domain);
			}
		}, {
			key: 'getSession',
			get: function get() {
				return this.session;
			}
		}, {
			key: 'setSession',
			set: function set(session) {
				this.session = session;
			}
		}, {
			key: 'getWishlist',
			get: function get() {
				return this.wishlist;
			}
		}, {
			key: 'setWishlist',
			set: function set(wishlist) {
				this.wishlist = wishlist;
			}
		}]);

		return WishList;
	}();

	theme.wishlist = new WishList();

	$(document).on('click', '.js-wl-add-cart', function (e) {
		e.preventDefault();

		var form = $(this).closest('form');
		var thc = $('.js-thc-property', form).val();
		var plant_type = $(this).data('product-type');

		// Only add the product to cart if the THC regulator allows it
		if (!theme.THCRegulator.regulator(null, {
			thc: thc
		}, {
			type: plant_type
		})) {
			return false;
		}

		theme.cart.add(theme.utils.toObject($(form).serialize())).then(function () {
			$('.nav-menu__btn.btn--fit.cart').trigger('click');
		});
	});
})(window.theme = window.theme || {}, jQuery);

(function (theme, $) {

	$(document).on('submit', '.js-product-form', function (e) {
		e.preventDefault();
		var subclass = 'subclass' in this.dataset ? this.dataset.subclass : '';
		var subprod = 'subprod' in this.dataset ? this.dataset.subprod : '';

		theme.cart.add(theme.utils.toObject($(this).serialize())).then(function () {
			// Add a non taxable Bottle deposit product to products with subclass carbonated beverages or still beverages
			if (subclass.length && subclass === 'carbonated beverage' || subclass === 'still beverage') {
				if (subprod.length) {
					var data = {
						id: subprod,
						properties: {
							_is_subprod: true,
							_not_countable: true
						}
					};
					theme.cart.add(data).then(function () {
						$('.nav-menu__btn.btn--fit.cart').trigger('click');
					});
				}
			} else {
				$('.nav-menu__btn.btn--fit.cart').trigger('click');
			}
		});
	});
})(window.theme = window.theme || {}, jQuery);
$(function () {
	function resizeInput() {
		$(this).attr('size', $(this).val().length);
	}

	// Mobile functionality
	$('.nav-menu__links--tools').on('click', '.js-search-open', function (e) {
		var $tools = $(e.delegateTarget);
		$tools.addClass('search-open is-active');
	});

	$('.nav-menu__links--tools').on('click', '.js-search-close', function (e) {
		e.preventDefault();
		var $tools = $(e.delegateTarget);
		$tools.removeClass('search-open is-active');
		$('.js-search-box').val('').trigger('input');
	});

	$('.nav-menu__links--tools').on('click', '.js-search-dropdown-close', function (e) {
		e.preventDefault();
		var $tools = $(e.delegateTarget);
		$tools.removeClass('search-open is-active');
		$('.js-search-box').val('').trigger('input');
	});

	var $desktopClear = $('.search-box .js-search-clear');

	// Keep the desktop clear button out of the tab order when the dropdown is closed
	function syncDesktopClearTabindex() {
		var open = $('html').hasClass('has-search-dropdown-open');
		$desktopClear.attr('tabindex', open ? '0' : '-1').attr('aria-hidden', open ? null : 'true');
	}
	syncDesktopClearTabindex();

	// Re-sync whenever the dropdown opens or closes
	var _tabindexObserver = new MutationObserver(syncDesktopClearTabindex);
	_tabindexObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

	$('.nav-menu__links').on('click', '.js-search-clear', function (e) {
		e.preventDefault();
		$('.js-search-box').val('').trigger('input');
	});

	$('.js-search-box')
	// event handler
	.keyup(resizeInput)
	// resize on page load
	.each(resizeInput);
});

$(function () {
	var $carousel = $('.product_related_products');

	$carousel.on('init afterChange', function () {
		$carousel.find('.slick-slide').each(function () {
			if ($(this).hasClass('slick-active')) {
				$(this).removeAttr('inert');
			} else {
				$(this).attr('inert', '');
			}
		});
	}).slick({
		accessibility: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToShow: 3,
		slidesToScroll: 1,
		prevArrow: '<button type="button" class="arrow-left" aria-label="Previous"><span uk-icon="chevron-left" aria-hidden="true"></span></button>',
		nextArrow: '<button type="button" class="arrow-right" aria-label="Next"><span uk-icon="chevron-right" aria-hidden="true"></span></button>',
		responsive: [{
			breakpoint: theme.bp.sm,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 300,
				arrows: true,
				centerMode: true,
				centerPadding: '20%'
			}
		}]
	});
});
(function ($) {

	$('.faq-container__row,.faq-container__answer').hide();
	$('.faq-segment div:nth-of-type(-n+3)').show(); // Shows only the fisrt 3 questions

	// Toggles the answer of the question
	$('.js-faq-question').on('click', function () {
		var _ = $(this);
		var $faq_answer = _.closest('.faq-container__row').find('.faq-container__answer');
		var $toggle_icon = _.find('[uk-icon]');

		if ($faq_answer.is(':hidden')) {
			$faq_answer.slideDown();
			$toggle_icon.attr('uk-icon', 'minus');
			UIkit.icon($toggle_icon[0]).$emit();
		} else {
			$faq_answer.slideUp();
			$toggle_icon.attr('uk-icon', 'plus');
			UIkit.icon($toggle_icon[0]).$emit();
		}
	});

	// Toggles to show the rest of the hidden questions
	$('.js-faq-button').on('click', function () {
		var _ = $(this);
		var $faq_row = _.closest('.faq-segment').find('div:nth-of-type(n+4):not(.faq-container__button)');
		var $faq_button = _.closest('.faq-segment').find('.faq-button');
		var show_text = $faq_button.data('faq-button-open');
		var hide_text = $faq_button.data('faq-button-close');

		if ($faq_row.is(':hidden')) {
			$faq_button.text(hide_text);
			$faq_row.slideDown();
		} else {
			$faq_button.text(show_text);
			$faq_row.slideUp();
		}
	});
})(jQuery);
// Expand orders and reorder
(function (theme, $) {
	var $order_expand = $('.js-order-expand');
	var $reorder = $('.js-reorder');

	$order_expand.click(function () {
		$(this).toggleClass('active');
		$(this).closest('.account__order').find('.account__order-details').slideToggle();
	});

	$reorder.on('click', function () {
		var order_data = $(this).data('order-data');

		order_data.forEach(function (item, index) {
			var queue = theme.cart.add(item);

			if (index === order_data.length - 1) {
				queue.then(function () {
					return $('.nav-menu__btn.btn--fit.cart').trigger('click');
				});
			}
		});
	});
})(window.theme = window.theme || {}, jQuery);

// Selected tabs
(function ($) {
	var $order_tab = $('.js-tab-select');
	var $order_section = $('.js-tab');
	var class_selected = 'selected';

	// Switch content tabs
	$order_tab.click(function (e) {
		e.preventDefault();
		var $this = $(this);
		var $section = $($this.attr('href'));

		// Disable all tabs
		$order_section.add($order_tab).removeClass(class_selected);
		// Enable selected tab
		$section.add($this).addClass(class_selected);
	});
})(jQuery);
(function ($, $clamp) {
	/**
  * Use the clamp.js library to limit elements
  * with the 'js-learn-clamp' class to 3 lines
  * and add an appropriate 'Read More' link
  */
	function clampExcerpts() {
		$('.js-learn-clamp').get().forEach(function (element) {
			var url = element.dataset.url;
			var title = element.dataset.title;

			if (!element.dataset.original_text) {
				// On first run store the original text
				element.dataset.original_text = element.innerHTML;
			} else {
				// On subsequent runs restore the original text first
				element.innerHTML = element.dataset.original_text;
			}

			$clamp(element, {
				clamp: 3,
				useNativeClamp: false,
				truncationHTML: '...',
				truncationChar: ''
			});
		});
	}

	$(function () {
		$(window).on('resize orientationchange', function () {
			clampExcerpts();
		});

		clampExcerpts();
	});
})(jQuery, $clamp);
(function (theme, $) {
	/**
  * @name Multi-step form - WIP
  * @description Prototype for basic multi-step form, A PEN BY Joe Watkins PRO
  * https://codepen.io/joe-watkins/pen/XKEqQV?editors=0010
  * @dependencies jQuery, jQuery Validate
  */

	var app = {

		init: function init() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			this.cacheDOM();
			this.setupAria();
			this.nextButton();
			this.prevButton();
			this.startOver();
			this.editForm();
			this.validators = options.validators || [];
			// this.handleStepClicks();
		},

		cacheDOM: function cacheDOM() {
			if ($('.age-verification').length === 0) {
				return;
			}
			this.$formParent = $('.age-verification');
			this.$form = this.$formParent.find('form');
			this.$formStepParents = this.$form.find('[role="group"]'), this.$nextButton = this.$form.find('.btn-next');
			this.$prevButton = this.$form.find('.btn-prev');
			this.$editButton = this.$form.find('.btn-edit');
			this.$resetButton = this.$form.find('[type="reset"]');

			this.$stepsParent = $('[role="group"]');
			this.$steps = this.$stepsParent.find('button');
		},

		htmlClasses: {
			activeClass: 'active',
			hiddenClass: 'hidden',
			visibleClass: 'visible',
			editFormClass: 'edit-form',
			animatedVisibleClass: 'animated fadeIn',
			animatedHiddenClass: 'animated fadeOut',
			animatingClass: 'animating'
		},

		setupAria: function setupAria() {

			// set first parent to visible
			this.$formStepParents.eq(0).attr('aria-hidden', false);

			// set all other parents to hidden
			this.$formStepParents.not(':first').attr('aria-hidden', true);
		},

		nextButton: function nextButton() {

			this.$nextButton.on("click", function (e) {

				e.preventDefault();

				// grab current step and next step parent
				var $this = $(this),
				    currentParent = $this.closest('[role="group"]'),
				    nextParent = currentParent.next();

				// if the form is valid hide current step
				// trigger next step
				if (app.checkForValidForm(currentParent)) {
					currentParent.removeClass(app.htmlClasses.visibleClass);
					app.showNextStep(currentParent, nextParent);
				}
			});
		},

		prevButton: function prevButton() {

			this.$prevButton.on('click', function (e) {

				e.preventDefault();

				// grab current step parent and previous parent
				var $this = $(this),
				    currentParent = $(this).closest('[role="group"]'),
				    prevParent = currentParent.prev();

				// hide current step and show previous step
				// no need to validate form here
				currentParent.removeClass(app.htmlClasses.visibleClass);
				app.showPrevStep(currentParent, prevParent);
			});
		},

		showNextStep: function showNextStep(currentParent, nextParent) {
			// hide previous parent
			currentParent.addClass(app.htmlClasses.hiddenClass).attr('aria-hidden', true);

			// show next parent
			nextParent.removeClass(app.htmlClasses.hiddenClass).addClass(app.htmlClasses.visibleClass).attr('aria-hidden', false);

			// focus first input on next parent
			nextParent.focus();

			// activate appropriate step
			app.handleState(nextParent.index());
		},

		showPrevStep: function showPrevStep(currentParent, prevParent) {

			// hide previous parent
			currentParent.addClass(app.htmlClasses.hiddenClass).attr('aria-hidden', true);

			// show next parent
			prevParent.removeClass(app.htmlClasses.hiddenClass).addClass(app.htmlClasses.visibleClass).attr('aria-hidden', false);

			// send focus to first input on next parent
			prevParent.focus();

			// activate appropriate step
			app.handleState(prevParent.index());
		},

		checkForValidForm: function checkForValidForm(currentParent) {

			if (currentParent.hasClass('age-entry')) {
				return this.validators.reduce(function (acc, validator) {
					return validator.validate() && acc;
				}, true);
			}

			// if(this.$form.valid()){
			return true;
			// }
		},

		startOver: function startOver() {

			var $parents = this.$formStepParents,
			    $firstParent = this.$formStepParents.eq(0),
			    $formParent = this.$formParent,
			    $stepsParent = this.$stepsParent;

			this.$resetButton.on('click', function (e) {

				// hide all parents - show first
				$parents.removeClass(app.htmlClasses.visibleClass).addClass(app.htmlClasses.hiddenClass).eq(0).removeClass(app.htmlClasses.hiddenClass).eq(0).addClass(app.htmlClasses.visibleClass);

				// remove edit state if present
				$formParent.removeClass(app.htmlClasses.editFormClass);

				// manage state - set to first item
				app.handleState(0);

				// reset stage for initial aria state
				app.setupAria();

				// send focus to first item
				setTimeout(function () {
					$firstParent.focus();
				}, 200);
			}); // click
		},

		reset: function reset() {
			var $parents = this.$formStepParents,
			    $firstParent = this.$formStepParents.eq(0),
			    $formParent = this.$formParent,
			    $stepsParent = this.$stepsParent;

			// hide all parents - show first
			$parents.removeClass(app.htmlClasses.visibleClass).addClass(app.htmlClasses.hiddenClass).eq(0).removeClass(app.htmlClasses.hiddenClass).eq(0).addClass(app.htmlClasses.visibleClass);

			// remove edit state if present
			$formParent.removeClass(app.htmlClasses.editFormClass);

			// manage state - set to first item
			app.handleState(0);

			// reset stage for initial aria state
			app.setupAria();

			// send focus to first item
			setTimeout(function () {
				$firstParent.focus();
			}, 200);
		},

		handleState: function handleState(step) {
			this.$steps.eq(step).prevAll().removeAttr('disabled');
			this.$steps.eq(step).addClass(app.htmlClasses.activeClass);
		},

		editForm: function editForm() {
			var $formParent = this.$formParent,
			    $formStepParents = this.$formStepParents,
			    $stepsParent = this.$stepsParent;

			this.$editButton.on('click', function () {
				$formParent.toggleClass(app.htmlClasses.editFormClass);
				$formStepParents.attr('aria-hidden', false);
				$formStepParents.eq(0).find('input').eq(0).focus();
				app.handleAriaExpanded();
			});
		},

		trapFocus: function trapFocus($container) {
			var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
			$container.on('keydown.focustrap', function (e) {
				if (e.key !== 'Tab') {
					return;
				}
				var $focusable = $container.find(FOCUSABLE).filter(':visible');
				var first = $focusable[0];
				var last = $focusable[$focusable.length - 1];
				if (e.shiftKey) {
					if (document.activeElement === first) {
						e.preventDefault();
						last.focus();
					}
				} else {
					if (document.activeElement === last) {
						e.preventDefault();
						first.focus();
					}
				}
			});
		},

		releaseFocus: function releaseFocus($container) {
			$container.off('keydown.focustrap');
		},

		handleStepClicks: function handleStepClicks() {

			var $stepTriggers = this.$steps,
			    $stepParents = this.$formStepParents;

			$stepTriggers.on('click', function (e) {

				e.preventDefault();

				var btnClickedIndex = $(this).index();

				// kill active state for items after step trigger
				$stepTriggers.nextAll().removeClass(app.htmlClasses.activeClass).attr('disabled', true);

				// activate button clicked
				$(this).addClass(app.htmlClasses.activeClass).attr('disabled', false);

				// hide all step parents
				$stepParents.removeClass(app.htmlClasses.visibleClass).addClass(app.htmlClasses.hiddenClass).attr('aria-hidden', true);

				// show step that matches index of button
				$stepParents.eq(btnClickedIndex).removeClass(app.htmlClasses.hiddenClass).addClass(app.htmlClasses.visibleClass).attr('aria-hidden', false).focus();
			});
		}

	};

	/**
  * A simple class to associate min and max attributes
  * to an input and determine if its input is a valid integer
  */

	var dateInputValidator = function () {
		function dateInputValidator($element) {
			var _this55 = this;

			_classCallCheck(this, dateInputValidator);

			this.min = parseInt($element.attr('min'));
			this.max = parseInt($element.attr('max'));
			this.$element = $element;

			this.$element.on('input', function () {
				_this55.$element.removeClass('error');
			});
		}

		/**
   * Checks if the input is a number, an integer, and
   * within the min and max bounds
   * @returns {Boolean} valid input
   */


		_createClass(dateInputValidator, [{
			key: 'valid',
			value: function valid() {
				var value = parseInt(this.$element.val());
				return Number(value) === value && value % 1 === 0 && value >= this.min && value <= this.max;
			}

			/**
    * Checks if the input is valid and toggles a 'error'
    * class accordingly
    * @returns {Boolean} valid input
    */

		}, {
			key: 'validate',
			value: function validate() {
				var valid = this.valid();
				this.$element.toggleClass('error', !valid);
				return valid;
			}
		}]);

		return dateInputValidator;
	}();

	/**
  * A simple class to validate the input on a dropdown
  */


	var dropDownValidator = function () {
		function dropDownValidator($element) {
			var _this56 = this;

			_classCallCheck(this, dropDownValidator);

			this.$element = $element;

			this.$element.on('input', function () {
				_this56.$element.removeClass('error');
			});
		}

		/**
   * Check whether the dropdown's value is valid
   * @return {Boolean} - valid input
   */


		_createClass(dropDownValidator, [{
			key: 'valid',
			value: function valid() {
				return this.$element.val() != null;
			}

			/**
    * Check if the dropdown's value is valid and
    * toggle an 'error' class accordingly
    * @returns {Boolean} - valid input
    */

		}, {
			key: 'validate',
			value: function validate() {
				var valid = this.valid();
				this.$element.toggleClass('error', !valid);
				return valid;
			}
		}]);

		return dropDownValidator;
	}();

	$(function () {
		var $age_modal = $('#modal--landing');

		// If the age modal isn't loaded please return
		if (localStorage.getItem('_remember_verification') === 'true' || Cookies.get('_verified') === 'true' || $age_modal.length === 0) {
			$age_modal.attr('aria-hidden', 'true').prop('inert', true);
			return;
		}

		$('body').addClass('show-agegate');
		$('#site-wrapper').attr('inert', '').attr('aria-hidden', 'true');
		$age_modal.focus();
		app.trapFocus($age_modal);

		var elements = {
			$day_input: $('#dob-day'),
			$month_input: $('#dob-month'),
			$year_input: $('#dob-year'),
			$dob_verify: $('.js-dob-verify', $age_modal)
		};

		var dayValidator = new dropDownValidator(elements.$day_input);
		var yearValidator = new dropDownValidator(elements.$year_input);
		var monthValidator = new dropDownValidator(elements.$month_input);

		// Returns how many days in the month
		function daysInMonth(m, y) {
			switch (m) {
				case 1:
					return y % 4 == 0 && y % 100 || y % 400 == 0 ? 29 : 28;
				case 8:case 3:case 5:case 10:
					return 30;
				default:
					return 31;
			}
		}

		// Returns if a date is valid
		function dateValid(d, m, y) {
			return !!d && (!!m || m === 0) && !!y && m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
		}

		app.init({
			validators: [dayValidator, yearValidator, monthValidator]
		});

		// Generate date on step 2
		elements.$dob_verify.on('click', function (e) {
			var input_valid = dayValidator.validate() && monthValidator.validate() && yearValidator.validate();

			if (!input_valid) {
				return false;
			}

			var dd = elements.$day_input.val();
			var mm = elements.$month_input.val();
			var yyyy = elements.$year_input.val();

			var birthdate = new Date(yyyy, mm, dd);
			var options = { year: 'numeric', month: 'long', day: 'numeric' };

			$('#dob').val(birthdate.valueOf());
			$('#dob-confirm').text(birthdate.toLocaleDateString('en-CA', options));
		});

		// Submit form, checks the current date and calculated the person's age based on the birthdate
		$('#dob-form').on('submit', function (e) {
			e.preventDefault(e);
			var birthdate_jstimestamp = parseInt($('#dob').val());
			var years_apart = new Date(new Date() - new Date(birthdate_jstimestamp)).getFullYear() - 1970;

			if (years_apart < 19 || isNaN(years_apart)) {
				// Fail
				$('#dob-error').show();
				$('#dob-error').focus();
			} else {
				// Success
				if (document.getElementById('dob-remember').checked) {
					localStorage.setItem('_remember_verification', 'true');
				}
				Cookies.set('_verified', 'true', { expires: 0.5 });
				$('#dob-success').show();
				$('#dob-success').focus();
			}

			$('#dob-form').hide();
			$('#dob-result').show();
		});

		// Enable or disable the "Submit Birthdate" cta
		elements.$month_input.add(elements.$day_input).add(elements.$year_input).on('change', function () {
			var input_valid = dayValidator.valid() && monthValidator.valid() && yearValidator.valid();
			var date_valid = dateValid(parseInt(elements.$day_input.val()), parseInt(elements.$month_input.val()), parseInt(elements.$year_input.val()));
			var is_disabled = !(input_valid && date_valid);

			elements.$dob_verify.attr('aria-disabled', is_disabled.toString());
			elements.$dob_verify.html(input_valid && date_valid ? elements.$dob_verify.data('enabled-text') : elements.$dob_verify.data('disabled-text'));
		});

		// Click on learn more about canabis
		$('[aria-controls="onboarding"]').on("click", function () {
			$("#age-verification-content").hide();
			window.location.replace("/pages/learn");
		});

		$('.js-dob-reset', $age_modal).on('click', function () {
			// Reset selects to placeholder
			elements.$day_input.prop('selectedIndex', 0);
			elements.$month_input.prop('selectedIndex', 0);
			elements.$year_input.prop('selectedIndex', 0);

			// Reset overlay text to initial placeholders
			elements.$day_input.closest('.js-dob-dropdown').find('.js-dob-dropdown-selected').text('DD');
			elements.$month_input.closest('.js-dob-dropdown').find('.js-dob-dropdown-selected').text('MM');
			elements.$year_input.closest('.js-dob-dropdown').find('.js-dob-dropdown-selected').text('YYYY');

			// Reset button to disabled state
			elements.$dob_verify.attr('aria-disabled', 'true').html(elements.$dob_verify.data('disabled-text'));

			$('#dob-error').hide();
			$('#dob-form').show();
			app.reset();
		});

		$('.js-onboarding-close', $age_modal).on('click', function () {
			$('body').removeClass('show-agegate');
			$('#site-wrapper').removeAttr('inert').removeAttr('aria-hidden');
			$age_modal.attr('aria-hidden', 'true').prop('inert', true);
			app.releaseFocus($age_modal);
		});

		// Getting the month chosen by the user on the selected input and showing it with just the name of the month on the overlay
		$('.js-dob-dropdown').on('change', function () {
			var $selected = $('option:selected', this);
			var chosen_month = $selected.data('display') ? $selected.data('display') : $selected.val();
			$(this).find('.js-dob-dropdown-selected').html(chosen_month);
		});
	});
})(window.theme = window.theme || {}, jQuery);
(function (theme, $) {
	var Tooltips = function () {
		function Tooltips() {
			var _this57 = this;

			var terms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			_classCallCheck(this, Tooltips);

			this.terms = terms;
			this._tooltips = [];

			this.update();

			// Site-wide events to update tooltips on
			$(document).on('CartFlyout_update', function () {
				_this57.update();
			});
		}

		_createClass(Tooltips, [{
			key: 'update',
			value: function update() {
				var _this58 = this;

				this.$tooltips = $('.js-tooltip');

				this.$tooltips.not('.is-loaded').each(function (index, element) {
					var $container = $(element);
					var term = $container.data('tooltip');
					// Get the definition object
					var definition = _this58.terms[term];

					// Check to make sure the tooltip has a term
					if (!!term && !!definition) {
						var tooltip = new ToolTip($container, definition.definition, _this58);
						_this58._tooltips.push(tooltip);

						$container.addClass('is-loaded');
					} else {
						// Hide the tooltip
						$container.hide().addClass('is-loaded');
					}
				});
			}

			/**
    * Close all tooltips
    */

		}, {
			key: 'closeAll',
			value: function closeAll() {
				this._tooltips.forEach(function (tooltip) {
					tooltip.close();
				});
			}
		}]);

		return Tooltips;
	}();

	/**
  * A ToolTip class encapsulates a single tooltip and
  * links it to the main tooltip manager
  * @class
  */


	var ToolTip = function () {
		function ToolTip($container, definition, manager) {
			var _this59 = this;

			_classCallCheck(this, ToolTip);

			this.manager = manager;
			this.$container = $container;

			this.$tooltip = $('<div class="tooltip">\n\t\t\t\t\t<div class="tooltip-arrow"></div>\n\t\t\t\t\t' + definition + '\n\t\t\t\t</div>');

			// Append the definition element
			this.$tooltip.appendTo(this.$container);

			this.$container.off('click.tooltip').on('click.tooltip', function () {
				var active = _this59.$container.hasClass('is-active');
				// If the tooltip is too close to the edge, move it below
				if (!active && $(window).width() - _this59.$container.offset().left < 200) {
					_this59.$tooltip.addClass('tooltip--bottom');
				}

				// If the tooltip is opening, close all other tooltips
				if (!active) {
					_this59.manager.closeAll();
				}
				_this59.$container.toggleClass('is-active');
			});
		}

		/**
   * Close this tooltip
   */


		_createClass(ToolTip, [{
			key: 'close',
			value: function close() {
				this.$container.removeClass('is-active');
			}
		}]);

		return ToolTip;
	}();

	$(function () {
		theme.tooltips = new Tooltips(theme._tooltips || {});
	});
})(window.theme = window.theme || {}, jQuery);
(function (theme, $) {
	/**
  * The CartIndicator serves to update the number of items
  * in the cart, and the total THC of the cart shown in the
  * header next to the cart button.
  */
	var CartIndicator = function () {
		function CartIndicator($container) {
			var _this60 = this;

			_classCallCheck(this, CartIndicator);

			this.$counter = $('.js-cart-count', $container);
			this.$weight = $('.js-cart-weight', $container);

			if (parseInt(this.$counter.text(), 10) > 0) {
				this.$counter.show();
			}

			$(document).on('cart_set', function (event, cart) {
				_this60.updateIndicators(cart);
			});
		}

		_createClass(CartIndicator, [{
			key: 'updateIndicators',
			value: function updateIndicators(cart) {
				this.$weight.text(Math.round(theme.THCRegulator.getTotal() * 100) / 100);
				this.toggleIndicator(cart);
				// update counter to display cart count (will not display count of products such as Bottle Deposit)
				var total_non_countables = cart.items.reduce(function (acc, curr) {
					if ('_not_countable' in curr.properties) {
						return acc + curr.quantity;
					}
					return acc;
				}, 0);
				var cart_count = cart.item_count - total_non_countables;
				this.$counter.text(cart_count);
			}
		}, {
			key: 'toggleIndicator',
			value: function toggleIndicator(cart) {
				this.$counter.toggle(cart.item_count > 0);
			}
		}]);

		return CartIndicator;
	}();

	$(function () {
		$('.js-cart-indicator').get().forEach(function (container) {
			return new CartIndicator($(container));
		});
	});
})(window.theme = window.theme || {}, jQuery);
(function ($) {
	var selectors = {
		FILTERS_TOGGLE: '.js-filters-toggle',
		SEARCH_CONTEXT_CONTAINER: '.js-search-context-container'
	};

	var $filtersToggle = $(selectors.FILTERS_TOGGLE);
	var $searchContextContainer = $(selectors.SEARCH_CONTEXT_CONTAINER);

	refreshFiltersToggleState();

	$searchContextContainer.on('Filter:toggled', refreshFiltersToggleState);

	function refreshFiltersToggleState() {
		$filtersToggle.toggleClass('is-filters-applied', !!$('.filter-active').length);
	}
})(jQuery);
(function ($) {
	var initialize = function initialize() {

		/* Initializes a slick carousel */
		var initializeSlider = function initializeSlider() {
			$carousel.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 300,
				autoplay: $autoplay,
				autoplaySpeed: $autoplay_speed,
				arrows: true,
				infinite: true,
				centerMode: false,
				dots: true,
				appendDots: $('.js-hero-slider-dots'),
				prevArrow: '<button type="button" class="arrow-left hero-slider-arrow-left" aria-label="Previous"><span uk-icon="chevron-left" aria-hidden="true"></span></button>',
				nextArrow: '<button type="button" class="arrow-right hero-slider-arrow-right" aria-label="Next"><span uk-icon="chevron-right" aria-hidden="true"></span></button>',
				responsive: [{
					breakpoint: theme.bp.sm,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: true,
						infinite: true,
						focusOnSelect: true,
						swipe: true,
						swipeToSlide: true,
						touchTreshold: 1000,
						centerMode: false,
						adaptiveHeight: false
					}
				}]
			});
		};
		var $carousel = $('.js-hero-slider');
		var $autoplay = $carousel.data('autoplay');
		var $autoplay_speed = $carousel.data('autoplay-speed');
		var number_of_slides = $('.js-hero-slide').length;
		if (number_of_slides > 1) {
			initializeSlider();
		}
	};

	// Document ready
	$(function () {
		initialize();
	});

	// Section update
	$(document).on('shopify:section:load', function () {
		initialize();
	});
})(window.jQuery);
(function ($) {
	var _interval;

	function initSlider() {
		var slideshow = document.querySelector('.custom-slideshow');
		if (!slideshow) return;

		var slides = slideshow.querySelectorAll('.custom-slide');
		var dots = slideshow.querySelectorAll('.dot-nav button[data-index]');
		var pauseBtn = slideshow.querySelector('.dot-nav__pause');
		var speed = parseInt(slideshow.getAttribute('data-autoplay-speed'), 10) || 6000;
		var current = 0;
		var paused = false;

		if (slides.length <= 1) return;

		clearInterval(_interval);

		function setFocusable(slide, focusable) {
			slide.querySelectorAll('a, button').forEach(function (el) {
				if (focusable) {
					el.removeAttribute('tabindex');
				} else {
					el.setAttribute('tabindex', '-1');
				}
			});
		}

		function showSlide(index) {
			slides.forEach(function (slide) {
				slide.classList.remove('active');
				slide.setAttribute('aria-hidden', 'true');
				setFocusable(slide, false);
			});
			dots.forEach(function (dot) {
				dot.classList.remove('active');
				dot.removeAttribute('aria-current');
			});
			slides[index].classList.add('active');
			slides[index].removeAttribute('aria-hidden');
			setFocusable(slides[index], true);
			if (dots[index]) {
				dots[index].classList.add('active');
				dots[index].setAttribute('aria-current', 'true');
			}
			var announcer = document.getElementById('slideshow-announcer');
			if (announcer) {
				var label = slides[index].getAttribute('data-label');
				announcer.textContent = label ? 'Slide ' + (index + 1) + ' of ' + slides.length + ': ' + label : 'Slide ' + (index + 1) + ' of ' + slides.length;
			}
			current = index;
		}

		function showNextSlide() {
			showSlide((current + 1) % slides.length);
		}

		dots.forEach(function (dot) {
			dot.addEventListener('click', function () {
				showSlide(parseInt(dot.getAttribute('data-index'), 10));
				if (!paused) {
					clearInterval(_interval);
					_interval = setInterval(showNextSlide, speed);
				}
			});
		});

		if (pauseBtn) {
			pauseBtn.addEventListener('click', function () {
				paused = !paused;
				if (paused) {
					clearInterval(_interval);
					pauseBtn.setAttribute('aria-label', 'Play slideshow');
					pauseBtn.setAttribute('aria-pressed', 'true');
					pauseBtn.classList.add('is-paused');
				} else {
					_interval = setInterval(showNextSlide, speed);
					pauseBtn.setAttribute('aria-label', 'Pause slideshow');
					pauseBtn.setAttribute('aria-pressed', 'false');
					pauseBtn.classList.remove('is-paused');
				}
			});
		}

		showSlide(0);
		_interval = setInterval(showNextSlide, speed);
	}

	$(function () {
		initSlider();
	});

	$(document).on('shopify:section:load', function () {
		initSlider();
	});
})(jQuery);

function toggleFAQ(el) {
	var parent = el.closest('.faq-item');
	var icon = el.querySelector('.faq-icon');
	var isOpen = parent.classList.contains('open');

	parent.classList.toggle('open');
	icon.textContent = isOpen ? '+' : '−';
}

function toggleFAQVisibility(button) {
	var section = button.closest('.faq-section');
	var faqItems = section.querySelectorAll('.faq-item');
	var willExpand = !button.classList.contains('expanded');

	faqItems.forEach(function (item, index) {
		if (index > 2) {
			item.classList.toggle('hidden', !willExpand);
		}
	});
	button.classList.toggle('expanded', willExpand);
	button.textContent = willExpand ? button.dataset.less : button.dataset.more;
}

document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll('.faq-section').forEach(function (section) {
		section.querySelectorAll('.faq-item').forEach(function (el, idx) {
			if (idx > 2) {
				el.classList.add('hidden');
			} else {
				el.classList.remove('hidden');
			}
		});
	});
});